(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Order = {}));
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	var axios$2 = {exports: {}};

	var bind$2 = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);

	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    return fn.apply(thisArg, args);
	  };
	};

	var bind$1 = bind$2; // utils is a library of generic helper functions non-specific to axios

	var toString = Object.prototype.toString;
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */

	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */


	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */


	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */


	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */


	function isFormData(val) {
	  return typeof FormData !== 'undefined' && val instanceof FormData;
	}
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */


	function isArrayBufferView(val) {
	  var result;

	  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
	  }

	  return result;
	}
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */


	function isString(val) {
	  return typeof val === 'string';
	}
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */


	function isNumber(val) {
	  return typeof val === 'number';
	}
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */


	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */


	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }

	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */


	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */


	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */


	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */


	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */


	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */


	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */


	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */


	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
	    return false;
	  }

	  return typeof window !== 'undefined' && typeof document !== 'undefined';
	}
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */


	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  } // Force an array if not already something iterable


	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }

	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */


	function
	  /* obj1, obj2, obj3, ... */
	merge() {
	  var result = {};

	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }

	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }

	  return result;
	}
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */


	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind$1(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */


	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }

	  return content;
	}

	var utils$d = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};

	var utils$c = utils$d;

	function encode(val) {
	  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	}
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */


	var buildURL$2 = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }

	  var serializedParams;

	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils$c.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	    utils$c.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }

	      if (utils$c.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }

	      utils$c.forEach(val, function parseValue(v) {
	        if (utils$c.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils$c.isObject(v)) {
	          v = JSON.stringify(v);
	        }

	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	    serializedParams = parts.join('&');
	  }

	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');

	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }

	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }

	  return url;
	};

	var utils$b = utils$d;

	function InterceptorManager$1() {
	  this.handlers = [];
	}
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */


	InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */


	InterceptorManager$1.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */


	InterceptorManager$1.prototype.forEach = function forEach(fn) {
	  utils$b.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};

	var InterceptorManager_1 = InterceptorManager$1;

	var utils$a = utils$d;

	var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
	  utils$a.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};

	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */


	var enhanceError$2 = function enhanceError(error, config, code, request, response) {
	  error.config = config;

	  if (code) {
	    error.code = code;
	  }

	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;

	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  };

	  return error;
	};

	var enhanceError$1 = enhanceError$2;
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */

	var createError$2 = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError$1(error, config, code, request, response);
	};

	var createError$1 = createError$2;
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */

	var settle$1 = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;

	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
	  }
	};

	var utils$9 = utils$d;
	var cookies$1 = utils$9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
	function standardBrowserEnv() {
	  return {
	    write: function write(name, value, expires, path, domain, secure) {
	      var cookie = [];
	      cookie.push(name + '=' + encodeURIComponent(value));

	      if (utils$9.isNumber(expires)) {
	        cookie.push('expires=' + new Date(expires).toGMTString());
	      }

	      if (utils$9.isString(path)) {
	        cookie.push('path=' + path);
	      }

	      if (utils$9.isString(domain)) {
	        cookie.push('domain=' + domain);
	      }

	      if (secure === true) {
	        cookie.push('secure');
	      }

	      document.cookie = cookie.join('; ');
	    },
	    read: function read(name) {
	      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	      return match ? decodeURIComponent(match[3]) : null;
	    },
	    remove: function remove(name) {
	      this.write(name, '', Date.now() - 86400000);
	    }
	  };
	}() : // Non standard browser env (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return {
	    write: function write() {},
	    read: function read() {
	      return null;
	    },
	    remove: function remove() {}
	  };
	}();

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */


	var isAbsoluteURL$1 = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */


	var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
	  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
	};

	var isAbsoluteURL = isAbsoluteURL$1;
	var combineURLs = combineURLs$1;
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */

	var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }

	  return requestedURL;
	};

	var utils$8 = utils$d; // Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers

	var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */

	var parseHeaders$1 = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) {
	    return parsed;
	  }

	  utils$8.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils$8.trim(line.substr(0, i)).toLowerCase();
	    val = utils$8.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }

	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	  return parsed;
	};

	var utils$7 = utils$d;
	var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
	// whether the request URL is of the same origin as current location.
	function standardBrowserEnv() {
	  var msie = /(msie|trident)/i.test(navigator.userAgent);
	  var urlParsingNode = document.createElement('a');
	  var originURL;
	  /**
	  * Parse a URL to discover it's components
	  *
	  * @param {String} url The URL to be parsed
	  * @returns {Object}
	  */

	  function resolveURL(url) {
	    var href = url;

	    if (msie) {
	      // IE needs attribute set twice to normalize properties
	      urlParsingNode.setAttribute('href', href);
	      href = urlParsingNode.href;
	    }

	    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

	    return {
	      href: urlParsingNode.href,
	      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	      host: urlParsingNode.host,
	      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	      hostname: urlParsingNode.hostname,
	      port: urlParsingNode.port,
	      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
	    };
	  }

	  originURL = resolveURL(window.location.href);
	  /**
	  * Determine if a URL shares the same origin as the current location
	  *
	  * @param {String} requestURL The URL to test
	  * @returns {boolean} True if URL shares the same origin, otherwise false
	  */

	  return function isURLSameOrigin(requestURL) {
	    var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
	    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
	  };
	}() : // Non standard browser envs (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return function isURLSameOrigin() {
	    return true;
	  };
	}();

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */


	function Cancel$3(message) {
	  this.message = message;
	}

	Cancel$3.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel$3.prototype.__CANCEL__ = true;
	var Cancel_1 = Cancel$3;

	var utils$6 = utils$d;
	var settle = settle$1;
	var cookies = cookies$1;
	var buildURL$1 = buildURL$2;
	var buildFullPath = buildFullPath$1;
	var parseHeaders = parseHeaders$1;
	var isURLSameOrigin = isURLSameOrigin$1;
	var createError = createError$2;
	var defaults$4 = defaults_1;
	var Cancel$2 = Cancel_1;

	var xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;

	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }

	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }

	    if (utils$6.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest(); // HTTP basic authentication

	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      } // Prepare the response


	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response); // Clean up request

	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        } // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request


	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        } // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'


	        setTimeout(onloadend);
	      };
	    } // Handle browser request cancellation (as opposed to a manual cancellation)


	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Handle low level network errors


	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request)); // Clean up request

	      request = null;
	    }; // Handle timeout


	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || defaults$4.transitional;

	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }

	      reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.


	    if (utils$6.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    } // Add headers to the request


	    if ('setRequestHeader' in request) {
	      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    } // Add withCredentials to request if needed


	    if (!utils$6.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    } // Add responseType to request if needed


	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    } // Handle progress if needed


	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    } // Not all browsers support upload events


	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function (cancel) {
	        if (!request) {
	          return;
	        }

	        reject(!cancel || cancel && cancel.type ? new Cancel$2('canceled') : cancel);
	        request.abort();
	        request = null;
	      };

	      config.cancelToken && config.cancelToken.subscribe(onCanceled);

	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }

	    if (!requestData) {
	      requestData = null;
	    } // Send the request


	    request.send(requestData);
	  });
	};

	var utils$5 = utils$d;
	var normalizeHeaderName = normalizeHeaderName$1;
	var enhanceError = enhanceError$2;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};

	function setContentTypeIfUnset(headers, value) {
	  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}

	function getDefaultAdapter() {
	  var adapter;

	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = xhr;
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = xhr;
	  }

	  return adapter;
	}

	function stringifySafely(rawValue, parser, encoder) {
	  if (utils$5.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils$5.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }

	  return (encoder || JSON.stringify)(rawValue);
	}

	var defaults$3 = {
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	  adapter: getDefaultAdapter(),
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');

	    if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
	      return data;
	    }

	    if (utils$5.isArrayBufferView(data)) {
	      return data.buffer;
	    }

	    if (utils$5.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }

	    if (utils$5.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }

	    return data;
	  }],
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults$3.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

	    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }

	          throw e;
	        }
	      }
	    }

	    return data;
	  }],

	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	  maxContentLength: -1,
	  maxBodyLength: -1,
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults$3.headers[method] = {};
	});
	utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
	});
	var defaults_1 = defaults$3;

	var utils$4 = utils$d;
	var defaults$2 = defaults_1;
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */

	var transformData$1 = function transformData(data, headers, fns) {
	  var context = this || defaults$2;
	  /*eslint no-param-reassign:0*/

	  utils$4.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	  return data;
	};

	var isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};

	var utils$3 = utils$d;
	var transformData = transformData$1;
	var isCancel = isCancel$1;
	var defaults$1 = defaults_1;
	var Cancel$1 = Cancel_1;
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */

	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }

	  if (config.signal && config.signal.aborted) {
	    throw new Cancel$1('canceled');
	  }
	}
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */


	var dispatchRequest$1 = function dispatchRequest(config) {
	  throwIfCancellationRequested(config); // Ensure headers exist

	  config.headers = config.headers || {}; // Transform request data

	  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

	  config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
	  utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
	    delete config.headers[method];
	  });
	  var adapter = config.adapter || defaults$1.adapter;
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config); // Transform response data

	    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config); // Transform response data

	      if (reason && reason.response) {
	        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
	      }
	    }

	    return Promise.reject(reason);
	  });
	};

	var utils$2 = utils$d;
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */

	var mergeConfig$2 = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};

	  function getMergedValue(target, source) {
	    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
	      return utils$2.merge(target, source);
	    } else if (utils$2.isPlainObject(source)) {
	      return utils$2.merge({}, source);
	    } else if (utils$2.isArray(source)) {
	      return source.slice();
	    }

	    return source;
	  } // eslint-disable-next-line consistent-return


	  function mergeDeepProperties(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils$2.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  } // eslint-disable-next-line consistent-return


	  function valueFromConfig2(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  } // eslint-disable-next-line consistent-return


	  function defaultToConfig2(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils$2.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  } // eslint-disable-next-line consistent-return


	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }

	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    utils$2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
	  });
	  return config;
	};

	var data = {
	  "version": "0.24.0"
	};

	var VERSION = data.version;
	var validators$1 = {}; // eslint-disable-next-line func-names

	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
	  validators$1[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	var deprecatedWarnings = {};
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */

	validators$1.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  } // eslint-disable-next-line func-names


	  return function (value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
	    }

	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

	      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
	    }

	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */


	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }

	  var keys = Object.keys(options);
	  var i = keys.length;

	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];

	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);

	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }

	      continue;
	    }

	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}

	var validator$1 = {
	  assertOptions: assertOptions,
	  validators: validators$1
	};

	var utils$1 = utils$d;
	var buildURL = buildURL$2;
	var InterceptorManager = InterceptorManager_1;
	var dispatchRequest = dispatchRequest$1;
	var mergeConfig$1 = mergeConfig$2;
	var validator = validator$1;
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */

	function Axios$1(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */


	Axios$1.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }

	  config = mergeConfig$1(this.defaults, config); // Set config.method

	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }

	  var transitional = config.transitional;

	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  } // filter out skipped interceptors


	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }

	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	  var promise;

	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	    promise = Promise.resolve(config);

	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }

	    return promise;
	  }

	  var newConfig = config;

	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();

	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }

	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }

	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }

	  return promise;
	};

	Axios$1.prototype.getUri = function getUri(config) {
	  config = mergeConfig$1(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	}; // Provide aliases for supported request methods


	utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios$1.prototype[method] = function (url, config) {
	    return this.request(mergeConfig$1(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios$1.prototype[method] = function (url, data, config) {
	    return this.request(mergeConfig$1(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	var Axios_1 = Axios$1;

	var Cancel = Cancel_1;
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */

	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	  var token = this; // eslint-disable-next-line func-names

	  this.promise.then(function (cancel) {
	    if (!token._listeners) return;
	    var i;
	    var l = token._listeners.length;

	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }

	    token._listeners = null;
	  }); // eslint-disable-next-line func-names

	  this.promise.then = function (onfulfilled) {
	    var _resolve; // eslint-disable-next-line func-names


	    var promise = new Promise(function (resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);

	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };

	    return promise;
	  };

	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */


	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	/**
	 * Subscribe to the cancel signal
	 */


	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }

	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	/**
	 * Unsubscribe from the cancel signal
	 */


	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }

	  var index = this._listeners.indexOf(listener);

	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */


	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	var CancelToken_1 = CancelToken;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */


	var spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */


	var isAxiosError = function isAxiosError(payload) {
	  return typeof payload === 'object' && payload.isAxiosError === true;
	};

	var utils = utils$d;
	var bind = bind$2;
	var Axios = Axios_1;
	var mergeConfig = mergeConfig$2;
	var defaults = defaults_1;
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */

	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

	  utils.extend(instance, Axios.prototype, context); // Copy context to instance

	  utils.extend(instance, context); // Factory for creating new instances

	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };

	  return instance;
	} // Create the default instance to be exported


	var axios$1 = createInstance(defaults); // Expose Axios class to allow class inheritance

	axios$1.Axios = Axios; // Expose Cancel & CancelToken

	axios$1.Cancel = Cancel_1;
	axios$1.CancelToken = CancelToken_1;
	axios$1.isCancel = isCancel$1;
	axios$1.VERSION = data.version; // Expose all/spread

	axios$1.all = function all(promises) {
	  return Promise.all(promises);
	};

	axios$1.spread = spread; // Expose isAxiosError

	axios$1.isAxiosError = isAxiosError;
	axios$2.exports = axios$1; // Allow use of default import syntax in TypeScript

	axios$2.exports.default = axios$1;

	var axios = axios$2.exports;

	var urlJoin$1 = {exports: {}};

	(function (module) {
	  (function (name, context, definition) {
	    if (module.exports) module.exports = definition();else context[name] = definition();
	  })('urljoin', commonjsGlobal, function () {
	    function normalize(strArray) {
	      var resultArray = [];

	      if (strArray.length === 0) {
	        return '';
	      }

	      if (typeof strArray[0] !== 'string') {
	        throw new TypeError('Url must be a string. Received ' + strArray[0]);
	      } // If the first part is a plain protocol, we combine it with the next part.


	      if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
	        var first = strArray.shift();
	        strArray[0] = first + strArray[0];
	      } // There must be two or three slashes in the file protocol, two slashes in anything else.


	      if (strArray[0].match(/^file:\/\/\//)) {
	        strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
	      } else {
	        strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
	      }

	      for (var i = 0; i < strArray.length; i++) {
	        var component = strArray[i];

	        if (typeof component !== 'string') {
	          throw new TypeError('Url must be a string. Received ' + component);
	        }

	        if (component === '') {
	          continue;
	        }

	        if (i > 0) {
	          // Removing the starting slashes for each component but the first.
	          component = component.replace(/^[\/]+/, '');
	        }

	        if (i < strArray.length - 1) {
	          // Removing the ending slashes for each component but the last.
	          component = component.replace(/[\/]+$/, '');
	        } else {
	          // For the last component we will combine multiple slashes to a single one.
	          component = component.replace(/[\/]+$/, '/');
	        }

	        resultArray.push(component);
	      }

	      var str = resultArray.join('/'); // Each input component is now separated by a single slash except the possible first plain protocol part.
	      // remove trailing slash before parameters or hash

	      str = str.replace(/\/(\?|&|#[^!])/g, '$1'); // replace ? in parameters with &

	      var parts = str.split('?');
	      str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
	      return str;
	    }

	    return function () {
	      var input;

	      if (typeof arguments[0] === 'object') {
	        input = arguments[0];
	      } else {
	        input = [].slice.call(arguments);
	      }

	      return normalize(input);
	    };
	  });
	})(urlJoin$1);

	var urlJoin = urlJoin$1.exports;

	var helpers = {exports: {}};

	(function (module, exports) {
	  (function (global, factory) {
	    factory(exports) ;
	  })(commonjsGlobal, function (exports) {

	    class BaseError extends Error {
	      // TODO Determine how to do this ??
	      // public get level(): LevelNumber {
	      //
	      //     return this._level;
	      //
	      // }
	      constructor(data) {
	        super();
	        this._at = new Date();
	        this._url = window && window.location && window.location.href || '';
	        this._data = data; // this._level = LevelNumber.Debug; // TODO??

	        this.message = this.toString();
	      } // TODO Determine how to do this ??
	      // protected _level: LevelNumber;


	      get at() {
	        return new Date(this._at.valueOf());
	      }

	      get data() {
	        return this._data;
	      }

	      get isOpenTicketError() {
	        return true;
	      }

	      toFlatData() {
	        const slug = this.toSlug();
	        let serializedSlugData = '';

	        try {
	          serializedSlugData = JSON.stringify(slug.data) || '';
	        } catch (_) {
	          /* No-op */
	        }

	        return { ...this.additionalFlatData(),
	          at: this.at.toISOString(),
	          // level: levelNumberToLevel[this.level], // TODO ??
	          message: this.toString(),
	          slug: this.toSlug().key,
	          slugData: serializedSlugData,
	          url: this._url
	        };
	      }

	      additionalFlatData() {
	        return {};
	      }

	    }

	    function isStringError(e) {
	      return e && e._isStringError;
	    }

	    class StringError extends BaseError {
	      constructor(slug, message) {
	        if (!slug || !slug.length) {
	          throw new Error('Expected first argument to be a non empty string.');
	        }

	        super(slug);
	        this._message = message;
	        this._isStringError = true;
	      }

	      toSlug() {
	        return {
	          key: this.data
	        };
	      }

	      toString() {
	        return this._message || this.data;
	      }

	    }

	    class UnexpectedError extends BaseError {
	      toSlug() {
	        return {
	          key: 'sdkhelpers.errors.unexpected'
	        };
	      }

	      toString() {
	        const str = 'Unexpected error';

	        if (this.data) {
	          if (this.data instanceof Error) {
	            return `${str} [${this.data.name}]: ${this.data.message}`;
	          }

	          try {
	            return `${str}: ${JSON.stringify(this.data)}`;
	          } catch (e) {
	            /* No-op */
	          }
	        }

	        return str;
	      }

	    }

	    function isFormValidationError(e) {
	      return e && e._isFormValidationError;
	    }
	    /**
	     * This error class can be used for all errors that implement the
	     * CRUD validation error interface.
	     */


	    class FormValidationError extends BaseError {
	      constructor() {
	        super(...arguments);
	        this._isFormValidationError = true;
	      }

	      toSlug() {
	        return {
	          key: this.data.slug,
	          data: this.data.data
	        }; // // This key can optionally be used to show a more specific
	        // // error message to the user. We only pass the first error
	        // // because of the translation interface requires fixed
	        // // length data. The getFieldErrors method can be used
	        // // to retrieve a complete set of errors per form field.
	        // const firstError: { key: string; error: string } | undefined = this._getFirstErrorFromFirstField();
	        //
	        // if (!firstError) {
	        //
	        //     return {
	        //         key: 'sdkhelpers.form.errors.generic_validation_error',
	        //     };
	        //
	        // }
	        //
	        // return {
	        //     key: 'sdkhelpers.form.errors.validation_error',
	        //     data: firstError,
	        // };
	      }

	      getFieldErrors(key) {
	        return FormValidationError.getFieldErrors(this.data.messages, key);
	      }

	      toString() {
	        const firstError = this._getFirstErrorFromFirstField();

	        if (!firstError) {
	          return 'Validation error';
	        }

	        return `First validation error ${firstError.key}: ${firstError.error}`;
	      }

	      additionalFlatData() {
	        const errors = {};

	        for (const key in this.data.messages) {
	          if (Object.prototype.hasOwnProperty.call(this.data, key)) {
	            continue;
	          }

	          const localErrors = this.data.messages[key];

	          if (localErrors) {
	            errors[key] = Array.isArray(localErrors) ? localErrors.join(', ') : localErrors;
	          }
	        }

	        return errors;
	      }

	      static getFieldErrors(messages, key) {
	        const errorOrErrors = messages[key];

	        if (!errorOrErrors) {
	          return undefined;
	        }

	        const errors = Array.isArray(errorOrErrors) ? errorOrErrors : [errorOrErrors];
	        return errors.map(error => ({
	          key: 'sdkhelpers.form.errors.validation_error_field',
	          data: {
	            key,
	            error
	          }
	        }));
	      }

	      _getFirstErrorFromFirstField() {
	        for (const key in this.data.messages) {
	          if (!Object.prototype.hasOwnProperty.call(this.data, key)) {
	            continue;
	          }

	          const errorOrErrors = this.data.messages[key];

	          if (!errorOrErrors) {
	            continue;
	          }

	          if (Array.isArray(errorOrErrors)) {
	            return {
	              key,
	              error: errorOrErrors[0]
	            };
	          }

	          return {
	            key,
	            error: errorOrErrors
	          };
	        }

	        return undefined;
	      }

	    }

	    class Form {
	      constructor(config) {
	        this.props = this._buildProps(config.data);
	        this.original = { ...config.data
	        };
	        this.config = config;
	      }

	      validate(mutate = false) {
	        return this._internalValidate(mutate);
	      }

	      validateProp(key, mutate = false) {
	        return this._internalValidate(mutate, key);
	      }

	      async submit() {
	        const validation = await this.validate(true);

	        if (!validation.valid) {
	          throw new FormValidationError(validation.result);
	        }

	        try {
	          const data = this.serialize();
	          const response = await this.config.submit(data, this.original);

	          this._resetErrors();

	          this._applyChanges({ ...data,
	            ...response
	          });
	        } catch (e) {
	          if (isFormValidationError(e)) {
	            // Note:
	            // Only props with data present in the error are mutated.
	            // All other prop errors are left as is.
	            this._mutateErrors(e.data.messages);

	            throw e;
	          } else if (isStringError(e)) {
	            throw e;
	          }

	          throw new UnexpectedError(e); // TODO Add possible usages of unexpected error instance to doc.
	        }
	      }

	      undo(key) {
	        this.props[key].value = this.original[key];
	      }

	      undoAll() {
	        for (const key in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
	            continue;
	          }

	          this.props[key].value = this.original[key];
	        }
	      }

	      hasLocalChanges() {
	        for (const key in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
	            continue;
	          }

	          if (this.props[key].value !== this.original[key]) {
	            return true;
	          }
	        }

	        return false;
	      }

	      serialize(key) {
	        const data = {};

	        if (key) {
	          if (this.original[key] !== this.props[key].value) {
	            data[key] = this.props[key].value;
	          }

	          return data;
	        }

	        for (const propKey in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, propKey)) {
	            continue;
	          }

	          data[propKey] = this.props[propKey].value;
	        }

	        return data;
	      }
	      /**
	       * Run validation and return results.
	       *
	       * A prop will only be validated if it is dirty.
	       *
	       * When a key is given, only that prop is checked if it is dirty.
	       * Without a key, all dirty props are checked.
	       *
	       * When mutate is true, prop errors are mutated for all checked props.
	       *
	       * @private
	       */


	      async _internalValidate(mutate = false, key) {
	        if (!this.config.validate) {
	          return {
	            valid: true
	          };
	        }

	        const data = this.serialize(key);
	        const result = await this.config.validate(data);

	        if (!result.valid && mutate) {
	          this._mutateErrors(result.result.messages, !key);
	        }

	        return result;
	      }
	      /**
	       * Mutates all given prop errors in keys.
	       *
	       * If no error is present in the validation data,
	       * it is set to an empty array.
	       *
	       * @private
	       */


	      _mutateErrors(validationData, clearAll = true) {
	        for (const key in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
	            continue;
	          }

	          if (validationData[key]) {
	            const sluggedErrors = FormValidationError.getFieldErrors(validationData, key);
	            this.props[key].errors = sluggedErrors || [];
	          } else if (clearAll && this.props[key].errors.length) {
	            this.props[key].errors = [];
	          }
	        }
	      }
	      /**
	       * Removes all errors from  props
	       *
	       * @private
	       */


	      _resetErrors() {
	        this._mutateErrors({});
	      }

	      _applyChanges(data) {
	        for (const key in data) {
	          const value = data[key];
	          this.original[key] = value;
	          this.props[key].value = value;
	        }
	      }

	      _buildProps(props) {
	        const map = {};

	        for (const key in props) {
	          if (!Object.prototype.hasOwnProperty.call(props, key)) {
	            continue;
	          }

	          map[key] = {
	            errors: [],
	            rules: [],
	            value: props[key]
	          };
	        }

	        return map;
	      }

	    }

	    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	    function commonjsRequire(path) {
	      throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
	    }

	    function leapYear$1(year) {
	      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    }

	    function checkFalsePositiveDates$1(dateString = '') {
	      if (dateString.length === 10) {
	        // massage input to use yyyy-mm-dd format
	        // we support yyyy/mm/dd or yyyy.mm.dd
	        let normalizedDate = dateString.replace('.', '-').replace('/', '-');
	        let parts = normalizedDate.split('-');

	        if (parts.length === 3) {
	          if (parts[0].length === 4) {
	            // yyyy-mm-dd format
	            let y = parseInt(parts[0]);
	            let m = parseInt(parts[1]);
	            let d = parseInt(parts[2]);

	            if (m === 2) {
	              // return leapYear(y) ? d <= 29 : d <= 28;
	              if (leapYear$1(y)) {
	                if (d > 29) {
	                  return false;
	                }
	              } else {
	                if (d > 28) {
	                  return false;
	                }
	              }
	            }

	            if (m === 4 || m === 6 || m === 9 || m === 11) {
	              if (d > 30) {
	                return false;
	              }
	            }
	          }
	        }

	        return true; // we are not in feburary, proceed
	      }

	      return true; // we are not testing formatted date, proceed to rest of validation
	    }

	    function isValidDate$1(dateString) {
	      let testDate;

	      if (typeof dateString === 'number') {
	        testDate = new Date(dateString);

	        if (typeof testDate === 'object') {
	          return true;
	        }
	      } // first convert incoming string to date object and see if it correct date and format


	      testDate = new Date(dateString);

	      if (typeof testDate === 'object') {
	        if (testDate.toString() === 'Invalid Date') {
	          return false;
	        }
	        /**
	         * Check for false positive dates
	         * perform special check on february as JS `new Date` incorrectly returns valid date
	         * Eg.  let newDate = new Date('2020-02-29')  // returns as March 02 2020
	         * Eg.  let newDate = new Date('2019-02-29')  // returns as March 01 2020
	         * Eg.  let newDate = new Date('2019-04-31')  // returns as April 30 2020
	         */


	        if (!checkFalsePositiveDates$1(dateString)) {
	          return false;
	        } // valid date object and not a february date


	        return true;
	      } // First check for the pattern


	      var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

	      if (!regex_date.test(dateString)) {
	        return false;
	      } // Parse the date parts to integers


	      var parts = dateString.split("-");
	      var day = parseInt(parts[2], 10);
	      var month = parseInt(parts[1], 10);
	      var year = parseInt(parts[0], 10); // Check the ranges of month and year

	      if (year < 1000 || year > 3000 || month == 0 || month > 12) {
	        return false;
	      }

	      var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

	      if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
	        monthLength[1] = 29;
	      } // Check the range of the day


	      return day > 0 && day <= monthLength[month - 1];
	    }

	    var rules = {
	      required: function (val) {
	        var str;

	        if (val === undefined || val === null) {
	          return false;
	        }

	        str = String(val).replace(/\s/g, "");
	        return str.length > 0 ? true : false;
	      },
	      required_if: function (val, req, attribute) {
	        req = this.getParameters();

	        if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
	          return this.validator.getRule("required").validate(val);
	        }

	        return true;
	      },
	      required_unless: function (val, req, attribute) {
	        req = this.getParameters();

	        if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
	          return this.validator.getRule("required").validate(val);
	        }

	        return true;
	      },
	      required_with: function (val, req, attribute) {
	        if (this.validator._objectPath(this.validator.input, req)) {
	          return this.validator.getRule("required").validate(val);
	        }

	        return true;
	      },
	      required_with_all: function (val, req, attribute) {
	        req = this.getParameters();

	        for (var i = 0; i < req.length; i++) {
	          if (!this.validator._objectPath(this.validator.input, req[i])) {
	            return true;
	          }
	        }

	        return this.validator.getRule("required").validate(val);
	      },
	      required_without: function (val, req, attribute) {
	        if (this.validator._objectPath(this.validator.input, req)) {
	          return true;
	        }

	        return this.validator.getRule("required").validate(val);
	      },
	      required_without_all: function (val, req, attribute) {
	        req = this.getParameters();

	        for (var i = 0; i < req.length; i++) {
	          if (this.validator._objectPath(this.validator.input, req[i])) {
	            return true;
	          }
	        }

	        return this.validator.getRule("required").validate(val);
	      },
	      boolean: function (val) {
	        return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
	      },
	      // compares the size of strings
	      // with numbers, compares the value
	      size: function (val, req, attribute) {
	        if (val) {
	          req = parseFloat(req);
	          var size = this.getSize();
	          return size === req;
	        }

	        return true;
	      },
	      string: function (val, req, attribute) {
	        return typeof val === "string";
	      },
	      sometimes: function (val) {
	        return true;
	      },

	      /**
	       * Compares the size of strings or the value of numbers if there is a truthy value
	       */
	      min: function (val, req, attribute) {
	        var size = this.getSize();
	        return size >= req;
	      },

	      /**
	       * Compares the size of strings or the value of numbers if there is a truthy value
	       */
	      max: function (val, req, attribute) {
	        var size = this.getSize();
	        return size <= req;
	      },
	      between: function (val, req, attribute) {
	        req = this.getParameters();
	        var size = this.getSize();
	        var min = parseFloat(req[0], 10);
	        var max = parseFloat(req[1], 10);
	        return size >= min && size <= max;
	      },
	      email: function (val) {
	        // Added umlaut support https://github.com/skaterdav85/validatorjs/issues/308
	        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	        if (!re.test(val)) {
	          // added support domain 3-n level https://github.com/skaterdav85/validatorjs/issues/384
	          re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
	        }

	        return re.test(val);
	      },
	      numeric: function (val) {
	        var num;
	        num = Number(val); // tries to convert value to a number. useful if value is coming from form element

	        if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
	          return true;
	        } else {
	          return false;
	        }
	      },
	      array: function (val) {
	        return val instanceof Array;
	      },
	      url: function (url) {
	        return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(url);
	      },
	      alpha: function (val) {
	        return /^[a-zA-Z]+$/.test(val);
	      },
	      alpha_dash: function (val) {
	        return /^[a-zA-Z0-9_\-]+$/.test(val);
	      },
	      alpha_num: function (val) {
	        return /^[a-zA-Z0-9]+$/.test(val);
	      },
	      same: function (val, req) {
	        var val1 = this.validator._flattenObject(this.validator.input)[req];

	        var val2 = val;

	        if (val1 === val2) {
	          return true;
	        }

	        return false;
	      },
	      different: function (val, req) {
	        var val1 = this.validator._flattenObject(this.validator.input)[req];

	        var val2 = val;

	        if (val1 !== val2) {
	          return true;
	        }

	        return false;
	      },
	      in: function (val, req) {
	        var list, i;

	        if (val) {
	          list = this.getParameters();
	        }

	        if (val && !(val instanceof Array)) {
	          var localValue = val;

	          for (i = 0; i < list.length; i++) {
	            if (typeof list[i] === "string") {
	              localValue = String(val);
	            }

	            if (localValue === list[i]) {
	              return true;
	            }
	          }

	          return false;
	        }

	        if (val && val instanceof Array) {
	          for (i = 0; i < val.length; i++) {
	            if (list.indexOf(val[i]) < 0) {
	              return false;
	            }
	          }
	        }

	        return true;
	      },
	      not_in: function (val, req) {
	        var list = this.getParameters();
	        var len = list.length;
	        var returnVal = true;

	        for (var i = 0; i < len; i++) {
	          var localValue = val;

	          if (typeof list[i] === "string") {
	            localValue = String(val);
	          }

	          if (localValue === list[i]) {
	            returnVal = false;
	            break;
	          }
	        }

	        return returnVal;
	      },
	      accepted: function (val) {
	        if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
	          return true;
	        }

	        return false;
	      },
	      confirmed: function (val, req, key) {
	        var confirmedKey = key + "_confirmation";

	        if (this.validator.input[confirmedKey] === val) {
	          return true;
	        }

	        return false;
	      },
	      integer: function (val) {
	        return String(parseInt(val, 10)) === String(val);
	      },
	      digits: function (val, req) {
	        var numericRule = this.validator.getRule('numeric');

	        if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
	          return true;
	        }

	        return false;
	      },
	      digits_between: function (val) {
	        var numericRule = this.validator.getRule("numeric");
	        var req = this.getParameters();
	        var valueDigitsCount = String(val).length;
	        var min = parseFloat(req[0], 10);
	        var max = parseFloat(req[1], 10);

	        if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
	          return true;
	        }

	        return false;
	      },
	      regex: function (val, req) {
	        var mod = /[g|i|m]{1,3}$/;
	        var flag = req.match(mod);
	        flag = flag ? flag[0] : "";
	        req = req.replace(mod, "").slice(1, -1);
	        req = new RegExp(req, flag);
	        return !!req.test(val);
	      },
	      date: function (val, format) {
	        return isValidDate$1(val);
	      },
	      present: function (val) {
	        return typeof val !== "undefined";
	      },
	      after: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() < new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      after_or_equal: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() <= new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      before: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() > new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      before_or_equal: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() >= new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      hex: function (val) {
	        return /^[0-9a-f]+$/i.test(val);
	      },
	      ipv4: function (val, req, attribute) {
	        if (typeof val != 'string') return false; // regex to check that each octet is valid

	        var er = /^[0-9]+$/; // ipv4 octets are delimited by dot

	        octets = val.split('.'); // check 1: ipv4 address should contains 4 octets

	        if (octets.length != 4) return false;

	        for (let i = 0; i < octets.length; i++) {
	          const element = octets[i]; // check 2: each octet should be integer bigger than 0

	          if (!er.test(element)) return false; // check 3: each octet value should be less than 256

	          var octetValue = parseInt(element);
	          if (octetValue >= 256) return false;
	        } // if all checks passed, we know it's valid IPv4 address!


	        return true;
	      },
	      ipv6: function (val, req, attribute) {
	        if (typeof val != 'string') return false; // regex to check that each hextet is valid

	        var er = /^[0-9a-f]+$/; // ipv6 hextets are delimited by colon

	        hextets = val.split(':'); // check 1: ipv6 should contain only one consecutive colons

	        colons = val.match(/::/);
	        if (colons != null && val.match(/::/g).length > 1) return false; // check 2: ipv6 should not be ending or starting with colon
	        //          edge case: not with consecutive colons

	        if (val[0] == ':' && (colons == null || colons != null && colons.index != 0)) return false;
	        if (val[val.length - 1] == ':' && (colons == null || colons != null && colons.index != val.length - 2)) return false; // check 3: ipv6 should contain no less than 3 sector
	        //         minimum ipv6 addres - ::1

	        if (3 > hextets.length) return false; // check 4: ipv6 should contain no more than 8 sectors
	        //         only 1 edge case: when first or last sector is ommited

	        var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
	        if (hextets.length > 8 && !isEdgeCase) return false; // check 5: ipv6 should contain exactly one consecutive colons if it has less than 8 sectors

	        if (hextets.length != 8 && colons == null) return false;

	        for (let i = 0; i < hextets.length; i++) {
	          const element = hextets[i];
	          if (element.length == 0) continue; // check 6: all of hextets should contain numbers from 0 to f (in hexadecimal)

	          if (!er.test(element)) return false; // check 7: all of hextet values should be less then ffff (in hexadeimal)
	          //          checking using length of hextet. lowest invalid value's length is 5.
	          //          so all valid hextets are length of 4 or less

	          if (element.length > 4) return false;
	        }

	        return true;
	      },
	      ip: function (val, req, attribute) {
	        return rules['ipv4'](val, req, attribute) || rules['ipv6'](val, req, attribute);
	      }
	    };

	    var missedRuleValidator = function () {
	      throw new Error("Validator `" + this.name + "` is not defined!");
	    };

	    var missedRuleMessage;

	    function Rule(name, fn, async) {
	      this.name = name;
	      this.fn = fn;
	      this.passes = null;
	      this._customMessage = undefined;
	      this.async = async;
	    }

	    Rule.prototype = {
	      /**
	       * Validate rule
	       *
	       * @param  {mixed} inputValue
	       * @param  {mixed} ruleValue
	       * @param  {string} attribute
	       * @param  {function} callback
	       * @return {boolean|undefined}
	       */
	      validate: function (inputValue, ruleValue, attribute, callback) {
	        var _this = this;

	        this._setValidatingData(attribute, inputValue, ruleValue);

	        if (typeof callback === "function") {
	          this.callback = callback;

	          var handleResponse = function (passes, message) {
	            _this.response(passes, message);
	          };

	          if (this.async) {
	            return this._apply(inputValue, ruleValue, attribute, handleResponse);
	          } else {
	            return handleResponse(this._apply(inputValue, ruleValue, attribute));
	          }
	        }

	        return this._apply(inputValue, ruleValue, attribute);
	      },

	      /**
	       * Apply validation function
	       *
	       * @param  {mixed} inputValue
	       * @param  {mixed} ruleValue
	       * @param  {string} attribute
	       * @param  {function} callback
	       * @return {boolean|undefined}
	       */
	      _apply: function (inputValue, ruleValue, attribute, callback) {
	        var fn = this.isMissed() ? missedRuleValidator : this.fn;
	        return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
	      },

	      /**
	       * Set validating data
	       *
	       * @param {string} attribute
	       * @param {mixed} inputValue
	       * @param {mixed} ruleValue
	       * @return {void}
	       */
	      _setValidatingData: function (attribute, inputValue, ruleValue) {
	        this.attribute = attribute;
	        this.inputValue = inputValue;
	        this.ruleValue = ruleValue;
	      },

	      /**
	       * Get parameters
	       *
	       * @return {array}
	       */
	      getParameters: function () {
	        var value = [];

	        if (typeof this.ruleValue === "string") {
	          value = this.ruleValue.split(",");
	        }

	        if (typeof this.ruleValue === "number") {
	          value.push(this.ruleValue);
	        }

	        if (this.ruleValue instanceof Array) {
	          value = this.ruleValue;
	        }

	        return value;
	      },

	      /**
	       * Get true size of value
	       *
	       * @return {integer|float}
	       */
	      getSize: function () {
	        var value = this.inputValue;

	        if (value instanceof Array) {
	          return value.length;
	        }

	        if (typeof value === "number") {
	          return value;
	        }

	        if (this.validator._hasNumericRule(this.attribute)) {
	          return parseFloat(value, 10);
	        }

	        return value.length;
	      },

	      /**
	       * Get the type of value being checked; numeric or string.
	       *
	       * @return {string}
	       */
	      _getValueType: function () {
	        if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
	          return "numeric";
	        }

	        return "string";
	      },

	      /**
	       * Set the async callback response
	       *
	       * @param  {boolean|undefined} passes  Whether validation passed
	       * @param  {string|undefined} message Custom error message
	       * @return {void}
	       */
	      response: function (passes, message) {
	        this.passes = passes === undefined || passes === true;
	        this._customMessage = message;
	        this.callback(this.passes, message);
	      },

	      /**
	       * Set validator instance
	       *
	       * @param {Validator} validator
	       * @return {void}
	       */
	      setValidator: function (validator) {
	        this.validator = validator;
	      },

	      /**
	       * Check if rule is missed
	       *
	       * @return {boolean}
	       */
	      isMissed: function () {
	        return typeof this.fn !== "function";
	      },

	      get customMessage() {
	        return this.isMissed() ? missedRuleMessage : this._customMessage;
	      }

	    };
	    var manager = {
	      /**
	       * List of async rule names
	       *
	       * @type {Array}
	       */
	      asyncRules: [],

	      /**
	       * Implicit rules (rules to always validate)
	       *
	       * @type {Array}
	       */
	      implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],

	      /**
	       * Get rule by name
	       *
	       * @param  {string} name
	       * @param {Validator}
	       * @return {Rule}
	       */
	      make: function (name, validator) {
	        var async = this.isAsync(name);
	        var rule = new Rule(name, rules[name], async);
	        rule.setValidator(validator);
	        return rule;
	      },

	      /**
	       * Determine if given rule is async
	       *
	       * @param  {string}  name
	       * @return {boolean}
	       */
	      isAsync: function (name) {
	        for (var i = 0, len = this.asyncRules.length; i < len; i++) {
	          if (this.asyncRules[i] === name) {
	            return true;
	          }
	        }

	        return false;
	      },

	      /**
	       * Determine if rule is implicit (should always validate)
	       *
	       * @param {string} name
	       * @return {boolean}
	       */
	      isImplicit: function (name) {
	        return this.implicitRules.indexOf(name) > -1;
	      },

	      /**
	       * Register new rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      register: function (name, fn) {
	        rules[name] = fn;
	      },

	      /**
	       * Register new implicit rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      registerImplicit: function (name, fn) {
	        this.register(name, fn);
	        this.implicitRules.push(name);
	      },

	      /**
	       * Register async rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      registerAsync: function (name, fn) {
	        this.register(name, fn);
	        this.asyncRules.push(name);
	      },

	      /**
	       * Register implicit async rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      registerAsyncImplicit: function (name, fn) {
	        this.registerImplicit(name, fn);
	        this.asyncRules.push(name);
	      },
	      registerMissedRuleValidator: function (fn, message) {
	        missedRuleValidator = fn;
	        missedRuleMessage = message;
	      }
	    };
	    var rules_1 = manager;
	    var replacements = {
	      /**
	       * Between replacement (replaces :min and :max)
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      between: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          min: parameters[0],
	          max: parameters[1]
	        });
	      },

	      /**
	       * Digits-Between replacement (replaces :min and :max)
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      digits_between: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          min: parameters[0],
	          max: parameters[1]
	        });
	      },

	      /**
	       * Required_if replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_if: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          other: this._getAttributeName(parameters[0]),
	          value: parameters[1]
	        });
	      },

	      /**
	       * Required_unless replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_unless: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          other: this._getAttributeName(parameters[0]),
	          value: parameters[1]
	        });
	      },

	      /**
	       * Required_with replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_with: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          field: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Required_with_all replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_with_all: function (template, rule) {
	        var parameters = rule.getParameters();

	        var getAttributeName = this._getAttributeName.bind(this);

	        return this._replacePlaceholders(rule, template, {
	          fields: parameters.map(getAttributeName).join(', ')
	        });
	      },

	      /**
	       * Required_without replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_without: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          field: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Required_without_all replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_without_all: function (template, rule) {
	        var parameters = rule.getParameters();

	        var getAttributeName = this._getAttributeName.bind(this);

	        return this._replacePlaceholders(rule, template, {
	          fields: parameters.map(getAttributeName).join(', ')
	        });
	      },

	      /**
	       * After replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      after: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          after: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Before replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      before: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          before: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * After_or_equal replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      after_or_equal: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          after_or_equal: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Before_or_equal replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      before_or_equal: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          before_or_equal: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Same replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      same: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          same: this._getAttributeName(parameters[0])
	        });
	      }
	    };

	    function formatter(attribute) {
	      return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
	    }

	    var attributes = {
	      replacements: replacements,
	      formatter: formatter
	    };
	    var Attributes$1 = attributes;

	    var Messages$1 = function (lang, messages) {
	      this.lang = lang;
	      this.messages = messages;
	      this.customMessages = {};
	      this.attributeNames = {};
	    };

	    Messages$1.prototype = {
	      constructor: Messages$1,

	      /**
	       * Set custom messages
	       *
	       * @param {object} customMessages
	       * @return {void}
	       */
	      _setCustom: function (customMessages) {
	        this.customMessages = customMessages || {};
	      },

	      /**
	       * Set custom attribute names.
	       *
	       * @param {object} attributes
	       */
	      _setAttributeNames: function (attributes) {
	        this.attributeNames = attributes;
	      },

	      /**
	       * Set the attribute formatter.
	       *
	       * @param {fuction} func
	       * @return {void}
	       */
	      _setAttributeFormatter: function (func) {
	        this.attributeFormatter = func;
	      },

	      /**
	       * Get attribute name to display.
	       *
	       * @param  {string} attribute
	       * @return {string}
	       */
	      _getAttributeName: function (attribute) {
	        var name = attribute;

	        if (this.attributeNames.hasOwnProperty(attribute)) {
	          return this.attributeNames[attribute];
	        } else if (this.messages.attributes.hasOwnProperty(attribute)) {
	          name = this.messages.attributes[attribute];
	        }

	        if (this.attributeFormatter) {
	          name = this.attributeFormatter(name);
	        }

	        return name;
	      },

	      /**
	       * Get all messages
	       *
	       * @return {object}
	       */
	      all: function () {
	        return this.messages;
	      },

	      /**
	       * Render message
	       *
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      render: function (rule) {
	        if (rule.customMessage) {
	          return rule.customMessage;
	        }

	        var template = this._getTemplate(rule);

	        var message;

	        if (Attributes$1.replacements[rule.name]) {
	          message = Attributes$1.replacements[rule.name].apply(this, [template, rule]);
	        } else {
	          message = this._replacePlaceholders(rule, template, {});
	        }

	        return message;
	      },

	      /**
	       * Get the template to use for given rule
	       *
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      _getTemplate: function (rule) {
	        var messages = this.messages;
	        var template = messages.def;
	        var customMessages = this.customMessages;
	        var formats = [rule.name + '.' + rule.attribute, rule.name];

	        for (var i = 0, format; i < formats.length; i++) {
	          format = formats[i];

	          if (customMessages.hasOwnProperty(format)) {
	            template = customMessages[format];
	            break;
	          } else if (messages.hasOwnProperty(format)) {
	            template = messages[format];
	            break;
	          }
	        }

	        if (typeof template === 'object') {
	          template = template[rule._getValueType()];
	        }

	        return template;
	      },

	      /**
	       * Replace placeholders in the template using the data object
	       *
	       * @param  {Rule} rule
	       * @param  {string} template
	       * @param  {object} data
	       * @return {string}
	       */
	      _replacePlaceholders: function (rule, template, data) {
	        var message, attribute;
	        data.attribute = this._getAttributeName(rule.attribute);
	        data[rule.name] = data[rule.name] || rule.getParameters().join(',');

	        if (typeof template === 'string' && typeof data === 'object') {
	          message = template;

	          for (attribute in data) {
	            message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
	          }
	        }

	        return message;
	      }
	    };
	    var messages$1 = Messages$1;
	    var en = {
	      accepted: 'The :attribute must be accepted.',
	      after: 'The :attribute must be after :after.',
	      after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
	      alpha: 'The :attribute field must contain only alphabetic characters.',
	      alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
	      alpha_num: 'The :attribute field must be alphanumeric.',
	      before: 'The :attribute must be before :before.',
	      before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
	      between: {
	        numeric: 'The :attribute field must be between :min and :max.',
	        string: 'The :attribute field must be between :min and :max characters.'
	      },
	      confirmed: 'The :attribute confirmation does not match.',
	      email: 'The :attribute format is invalid.',
	      date: 'The :attribute is not a valid date format.',
	      def: 'The :attribute attribute has errors.',
	      digits: 'The :attribute must be :digits digits.',
	      digits_between: 'The :attribute field must be between :min and :max digits.',
	      different: 'The :attribute and :different must be different.',
	      in: 'The selected :attribute is invalid.',
	      integer: 'The :attribute must be an integer.',
	      hex: 'The :attribute field should have hexadecimal format',
	      min: {
	        numeric: 'The :attribute must be at least :min.',
	        string: 'The :attribute must be at least :min characters.'
	      },
	      max: {
	        numeric: 'The :attribute may not be greater than :max.',
	        string: 'The :attribute may not be greater than :max characters.'
	      },
	      not_in: 'The selected :attribute is invalid.',
	      numeric: 'The :attribute must be a number.',
	      present: 'The :attribute field must be present (but can be empty).',
	      required: 'The :attribute field is required.',
	      required_if: 'The :attribute field is required when :other is :value.',
	      required_unless: 'The :attribute field is required when :other is not :value.',
	      required_with: 'The :attribute field is required when :field is not empty.',
	      required_with_all: 'The :attribute field is required when :fields are not empty.',
	      required_without: 'The :attribute field is required when :field is empty.',
	      required_without_all: 'The :attribute field is required when :fields are empty.',
	      same: 'The :attribute and :same fields must match.',
	      size: {
	        numeric: 'The :attribute must be :size.',
	        string: 'The :attribute must be :size characters.'
	      },
	      string: 'The :attribute must be a string.',
	      url: 'The :attribute format is invalid.',
	      regex: 'The :attribute format is invalid.',
	      attributes: {}
	    };
	    var Messages = messages$1;
	    var require_method = commonjsRequire;
	    var container = {
	      messages: {},

	      /**
	       * Set messages for language
	       *
	       * @param {string} lang
	       * @param {object} rawMessages
	       * @return {void}
	       */
	      _set: function (lang, rawMessages) {
	        this.messages[lang] = rawMessages;
	      },

	      /**
	       * Set message for given language's rule.
	       *
	       * @param {string} lang
	       * @param {string} attribute
	       * @param {string|object} message
	       * @return {void}
	       */
	      _setRuleMessage: function (lang, attribute, message) {
	        this._load(lang);

	        if (message === undefined) {
	          message = this.messages[lang].def;
	        }

	        this.messages[lang][attribute] = message;
	      },

	      /**
	       * Load messages (if not already loaded)
	       *
	       * @param  {string} lang
	       * @return {void}
	       */
	      _load: function (lang) {
	        if (!this.messages[lang]) {
	          try {
	            var rawMessages = require_method('./lang/' + lang);

	            this._set(lang, rawMessages);
	          } catch (e) {}
	        }
	      },

	      /**
	       * Get raw messages for language
	       *
	       * @param  {string} lang
	       * @return {object}
	       */
	      _get: function (lang) {
	        this._load(lang);

	        return this.messages[lang];
	      },

	      /**
	       * Make messages for given language
	       *
	       * @param  {string} lang
	       * @return {Messages}
	       */
	      _make: function (lang) {
	        this._load(lang);

	        return new Messages(lang, this.messages[lang]);
	      }
	    };
	    var lang = container;

	    var Errors$1 = function () {
	      this.errors = {};
	    };

	    Errors$1.prototype = {
	      constructor: Errors$1,

	      /**
	       * Add new error message for given attribute
	       *
	       * @param  {string} attribute
	       * @param  {string} message
	       * @return {void}
	       */
	      add: function (attribute, message) {
	        if (!this.has(attribute)) {
	          this.errors[attribute] = [];
	        }

	        if (this.errors[attribute].indexOf(message) === -1) {
	          this.errors[attribute].push(message);
	        }
	      },

	      /**
	       * Returns an array of error messages for an attribute, or an empty array
	       *
	       * @param  {string} attribute A key in the data object being validated
	       * @return {array} An array of error messages
	       */
	      get: function (attribute) {
	        if (this.has(attribute)) {
	          return this.errors[attribute];
	        }

	        return [];
	      },

	      /**
	       * Returns the first error message for an attribute, false otherwise
	       *
	       * @param  {string} attribute A key in the data object being validated
	       * @return {string|false} First error message or false
	       */
	      first: function (attribute) {
	        if (this.has(attribute)) {
	          return this.errors[attribute][0];
	        }

	        return false;
	      },

	      /**
	       * Get all error messages from all failing attributes
	       *
	       * @return {Object} Failed attribute names for keys and an array of messages for values
	       */
	      all: function () {
	        return this.errors;
	      },

	      /**
	       * Determine if there are any error messages for an attribute
	       *
	       * @param  {string}  attribute A key in the data object being validated
	       * @return {boolean}
	       */
	      has: function (attribute) {
	        if (this.errors.hasOwnProperty(attribute)) {
	          return true;
	        }

	        return false;
	      }
	    };
	    var errors = Errors$1;

	    function AsyncResolvers$1(onFailedOne, onResolvedAll) {
	      this.onResolvedAll = onResolvedAll;
	      this.onFailedOne = onFailedOne;
	      this.resolvers = {};
	      this.resolversCount = 0;
	      this.passed = [];
	      this.failed = [];
	      this.firing = false;
	    }

	    AsyncResolvers$1.prototype = {
	      /**
	       * Add resolver
	       *
	       * @param {Rule} rule
	       * @return {integer}
	       */
	      add: function (rule) {
	        var index = this.resolversCount;
	        this.resolvers[index] = rule;
	        this.resolversCount++;
	        return index;
	      },

	      /**
	       * Resolve given index
	       *
	       * @param  {integer} index
	       * @return {void}
	       */
	      resolve: function (index) {
	        var rule = this.resolvers[index];

	        if (rule.passes === true) {
	          this.passed.push(rule);
	        } else if (rule.passes === false) {
	          this.failed.push(rule);
	          this.onFailedOne(rule);
	        }

	        this.fire();
	      },

	      /**
	       * Determine if all have been resolved
	       *
	       * @return {boolean}
	       */
	      isAllResolved: function () {
	        return this.passed.length + this.failed.length === this.resolversCount;
	      },

	      /**
	       * Attempt to fire final all resolved callback if completed
	       *
	       * @return {void}
	       */
	      fire: function () {
	        if (!this.firing) {
	          return;
	        }

	        if (this.isAllResolved()) {
	          this.onResolvedAll(this.failed.length === 0);
	        }
	      },

	      /**
	       * Enable firing
	       *
	       * @return {void}
	       */
	      enableFiring: function () {
	        this.firing = true;
	      }
	    };
	    var async = AsyncResolvers$1;
	    var Rules$1 = rules_1;
	    var Lang = lang;
	    var Errors = errors;
	    var Attributes = attributes;
	    var AsyncResolvers = async;

	    var Validator = function (input, rules, customMessages) {
	      var lang = Validator.getDefaultLang();
	      this.input = input || {};
	      this.messages = Lang._make(lang);

	      this.messages._setCustom(customMessages);

	      this.setAttributeFormatter(Validator.prototype.attributeFormatter);
	      this.errors = new Errors();
	      this.errorCount = 0;
	      this.hasAsync = false;
	      this.rules = this._parseRules(rules);
	    };

	    Validator.prototype = {
	      constructor: Validator,

	      /**
	       * Default language
	       *
	       * @type {string}
	       */
	      lang: 'en',

	      /**
	       * Numeric based rules
	       *
	       * @type {array}
	       */
	      numericRules: ['integer', 'numeric'],

	      /**
	       * Attribute formatter.
	       *
	       * @type {function}
	       */
	      attributeFormatter: Attributes.formatter,

	      /**
	       * Run validator
	       *
	       * @return {boolean} Whether it passes; true = passes, false = fails
	       */
	      check: function () {
	        for (var attribute in this.rules) {
	          var attributeRules = this.rules[attribute];

	          var inputValue = this._objectPath(this.input, attribute);

	          if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	            continue;
	          }

	          for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
	            ruleOptions = attributeRules[i];
	            rule = this.getRule(ruleOptions.name);

	            if (!this._isValidatable(rule, inputValue)) {
	              continue;
	            }

	            rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);

	            if (!rulePassed) {
	              this._addFailure(rule);
	            }

	            if (this._shouldStopValidating(attribute, rulePassed)) {
	              break;
	            }
	          }
	        }

	        return this.errorCount === 0;
	      },

	      /**
	       * Run async validator
	       *
	       * @param {function} passes
	       * @param {function} fails
	       * @return {void}
	       */
	      checkAsync: function (passes, fails) {
	        var _this = this;

	        passes = passes || function () {};

	        fails = fails || function () {};

	        var failsOne = function (rule, message) {
	          _this._addFailure(rule, message);
	        };

	        var resolvedAll = function (allPassed) {
	          if (allPassed) {
	            passes();
	          } else {
	            fails();
	          }
	        };

	        var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

	        var validateRule = function (inputValue, ruleOptions, attribute, rule) {
	          return function () {
	            var resolverIndex = asyncResolvers.add(rule);
	            rule.validate(inputValue, ruleOptions.value, attribute, function () {
	              asyncResolvers.resolve(resolverIndex);
	            });
	          };
	        };

	        for (var attribute in this.rules) {
	          var attributeRules = this.rules[attribute];

	          var inputValue = this._objectPath(this.input, attribute);

	          if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	            continue;
	          }

	          for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
	            ruleOptions = attributeRules[i];
	            rule = this.getRule(ruleOptions.name);

	            if (!this._isValidatable(rule, inputValue)) {
	              continue;
	            }

	            validateRule(inputValue, ruleOptions, attribute, rule)();
	          }
	        }

	        asyncResolvers.enableFiring();
	        asyncResolvers.fire();
	      },

	      /**
	       * Add failure and error message for given rule
	       *
	       * @param {Rule} rule
	       */
	      _addFailure: function (rule) {
	        var msg = this.messages.render(rule);
	        this.errors.add(rule.attribute, msg);
	        this.errorCount++;
	      },

	      /**
	       * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
	       *
	       * @param  {object} nested object
	       * @return {object} flattened object
	       */
	      _flattenObject: function (obj) {
	        var flattened = {};

	        function recurse(current, property) {
	          if (!property && Object.getOwnPropertyNames(current).length === 0) {
	            return;
	          }

	          if (Object(current) !== current || Array.isArray(current)) {
	            flattened[property] = current;
	          } else {
	            var isEmpty = true;

	            for (var p in current) {
	              isEmpty = false;
	              recurse(current[p], property ? property + '.' + p : p);
	            }

	            if (isEmpty) {
	              flattened[property] = {};
	            }
	          }
	        }

	        if (obj) {
	          recurse(obj);
	        }

	        return flattened;
	      },

	      /**
	       * Extract value from nested object using string path with dot notation
	       *
	       * @param  {object} object to search in
	       * @param  {string} path inside object
	       * @return {any|void} value under the path
	       */
	      _objectPath: function (obj, path) {
	        if (Object.prototype.hasOwnProperty.call(obj, path)) {
	          return obj[path];
	        }

	        var keys = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
	        var copy = {};

	        for (var attr in obj) {
	          if (Object.prototype.hasOwnProperty.call(obj, attr)) {
	            copy[attr] = obj[attr];
	          }
	        }

	        for (var i = 0, l = keys.length; i < l; i++) {
	          if (typeof copy === 'object' && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
	            copy = copy[keys[i]];
	          } else {
	            return;
	          }
	        }

	        return copy;
	      },

	      /**
	       * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
	       *
	       * @param  {object} rules
	       * @return {object}
	       */
	      _parseRules: function (rules) {
	        var parsedRules = {};
	        rules = this._flattenObject(rules);

	        for (var attribute in rules) {
	          var rulesArray = rules[attribute];

	          this._parseRulesCheck(attribute, rulesArray, parsedRules);
	        }

	        return parsedRules;
	      },
	      _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
	        if (attribute.indexOf('*') > -1) {
	          this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
	        } else {
	          this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
	        }
	      },
	      _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
	        var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);

	        var propertyValue = this._objectPath(this.input, parentPath);

	        if (propertyValue) {
	          for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
	            var workingValues = wildCardValues ? wildCardValues.slice() : [];
	            workingValues.push(propertyNumber);

	            this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
	          }
	        }
	      },
	      _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
	        var attributeRules = [];

	        if (rulesArray instanceof Array) {
	          rulesArray = this._prepareRulesArray(rulesArray);
	        }

	        if (typeof rulesArray === 'string') {
	          rulesArray = rulesArray.split('|');
	        }

	        for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
	          rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];

	          if (rule.value) {
	            rule.value = this._replaceWildCards(rule.value, wildCardValues);

	            this._replaceWildCardsMessages(wildCardValues);
	          }

	          if (Rules$1.isAsync(rule.name)) {
	            this.hasAsync = true;
	          }

	          attributeRules.push(rule);
	        }

	        parsedRules[attribute] = attributeRules;
	      },
	      _replaceWildCards: function (path, nums) {
	        if (!nums) {
	          return path;
	        }

	        var path2 = path;
	        nums.forEach(function (value) {
	          if (Array.isArray(path2)) {
	            path2 = path2[0];
	          }

	          const pos = path2.indexOf('*');

	          if (pos === -1) {
	            return path2;
	          }

	          path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
	        });

	        if (Array.isArray(path)) {
	          path[0] = path2;
	          path2 = path;
	        }

	        return path2;
	      },
	      _replaceWildCardsMessages: function (nums) {
	        var customMessages = this.messages.customMessages;
	        var self = this;
	        Object.keys(customMessages).forEach(function (key) {
	          if (nums) {
	            var newKey = self._replaceWildCards(key, nums);

	            customMessages[newKey] = customMessages[key];
	          }
	        });

	        this.messages._setCustom(customMessages);
	      },

	      /**
	       * Prepare rules if it comes in Array. Check for objects. Need for type validation.
	       *
	       * @param  {array} rulesArray
	       * @return {array}
	       */
	      _prepareRulesArray: function (rulesArray) {
	        var rules = [];

	        for (var i = 0, len = rulesArray.length; i < len; i++) {
	          if (typeof rulesArray[i] === 'object') {
	            for (var rule in rulesArray[i]) {
	              rules.push({
	                name: rule,
	                value: rulesArray[i][rule]
	              });
	            }
	          } else {
	            rules.push(rulesArray[i]);
	          }
	        }

	        return rules;
	      },

	      /**
	       * Determines if the attribute is supplied with the original data object.
	       *
	       * @param  {array} attribute
	       * @return {boolean}
	       */
	      _suppliedWithData: function (attribute) {
	        return this.input.hasOwnProperty(attribute);
	      },

	      /**
	       * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
	       *
	       * @param  {string} ruleString min:3
	       * @return {object} object containing the name of the rule and value
	       */
	      _extractRuleAndRuleValue: function (ruleString) {
	        var rule = {},
	            ruleArray;
	        rule.name = ruleString;

	        if (ruleString.indexOf(':') >= 0) {
	          ruleArray = ruleString.split(':');
	          rule.name = ruleArray[0];
	          rule.value = ruleArray.slice(1).join(':');
	        }

	        return rule;
	      },

	      /**
	       * Determine if attribute has any of the given rules
	       *
	       * @param  {string}  attribute
	       * @param  {array}   findRules
	       * @return {boolean}
	       */
	      _hasRule: function (attribute, findRules) {
	        var rules = this.rules[attribute] || [];

	        for (var i = 0, len = rules.length; i < len; i++) {
	          if (findRules.indexOf(rules[i].name) > -1) {
	            return true;
	          }
	        }

	        return false;
	      },

	      /**
	       * Determine if attribute has any numeric-based rules.
	       *
	       * @param  {string}  attribute
	       * @return {Boolean}
	       */
	      _hasNumericRule: function (attribute) {
	        return this._hasRule(attribute, this.numericRules);
	      },

	      /**
	       * Determine if rule is validatable
	       *
	       * @param  {Rule}   rule
	       * @param  {mixed}  value
	       * @return {boolean}
	       */
	      _isValidatable: function (rule, value) {
	        if (Array.isArray(value)) {
	          return true;
	        }

	        if (Rules$1.isImplicit(rule.name)) {
	          return true;
	        }

	        return this.getRule('required').validate(value);
	      },

	      /**
	       * Determine if we should stop validating.
	       *
	       * @param  {string} attribute
	       * @param  {boolean} rulePassed
	       * @return {boolean}
	       */
	      _shouldStopValidating: function (attribute, rulePassed) {
	        var stopOnAttributes = this.stopOnAttributes;

	        if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
	          return false;
	        }

	        if (stopOnAttributes instanceof Array) {
	          return stopOnAttributes.indexOf(attribute) > -1;
	        }

	        return true;
	      },

	      /**
	       * Set custom attribute names.
	       *
	       * @param {object} attributes
	       * @return {void}
	       */
	      setAttributeNames: function (attributes) {
	        this.messages._setAttributeNames(attributes);
	      },

	      /**
	       * Set the attribute formatter.
	       *
	       * @param {fuction} func
	       * @return {void}
	       */
	      setAttributeFormatter: function (func) {
	        this.messages._setAttributeFormatter(func);
	      },

	      /**
	       * Get validation rule
	       *
	       * @param  {string} name
	       * @return {Rule}
	       */
	      getRule: function (name) {
	        return Rules$1.make(name, this);
	      },

	      /**
	       * Stop on first error.
	       *
	       * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	       * @return {void}
	       */
	      stopOnError: function (attributes) {
	        this.stopOnAttributes = attributes;
	      },

	      /**
	       * Determine if validation passes
	       *
	       * @param {function} passes
	       * @return {boolean|undefined}
	       */
	      passes: function (passes) {
	        var async = this._checkAsync('passes', passes);

	        if (async) {
	          return this.checkAsync(passes);
	        }

	        return this.check();
	      },

	      /**
	       * Determine if validation fails
	       *
	       * @param {function} fails
	       * @return {boolean|undefined}
	       */
	      fails: function (fails) {
	        var async = this._checkAsync('fails', fails);

	        if (async) {
	          return this.checkAsync(function () {}, fails);
	        }

	        return !this.check();
	      },

	      /**
	       * Check if validation should be called asynchronously
	       *
	       * @param  {string}   funcName Name of the caller
	       * @param  {function} callback
	       * @return {boolean}
	       */
	      _checkAsync: function (funcName, callback) {
	        var hasCallback = typeof callback === 'function';

	        if (this.hasAsync && !hasCallback) {
	          throw funcName + ' expects a callback when async rules are being tested.';
	        }

	        return this.hasAsync || hasCallback;
	      }
	    };
	    /**
	     * Set messages for language
	     *
	     * @param {string} lang
	     * @param {object} messages
	     * @return {this}
	     */

	    Validator.setMessages = function (lang, messages) {
	      Lang._set(lang, messages);

	      return this;
	    };
	    /**
	     * Get messages for given language
	     *
	     * @param  {string} lang
	     * @return {Messages}
	     */


	    Validator.getMessages = function (lang) {
	      return Lang._get(lang);
	    };
	    /**
	     * Set default language to use
	     *
	     * @param {string} lang
	     * @return {void}
	     */


	    Validator.useLang = function (lang) {
	      this.prototype.lang = lang;
	    };
	    /**
	     * Get default language
	     *
	     * @return {string}
	     */


	    Validator.getDefaultLang = function () {
	      return this.prototype.lang;
	    };
	    /**
	     * Set the attribute formatter.
	     *
	     * @param {fuction} func
	     * @return {void}
	     */


	    Validator.setAttributeFormatter = function (func) {
	      this.prototype.attributeFormatter = func;
	    };
	    /**
	     * Stop on first error.
	     *
	     * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	     * @return {void}
	     */


	    Validator.stopOnError = function (attributes) {
	      this.prototype.stopOnAttributes = attributes;
	    };
	    /**
	     * Register custom validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.register = function (name, fn, message, fnReplacement) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.register(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register custom validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @param  {function} fnReplacement
	     * @return {void}
	     */


	    Validator.registerImplicit = function (name, fn, message, fnReplacement) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.registerImplicit(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register asynchronous validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.registerAsync = function (name, fn, message, fnReplacement) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.registerAsync(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register asynchronous validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.registerAsyncImplicit = function (name, fn, message) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.registerAsyncImplicit(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register validator for missed validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.registerMissedRuleValidator = function (fn, message) {
	      Rules$1.registerMissedRuleValidator(fn, message);
	    };

	    var validator$2 = Validator; // It is not possible to dynamically require language files when a package that has validatorjs as a dependency
	    // is compiled using rollup. Validatorjs does this internally.
	    // When this package is used in conjunction with a rollup compiled package, due to the global nature of
	    // a lot of features within validatorjs, this fails!
	    // Loading 'en' here, as it is the default language. This is also referenced internally
	    // for some methods that are not directly related to validation errors.

	    validator$2.setMessages('en', en || {
	      def: 'The :attribute attribute has errors.',
	      attributes: {}
	    });
	    /**
	     * Stub or implement the rules not supported by https://github.com/mikeerickson/validatorjs,
	     * but passed to the frontend by https://bitbucket.org/eventix/http/src/master/src/FrontendRules.php
	    */

	    /*
	    [
	        'active_url',
	        'accepted_if',
	        'bail',
	        'date_equals',
	        'date_format',
	        'declined',
	        'declined_if',
	        'distinct',
	        'ends_with',
	        'enum',
	        'filled',
	        'gt',
	        'gte',
	        'json',
	        'lt',
	        'lte',
	        'multiple_of',
	        'not_regex',
	        'nullable',
	        'prohibited',
	        'prohibited_if',
	        'prohibited_unless',
	        'prohibits',
	        'sometimes',
	        'starts_with',
	        'timezone',
	        'uuid',
	    ];
	    */

	    validator$2.registerMissedRuleValidator(() => true); // https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-a-leap-year

	    function leapYear(year) {
	      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    }

	    function checkFalsePositiveDates(dateString = '') {
	      if (dateString.length === 10) {
	        // massage input to use yyyy-mm-dd format
	        // we support yyyy/mm/dd or yyyy.mm.dd
	        const normalizedDate = dateString.replace('.', '-').replace('/', '-');
	        const parts = normalizedDate.split('-');

	        if (parts.length === 3) {
	          if (parts[0].length === 4) {
	            // yyyy-mm-dd format
	            const y = parseInt(parts[0], 10);
	            const m = parseInt(parts[1], 10);
	            const d = parseInt(parts[2], 10);

	            if (m === 2) {
	              // return leapYear(y) ? d <= 29 : d <= 28;
	              if (leapYear(y)) {
	                if (d > 29) {
	                  return false;
	                }
	              } else if (d > 28) {
	                return false;
	              }
	            }

	            if (m === 4 || m === 6 || m === 9 || m === 11) {
	              if (d > 30) {
	                return false;
	              }
	            }
	          }
	        }

	        return true; // we are not in february, proceed
	      }

	      return true; // we are not testing formatted date, proceed to rest of validation
	    }

	    function isValidDate(dateString) {
	      let testDate;

	      if (typeof dateString === 'number') {
	        testDate = new Date(dateString);

	        if (typeof testDate === 'object') {
	          return true;
	        }

	        dateString = `${dateString}`;
	      } else if (typeof dateString === 'boolean') {
	        return false;
	      } // first convert incoming string to date object and see if it corrects date and format


	      testDate = new Date(dateString);

	      if (typeof testDate === 'object') {
	        if (testDate.toString() === 'Invalid Date') {
	          return false;
	        }
	        /**
	         * Check for false positive dates
	         * perform special check on february as JS `new Date` incorrectly returns valid date
	         * E.g.  let newDate = new Date('2020-02-29')  // returns as March 02, 2020.
	         * E.g.  let newDate = new Date('2019-02-29')  // returns as March 01, 2020.
	         * E.g.  let newDate = new Date('2019-04-31')  // returns as April 30, 2020.
	         */


	        if (!checkFalsePositiveDates(dateString)) {
	          return false;
	        } // valid date object and not a february date


	        return true;
	      } // First check for the pattern


	      const regex_date = /^\d{4}-\d{1,2}-\d{1,2}$/;

	      if (!regex_date.test(dateString)) {
	        return false;
	      } // Parse the date parts to integers


	      const parts = dateString.split('-');
	      const day = parseInt(parts[2], 10);
	      const month = parseInt(parts[1], 10);
	      const year = parseInt(parts[0], 10); // Check the ranges of month and year

	      if (year < 1000 || year > 3000 || month === 0 || month > 12) {
	        return false;
	      }

	      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

	      if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
	        monthLength[1] = 29;
	      } // Check the range of the day


	      return day > 0 && day <= monthLength[month - 1];
	    }

	    function after(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() < new Date(val).getTime();
	    }

	    function after_or_equal(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() <= new Date(val).getTime();
	    }

	    function before(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() > new Date(val).getTime();
	    }

	    function before_or_equal(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() >= new Date(val).getTime();
	    }

	    const messages = validator$2.getMessages(validator$2.getDefaultLang());
	    validator$2.register('after', after, messages && typeof messages.after === 'string' ? messages.after : undefined);
	    validator$2.register('after_or_equal', after_or_equal, messages && typeof messages.after_or_equal === 'string' ? messages.after_or_equal : undefined);
	    validator$2.register('before', before, messages && typeof messages.before === 'string' ? messages.before : undefined);
	    validator$2.register('before_or_equal', before_or_equal, messages && typeof messages.before_or_equal === 'string' ? messages.before_or_equal : undefined);

	    function isCrudApiError(e) {
	      if (!e) {
	        return false;
	      } // This type cast is as of yet not valid,
	      // BUT this whole method is designed to check this validity,
	      // therefore it is expected to assume it will be valid.


	      const crudApiError = e;
	      return !!crudApiError.response && crudApiError.response.status !== undefined && Number.isInteger(crudApiError.response.status) && crudApiError.response.statusText !== undefined && !!crudApiError.response.data && crudApiError.response.data.status_code !== undefined && crudApiError.response.data.error_description !== undefined;
	    }

	    function marshalCrudValidationData(data) {
	      if (!isCrudApiError(data)) {
	        const unexpectedError = new UnexpectedError(data);
	        const unexpectedSlug = unexpectedError.toSlug();
	        return {
	          slug: unexpectedSlug.key,
	          data: { ...unexpectedSlug.data,
	            message: unexpectedError.toString()
	          },
	          messages: {}
	        };
	      }

	      const slugData = {
	        status: data.response.status,
	        statusText: data.response.statusText,
	        statusCode: data.response.data.status_code
	      };

	      if (typeof data.response.data.error_description === 'string') {
	        slugData.message = data.response.data.error_description;
	      }

	      const messages = {};
	      let errorDescription = data.response.data.error_description;

	      if (typeof errorDescription === 'object') {
	        if (typeof errorDescription.message === 'object') {
	          errorDescription = errorDescription.message;
	        }

	        for (const errorDescriptionKey in errorDescription) {
	          if (!Object.prototype.hasOwnProperty.call(errorDescription, errorDescriptionKey)) {
	            continue;
	          }

	          if (typeof errorDescription[errorDescriptionKey] === 'string' || Array.isArray(errorDescription[errorDescriptionKey])) {
	            messages[errorDescriptionKey] = errorDescription[errorDescriptionKey];
	          }
	        }
	      }

	      return {
	        slug: 'sdkhelpers.crud.errors.validation_error',
	        data: slugData,
	        messages
	      };
	    }

	    function isCrudValidationError(e) {
	      return e && e._isCrudValidationError;
	    }

	    class CrudValidationError extends BaseError {
	      constructor(data) {
	        super(marshalCrudValidationData(data));
	        this._isCrudValidationError = true;
	      }

	      toString() {
	        // TODO @Rik.. No clue what to make of this...
	        throw new Error('CrudValidationError.toString not yet implemented.');
	      }

	      toSlug() {
	        return {
	          key: this.data.slug,
	          data: this.data.data
	        };
	      }

	    }

	    class FormValidationResult {
	      constructor(data) {
	        this.valid = false;
	        this._data = data;
	      }

	      static create(data) {
	        if (!data || Object.values(data.messages).every(message => !message || !message.length)) {
	          return this.valid();
	        }

	        return this.invalid(data);
	      }

	      static valid() {
	        return {
	          valid: true
	        };
	      }

	      static invalid(data) {
	        return new this(data);
	      }

	      get result() {
	        return this._data;
	      }

	    }

	    class ModelForm extends Form {
	      constructor(relation, model) {
	        super({
	          data: model.props,
	          submit: (data, original) => this._submit(data, original),
	          validate: data => this._validate(data)
	        });
	        this._model = model;
	        this._relation = relation;

	        if (relation.rules) {
	          void relation.rules().then(rules => {
	            if (!rules) {
	              return;
	            }

	            this._rules = rules;

	            for (const key in rules) {
	              if (!this.props[key]) {
	                // Got rules for undefined prop
	                continue;
	              }

	              this.props[key].rules = rules[key];
	            }
	          });
	        }
	      }

	      async _submit(data, original) {
	        // Only send props that follow one of the following constraints:
	        // - The prop is `required` as implied by its rules
	        // - The new value differs from the original value and has therefore changed
	        const filteredData = {};

	        for (const key in data) {
	          if (!Object.prototype.hasOwnProperty.call(data, key)) {
	            continue;
	          }

	          if (original[key] !== data[key] || this.props[key].rules.includes('required')) {
	            filteredData[key] = data[key];
	          }
	        }

	        try {
	          if (this._model.isNew) {
	            await this._relation.create(filteredData, this._model);
	          } else {
	            await this._relation.update(filteredData, this._model);
	          }
	        } catch (e) {
	          if (isCrudValidationError(e)) {
	            throw new FormValidationError(e.data);
	          }

	          throw e;
	        }
	      }

	      async _validate(data) {
	        const validation = new validator$2(data, this._rules);

	        if (validation.check()) {
	          return FormValidationResult.valid();
	        }

	        return FormValidationResult.invalid({
	          slug: 'libsdkhelpers.form.model_form.validation_error',
	          messages: validation.errors.errors
	        });
	      }

	    }

	    var urlJoin$1 = {
	      exports: {}
	    };

	    (function (module) {
	      (function (name, context, definition) {
	        if (module.exports) module.exports = definition();else context[name] = definition();
	      })('urljoin', commonjsGlobal$1, function () {
	        function normalize(strArray) {
	          var resultArray = [];

	          if (strArray.length === 0) {
	            return '';
	          }

	          if (typeof strArray[0] !== 'string') {
	            throw new TypeError('Url must be a string. Received ' + strArray[0]);
	          } // If the first part is a plain protocol, we combine it with the next part.


	          if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
	            var first = strArray.shift();
	            strArray[0] = first + strArray[0];
	          } // There must be two or three slashes in the file protocol, two slashes in anything else.


	          if (strArray[0].match(/^file:\/\/\//)) {
	            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
	          } else {
	            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
	          }

	          for (var i = 0; i < strArray.length; i++) {
	            var component = strArray[i];

	            if (typeof component !== 'string') {
	              throw new TypeError('Url must be a string. Received ' + component);
	            }

	            if (component === '') {
	              continue;
	            }

	            if (i > 0) {
	              // Removing the starting slashes for each component but the first.
	              component = component.replace(/^[\/]+/, '');
	            }

	            if (i < strArray.length - 1) {
	              // Removing the ending slashes for each component but the last.
	              component = component.replace(/[\/]+$/, '');
	            } else {
	              // For the last component we will combine multiple slashes to a single one.
	              component = component.replace(/[\/]+$/, '/');
	            }

	            resultArray.push(component);
	          }

	          var str = resultArray.join('/'); // Each input component is now separated by a single slash except the possible first plain protocol part.
	          // remove trailing slash before parameters or hash

	          str = str.replace(/\/(\?|&|#[^!])/g, '$1'); // replace ? in parameters with &

	          var parts = str.split('?');
	          str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
	          return str;
	        }

	        return function () {
	          var input;

	          if (typeof arguments[0] === 'object') {
	            input = arguments[0];
	          } else {
	            input = [].slice.call(arguments);
	          }

	          return normalize(input);
	        };
	      });
	    })(urlJoin$1);

	    var urlJoin = urlJoin$1.exports;

	    class CrudNode {
	      constructor(parent, type, paths) {
	        this._parent = parent;
	        this._type = type;
	        this.paths = paths || [];
	      }

	      get $path() {
	        throw Error('$path not implemented');
	      }

	      get $routes() {
	        return [];
	      }

	      get $http() {
	        return this._parent.$http;
	      }

	      get $log() {
	        return this._parent.$log;
	      }

	      get $root() {
	        return this._parent.$root;
	      }

	      get $factory() {
	        return this._parent.$factory;
	      }

	      get type() {
	        return this._type;
	      }

	      get parent() {
	        return this._parent;
	      }

	    }

	    class CrudToOne extends CrudNode {
	      constructor(parent, type, config) {
	        super(parent, type);
	        this._config = config;
	      }

	      get $path() {
	        return urlJoin(this._parent.$path, this._config.path || this.type);
	      }

	      async link(model) {
	        const path = urlJoin(this.$path, model.guid);
	        await this.$http.put(path);
	        this._model = model;
	      }

	      async get() {
	        if (this._model) {
	          return this._model;
	        }

	        const response = await this.$http.get(this.$path);
	        return this._model = this.$factory.getOrCreate(this.rootRelation, this.type, response.data);
	      }

	      set(data) {
	        if (!data.guid) {
	          throw Error('to_one.set data has not guid');
	        }

	        this._model = this.$factory.getOrCreate(this.rootRelation, this.type, data);
	      }

	      get rootRelation() {
	        if (this.parent !== this.$root) {
	          return this.$root.getRelation(this.type);
	        }

	        return this;
	      }

	    } // Add a getter so that the mixins can access methods and properties of the CrudToMany instance


	    class CrudToManyMixin {
	      constructor(instance) {
	        this.instance = instance;
	      }

	      get rootRelation() {
	        if (this.instance.parent !== this.instance.$root) {
	          return this.instance.$root.getRelation(this.instance.type);
	        }

	        return this.instance;
	      }

	      rawDataToModels(data, type = this.instance.type) {
	        return data.map(item => this.instance.$factory.getOrCreate(this.rootRelation, type, item));
	      }

	    }

	    CrudToManyMixin.mixin = '<mixin-name>';
	    CrudToManyMixin.routes = [];

	    class Sort extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getSortedPage = async request => {
	          const rawResponse = await this.instance.$http.get(this.instance.$path, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };
	      }
	      /**
	       *
	       * Used to reposition a model.
	       *
	       * @param model The model to reposition
	       * @param order Where to position the model relative to the anchor model
	       * @param anchor The model after (or before) which the given model will be positioned
	       *
	       */


	      async sortModel(model, order, anchor) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(anchor.guid), order, encodeURIComponent(model.guid));
	        await this.instance.$http.put(path);
	      }

	    }

	    Sort.mixin = 'sort';
	    Sort.routes = [{
	      method: 'PUT',
	      uri: 'sort'
	    }, {
	      method: 'GET|HEAD',
	      uri: ''
	    }];
	    /**
	     * CRUD mixin implementation of the Pickable interface
	     */

	    class Pick extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getPickerPage = async request => {
	          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick`, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };

	        this.linkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.put(path, models);
	        };

	        this.unlinkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.delete(path, {
	            data: models
	          });
	        };
	      }

	    }

	    Pick.mixin = 'pick';
	    Pick.routes = [{
	      method: 'GET|HEAD',
	      uri: 'pick'
	    }];
	    /**
	     * CRUD mixin implementation of the NestedPickable interface
	     */

	    class NestedPick extends CrudToManyMixin {
	      constructor() {
	        super(...arguments); // Returns the page of the sums pagination route

	        this.getPickerSumsPage = async request => {
	          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/sums`, {
	            params: request
	          }); // The PickerSumsModel's type is not part of the default CRUD structure at the moment,
	          // it is defined as an optional property in the CrudToManyConfig.

	          const type = this.instance._config.pickerSumsType; // Since this cannot be enforced with TypeScript at the moment, do a manual runtime check
	          // and throw when is is not defined.

	          if (!type) {
	            throw Error('pickerSumsType is not defined on ToMany config');
	          }

	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data, type)
	          };
	        }; // Returns the page of the nested pagination route, by PickerSumsModel.guid


	        this.getPickerNestedPage = async request => {
	          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/${request.guid}`, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };

	        this.linkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.put(path, models);
	        };

	        this.unlinkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.delete(path, {
	            data: models
	          });
	        };
	      }

	    }

	    NestedPick.mixin = 'multi_picker';
	    NestedPick.routes = [{
	      method: 'GET|HEAD',
	      uri: 'pick/sums'
	    }, {
	      method: 'GET|HEAD',
	      uri: 'pick/{id}'
	    }];

	    class Create extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.create = async (data, model) => {
	          try {
	            const response = await this.instance.$http.post(this.instance.$path, data);
	            model.setData(response.data);
	            this.instance.$factory.add(this.instance.type, model);
	          } catch (e) {
	            if (isCrudApiError(e) && e.response.status === 406) {
	              throw new CrudValidationError(e);
	            }

	            throw new UnexpectedError(e);
	          }
	        };
	      }

	      new(data) {
	        const newModel = this.instance.$factory.new(this.rootRelation, this.instance.type);

	        if (data) {
	          newModel.setData(data);
	        }

	        return newModel;
	      }

	    }

	    Create.mixin = 'create';
	    Create.routes = [{
	      method: 'POST',
	      uri: ''
	    }];

	    class Link extends CrudToManyMixin {
	      async link(model) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	        await this.instance.$http.put(path);
	      }

	    }

	    Link.mixin = 'link';
	    Link.routes = [{
	      method: 'PUT',
	      uri: '{id}'
	    }];

	    class LinkMulti extends CrudToManyMixin {
	      async linkMulti(models) {
	        const path = urlJoin(this.instance.$path, 'multi');
	        await this.instance.$http.put(path, models.map(model => model.guid));
	      }

	    }

	    LinkMulti.mixin = 'link_multi';
	    LinkMulti.routes = [{
	      method: 'PUT',
	      uri: 'multi'
	    }];

	    class Rules extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.rules = async () => {
	          if (this.instance.__rules) {
	            return this.instance.__rules;
	          }

	          const path = urlJoin(this.instance.$path, 'rules');
	          const response = await this.instance.$http.get(path);
	          return this.instance.__rules = response.data;
	        };
	      }

	    }

	    Rules.mixin = 'rules';
	    Rules.routes = [{
	      method: 'GET|HEAD',
	      uri: 'rules'
	    }];

	    class Delete extends CrudToManyMixin {
	      async delete(model) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	        await this.instance.$http.delete(path);
	      }

	    }

	    Delete.mixin = 'delete';
	    Delete.routes = [{
	      method: 'DELETE',
	      uri: '{id}'
	    }];

	    class List extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getPage = async request => {
	          const rawResponse = await this.instance.$http.get(this.instance.$path, {
	            params: request
	          });

	          this.instance._setAdditionalFields(rawResponse.data);

	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };
	      }

	      canOrder(field) {
	        if (!this.instance.__filters) {
	          return false;
	        }

	        for (const filter of Object.values(this.instance.__filters)) {
	          if (filter.target !== field) {
	            continue;
	          }

	          return filter.match === 'exact' || filter.match === 'partial';
	        }

	        return false;
	      }

	    }

	    List.mixin = 'list';
	    List.routes = [{
	      method: 'GET|HEAD',
	      uri: ''
	    }];

	    class ListAll extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getPageByType = async request => {
	          const rawResponse = await this.instance.$http.get(this.instance.$path, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };
	      }

	    }

	    ListAll.mixin = 'list_all';
	    ListAll.routes = [{
	      method: 'GET|HEAD',
	      uri: ''
	    }, {
	      method: 'GET|HEAD',
	      uri: 'list/{type}'
	    }];

	    class Reinstate extends CrudToManyMixin {
	      async reinstate(guid) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(guid), 'reinstate');
	        await this.instance.$http.post(path);
	      }

	    }

	    Reinstate.mixin = 'reinstate';
	    Reinstate.routes = [{
	      method: 'POST',
	      uri: '{id}/reinstate'
	    }];

	    class Unlink extends CrudToManyMixin {
	      async unlink(model) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	        await this.instance.$http.delete(path);
	      }

	    }

	    Unlink.mixin = 'detach';
	    Unlink.routes = [{
	      method: 'DELETE',
	      uri: '{id}'
	    }];

	    class UnlinkMulti extends CrudToManyMixin {
	      async unlinkMulti(models) {
	        const path = urlJoin(this.instance.$path, 'multi');
	        await this.instance.$http.delete(path, {
	          data: models.map(model => model.guid)
	        });
	      }

	    }

	    UnlinkMulti.mixin = 'unlink_multi';
	    UnlinkMulti.routes = [{
	      method: 'DELETE',
	      uri: 'multi'
	    }];

	    class Filters extends CrudToManyMixin {
	      async getFilters() {
	        if (this.instance.__filters) {
	          return this.instance.__filters;
	        }

	        const path = urlJoin(this.instance.$path, 'filters');
	        const response = await this.instance.$http.get(path);
	        return this.instance.__filters = response.data;
	      }

	    }

	    Filters.mixin = 'filters';
	    Filters.routes = [{
	      method: 'GET|HEAD',
	      uri: 'filters'
	    }];

	    class Get extends CrudToManyMixin {
	      async get(guid) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(guid));
	        const response = await this.instance.$http.get(path);
	        return this.instance.$factory.getOrCreate(this.rootRelation, this.instance.type, response.data);
	      }

	    }

	    Get.mixin = 'get';
	    Get.routes = [{
	      method: 'GET|HEAD',
	      uri: '{id}'
	    }];

	    class Update extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.update = async (data, model) => {
	          try {
	            const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	            await this.instance.$http.patch(path, data);
	            model.setData(data);
	          } catch (e) {
	            if (isCrudApiError(e) && e.response.status === 406) {
	              throw new CrudValidationError(e);
	            }

	            throw new UnexpectedError(e);
	          }
	        };
	      }

	    }

	    Update.mixin = 'update';
	    Update.routes = [{
	      method: 'PATCH',
	      uri: '{id}'
	    }];
	    var index = /*#__PURE__*/Object.freeze({
	      __proto__: null,
	      Sort: Sort,
	      Pick: Pick,
	      NestedPick: NestedPick,
	      Create: Create,
	      Link: Link,
	      LinkMulti: LinkMulti,
	      Rules: Rules,
	      Delete: Delete,
	      List: List,
	      ListAll: ListAll,
	      Reinstate: Reinstate,
	      Unlink: Unlink,
	      UnlinkMulti: UnlinkMulti,
	      Filters: Filters,
	      Get: Get,
	      Update: Update
	    });

	    function toMany(parent, type, config) {
	      return new CrudToMany(parent, type, config);
	    }

	    class CrudToMany extends CrudNode {
	      constructor(parent, type, config) {
	        super(parent, type); // Contains the identifiers of the applied mixins

	        this.mixins = []; // Relation cache

	        this.__cache = {}; // Registered routes from the applied mixins

	        this._mixinRoutes = [];
	        this._config = config; // Add mixin helpers

	        this._applyMixin(CrudToManyMixin);
	      }

	      get $path() {
	        return urlJoin(this._parent.$path, this._config.path);
	      }

	      get $routes() {
	        const routes = [];
	        routes.push(...this._mixinRoutes);

	        if (this.parent === this.$root) {
	          const data = {
	            guid: '{id}',
	            created_at: '',
	            updated_at: ''
	          };
	          const model = this.$factory.getOrCreate(this, this.type, data);
	          routes.push(...model.$routes);
	        }

	        return routes;
	      }

	      with(ctor) {
	        // Keep track of applied mixins
	        this.mixins.push(ctor.mixin); // Add base path to mixin routes

	        const routes = ctor.routes.map(route => ({
	          method: route.method,
	          uri: urlJoin(this.$path, route.uri)
	        })); // Save the routes

	        this._mixinRoutes.push(...routes); // Copy prototype keys


	        this._applyMixin(ctor);

	        return this;
	      }

	      _applyMixin(constructor) {
	        const instance = this; // Reference: https://www.typescriptlang.org/docs/handbook/mixins.html
	        // Set properties

	        const mixinInstance = new constructor(instance);
	        Object.getOwnPropertyNames(mixinInstance).forEach(name => {
	          if (instance[name] === undefined) {
	            Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(mixinInstance, name) || Object.create(null));
	          }
	        }); // Set methods

	        Object.getOwnPropertyNames(constructor.prototype).forEach(name => {
	          if (instance[name] === undefined) {
	            Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(constructor.prototype, name) || Object.create(null));
	          }
	        });
	        return this;
	      }

	      _setAdditionalFields(response) {
	        this.__appends = this.__appends || response.__appends;
	        this.__filters = this.__filters || response.__filters;
	        this.__includes = this.__includes || response.__includes;
	        this.__rules = this.__rules || response.__rules;
	      }

	    }

	    exports.CrudModelPropType = void 0;

	    (function (CrudModelPropType) {
	      CrudModelPropType["String"] = "string";
	      CrudModelPropType["Boolean"] = "boolean";
	      CrudModelPropType["Number"] = "number";
	      CrudModelPropType["Date"] = "date";
	      CrudModelPropType["Array"] = "array";
	    })(exports.CrudModelPropType || (exports.CrudModelPropType = {}));

	    const CrudModelProps = {
	      guid: exports.CrudModelPropType.String
	    };

	    class CrudModel extends CrudNode {
	      constructor(parent, type, config) {
	        super(parent, type);

	        if (parent !== this.$root && parent.parent !== this.$root) {
	          throw Error(`Invalid parent for model of type ${type}`);
	        }

	        this._props = CrudModel.parsePropConfig({ ...config.props,
	          ...CrudModelProps
	        });
	        this.raw = { ...config.data
	        }; // Here

	        this.props = this._getPropValues(this._props, config.data);
	        this._config = config;
	      }

	      static parsePropConfig(config) {
	        const props = {};
	        Object.keys(config).forEach(key => {
	          let propConfig = config[key];

	          if (typeof propConfig !== 'object') {
	            propConfig = {
	              type: propConfig
	            };
	          }

	          props[key] = {
	            type: propConfig.type,
	            default: propConfig.default !== undefined ? propConfig.default : null,
	            props: propConfig.props,
	            value: null,
	            rules: propConfig.rules || []
	          };
	        });
	        return props;
	      }

	      get guid() {
	        return this.props.guid;
	      }

	      get isNew() {
	        return !this.props.guid;
	      }

	      get $path() {
	        if (this.parent instanceof CrudToMany && this.props.guid) {
	          return urlJoin(this.parent.$path, encodeURIComponent(this.props.guid));
	        }

	        return urlJoin(this.parent.$path, this.type);
	      }

	      get $routes() {
	        const routes = [];

	        for (const node of Object.values(this)) {
	          if (node instanceof CrudNode && node !== this.parent) {
	            routes.push(...node.$routes);
	          }
	        }

	        return routes;
	      }

	      setData(data) {
	        Object.keys(data).forEach(strKey => {
	          const key = strKey;
	          this.props[key] = data[key];
	        });
	      }

	      _getPropValues(props, data) {
	        const _props = {};

	        for (const key of Object.keys(props)) {
	          if (data && data[key] !== undefined) {
	            _props[key] = data[key];
	          } else {
	            _props[key] = props[key].value;
	          }
	        }

	        return _props;
	      }

	    }

	    CrudModel.type = '<type>';
	    CrudModel.props = CrudModel.parsePropConfig(CrudModelProps);

	    class CrudFactory {
	      constructor(config) {
	        this._blueprints = {};
	        this._cache = {};
	        this._config = config;

	        for (const blueprint of config.models) {
	          this._blueprints[blueprint.type] = blueprint;
	          this._cache[blueprint.type] = {};
	        }
	      }

	      new(parent, type) {
	        return new this._blueprints[type](parent);
	      }

	      add(type, model) {
	        if (!model.props.guid) {
	          throw Error('No guid set on model');
	        }

	        this._cache[type][model.props.guid] = model;
	      }

	      getOrCreate(parent, type, data) {
	        let model = this._cache[type][data.guid];

	        if (model) {
	          model.setData(data);
	          return model;
	        }

	        model = new this._blueprints[type](parent, data);
	        this.add(type, model);
	        return model;
	      }

	    }

	    var axios$2 = {
	      exports: {}
	    };

	    var bind$2 = function bind(fn, thisArg) {
	      return function wrap() {
	        var args = new Array(arguments.length);

	        for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i];
	        }

	        return fn.apply(thisArg, args);
	      };
	    };

	    var bind$1 = bind$2; // utils is a library of generic helper functions non-specific to axios

	    var toString = Object.prototype.toString;
	    /**
	     * Determine if a value is an Array
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an Array, otherwise false
	     */

	    function isArray(val) {
	      return toString.call(val) === '[object Array]';
	    }
	    /**
	     * Determine if a value is undefined
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if the value is undefined, otherwise false
	     */


	    function isUndefined(val) {
	      return typeof val === 'undefined';
	    }
	    /**
	     * Determine if a value is a Buffer
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Buffer, otherwise false
	     */


	    function isBuffer(val) {
	      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	    }
	    /**
	     * Determine if a value is an ArrayBuffer
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	     */


	    function isArrayBuffer(val) {
	      return toString.call(val) === '[object ArrayBuffer]';
	    }
	    /**
	     * Determine if a value is a FormData
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an FormData, otherwise false
	     */


	    function isFormData(val) {
	      return typeof FormData !== 'undefined' && val instanceof FormData;
	    }
	    /**
	     * Determine if a value is a view on an ArrayBuffer
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	     */


	    function isArrayBufferView(val) {
	      var result;

	      if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	        result = ArrayBuffer.isView(val);
	      } else {
	        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
	      }

	      return result;
	    }
	    /**
	     * Determine if a value is a String
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a String, otherwise false
	     */


	    function isString(val) {
	      return typeof val === 'string';
	    }
	    /**
	     * Determine if a value is a Number
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Number, otherwise false
	     */


	    function isNumber(val) {
	      return typeof val === 'number';
	    }
	    /**
	     * Determine if a value is an Object
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an Object, otherwise false
	     */


	    function isObject(val) {
	      return val !== null && typeof val === 'object';
	    }
	    /**
	     * Determine if a value is a plain Object
	     *
	     * @param {Object} val The value to test
	     * @return {boolean} True if value is a plain Object, otherwise false
	     */


	    function isPlainObject(val) {
	      if (toString.call(val) !== '[object Object]') {
	        return false;
	      }

	      var prototype = Object.getPrototypeOf(val);
	      return prototype === null || prototype === Object.prototype;
	    }
	    /**
	     * Determine if a value is a Date
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Date, otherwise false
	     */


	    function isDate(val) {
	      return toString.call(val) === '[object Date]';
	    }
	    /**
	     * Determine if a value is a File
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a File, otherwise false
	     */


	    function isFile(val) {
	      return toString.call(val) === '[object File]';
	    }
	    /**
	     * Determine if a value is a Blob
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Blob, otherwise false
	     */


	    function isBlob(val) {
	      return toString.call(val) === '[object Blob]';
	    }
	    /**
	     * Determine if a value is a Function
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Function, otherwise false
	     */


	    function isFunction(val) {
	      return toString.call(val) === '[object Function]';
	    }
	    /**
	     * Determine if a value is a Stream
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Stream, otherwise false
	     */


	    function isStream(val) {
	      return isObject(val) && isFunction(val.pipe);
	    }
	    /**
	     * Determine if a value is a URLSearchParams object
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	     */


	    function isURLSearchParams(val) {
	      return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	    }
	    /**
	     * Trim excess whitespace off the beginning and end of a string
	     *
	     * @param {String} str The String to trim
	     * @returns {String} The String freed of excess whitespace
	     */


	    function trim(str) {
	      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	    }
	    /**
	     * Determine if we're running in a standard browser environment
	     *
	     * This allows axios to run in a web worker, and react-native.
	     * Both environments support XMLHttpRequest, but not fully standard globals.
	     *
	     * web workers:
	     *  typeof window -> undefined
	     *  typeof document -> undefined
	     *
	     * react-native:
	     *  navigator.product -> 'ReactNative'
	     * nativescript
	     *  navigator.product -> 'NativeScript' or 'NS'
	     */


	    function isStandardBrowserEnv() {
	      if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
	        return false;
	      }

	      return typeof window !== 'undefined' && typeof document !== 'undefined';
	    }
	    /**
	     * Iterate over an Array or an Object invoking a function for each item.
	     *
	     * If `obj` is an Array callback will be called passing
	     * the value, index, and complete array for each item.
	     *
	     * If 'obj' is an Object callback will be called passing
	     * the value, key, and complete object for each property.
	     *
	     * @param {Object|Array} obj The object to iterate
	     * @param {Function} fn The callback to invoke for each item
	     */


	    function forEach(obj, fn) {
	      // Don't bother if no value provided
	      if (obj === null || typeof obj === 'undefined') {
	        return;
	      } // Force an array if not already something iterable


	      if (typeof obj !== 'object') {
	        /*eslint no-param-reassign:0*/
	        obj = [obj];
	      }

	      if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	          fn.call(null, obj[i], i, obj);
	        }
	      } else {
	        // Iterate over object keys
	        for (var key in obj) {
	          if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn.call(null, obj[key], key, obj);
	          }
	        }
	      }
	    }
	    /**
	     * Accepts varargs expecting each argument to be an object, then
	     * immutably merges the properties of each object and returns result.
	     *
	     * When multiple objects contain the same key the later object in
	     * the arguments list will take precedence.
	     *
	     * Example:
	     *
	     * ```js
	     * var result = merge({foo: 123}, {foo: 456});
	     * console.log(result.foo); // outputs 456
	     * ```
	     *
	     * @param {Object} obj1 Object to merge
	     * @returns {Object} Result of all merge properties
	     */


	    function
	    /* obj1, obj2, obj3, ... */
	    merge() {
	      var result = {};

	      function assignValue(val, key) {
	        if (isPlainObject(result[key]) && isPlainObject(val)) {
	          result[key] = merge(result[key], val);
	        } else if (isPlainObject(val)) {
	          result[key] = merge({}, val);
	        } else if (isArray(val)) {
	          result[key] = val.slice();
	        } else {
	          result[key] = val;
	        }
	      }

	      for (var i = 0, l = arguments.length; i < l; i++) {
	        forEach(arguments[i], assignValue);
	      }

	      return result;
	    }
	    /**
	     * Extends object a by mutably adding to it the properties of object b.
	     *
	     * @param {Object} a The object to be extended
	     * @param {Object} b The object to copy properties from
	     * @param {Object} thisArg The object to bind function to
	     * @return {Object} The resulting value of object a
	     */


	    function extend(a, b, thisArg) {
	      forEach(b, function assignValue(val, key) {
	        if (thisArg && typeof val === 'function') {
	          a[key] = bind$1(val, thisArg);
	        } else {
	          a[key] = val;
	        }
	      });
	      return a;
	    }
	    /**
	     * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	     *
	     * @param {string} content with BOM
	     * @return {string} content value without BOM
	     */


	    function stripBOM(content) {
	      if (content.charCodeAt(0) === 0xFEFF) {
	        content = content.slice(1);
	      }

	      return content;
	    }

	    var utils$d = {
	      isArray: isArray,
	      isArrayBuffer: isArrayBuffer,
	      isBuffer: isBuffer,
	      isFormData: isFormData,
	      isArrayBufferView: isArrayBufferView,
	      isString: isString,
	      isNumber: isNumber,
	      isObject: isObject,
	      isPlainObject: isPlainObject,
	      isUndefined: isUndefined,
	      isDate: isDate,
	      isFile: isFile,
	      isBlob: isBlob,
	      isFunction: isFunction,
	      isStream: isStream,
	      isURLSearchParams: isURLSearchParams,
	      isStandardBrowserEnv: isStandardBrowserEnv,
	      forEach: forEach,
	      merge: merge,
	      extend: extend,
	      trim: trim,
	      stripBOM: stripBOM
	    };
	    var utils$c = utils$d;

	    function encode(val) {
	      return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	    }
	    /**
	     * Build a URL by appending params to the end
	     *
	     * @param {string} url The base of the url (e.g., http://www.google.com)
	     * @param {object} [params] The params to be appended
	     * @returns {string} The formatted url
	     */


	    var buildURL$2 = function buildURL(url, params, paramsSerializer) {
	      /*eslint no-param-reassign:0*/
	      if (!params) {
	        return url;
	      }

	      var serializedParams;

	      if (paramsSerializer) {
	        serializedParams = paramsSerializer(params);
	      } else if (utils$c.isURLSearchParams(params)) {
	        serializedParams = params.toString();
	      } else {
	        var parts = [];
	        utils$c.forEach(params, function serialize(val, key) {
	          if (val === null || typeof val === 'undefined') {
	            return;
	          }

	          if (utils$c.isArray(val)) {
	            key = key + '[]';
	          } else {
	            val = [val];
	          }

	          utils$c.forEach(val, function parseValue(v) {
	            if (utils$c.isDate(v)) {
	              v = v.toISOString();
	            } else if (utils$c.isObject(v)) {
	              v = JSON.stringify(v);
	            }

	            parts.push(encode(key) + '=' + encode(v));
	          });
	        });
	        serializedParams = parts.join('&');
	      }

	      if (serializedParams) {
	        var hashmarkIndex = url.indexOf('#');

	        if (hashmarkIndex !== -1) {
	          url = url.slice(0, hashmarkIndex);
	        }

	        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	      }

	      return url;
	    };

	    var utils$b = utils$d;

	    function InterceptorManager$1() {
	      this.handlers = [];
	    }
	    /**
	     * Add a new interceptor to the stack
	     *
	     * @param {Function} fulfilled The function to handle `then` for a `Promise`
	     * @param {Function} rejected The function to handle `reject` for a `Promise`
	     *
	     * @return {Number} An ID used to remove interceptor later
	     */


	    InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
	      this.handlers.push({
	        fulfilled: fulfilled,
	        rejected: rejected,
	        synchronous: options ? options.synchronous : false,
	        runWhen: options ? options.runWhen : null
	      });
	      return this.handlers.length - 1;
	    };
	    /**
	     * Remove an interceptor from the stack
	     *
	     * @param {Number} id The ID that was returned by `use`
	     */


	    InterceptorManager$1.prototype.eject = function eject(id) {
	      if (this.handlers[id]) {
	        this.handlers[id] = null;
	      }
	    };
	    /**
	     * Iterate over all the registered interceptors
	     *
	     * This method is particularly useful for skipping over any
	     * interceptors that may have become `null` calling `eject`.
	     *
	     * @param {Function} fn The function to call for each interceptor
	     */


	    InterceptorManager$1.prototype.forEach = function forEach(fn) {
	      utils$b.forEach(this.handlers, function forEachHandler(h) {
	        if (h !== null) {
	          fn(h);
	        }
	      });
	    };

	    var InterceptorManager_1 = InterceptorManager$1;
	    var utils$a = utils$d;

	    var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
	      utils$a.forEach(headers, function processHeader(value, name) {
	        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	          headers[normalizedName] = value;
	          delete headers[name];
	        }
	      });
	    };
	    /**
	     * Update an Error with the specified config, error code, and response.
	     *
	     * @param {Error} error The error to update.
	     * @param {Object} config The config.
	     * @param {string} [code] The error code (for example, 'ECONNABORTED').
	     * @param {Object} [request] The request.
	     * @param {Object} [response] The response.
	     * @returns {Error} The error.
	     */


	    var enhanceError$2 = function enhanceError(error, config, code, request, response) {
	      error.config = config;

	      if (code) {
	        error.code = code;
	      }

	      error.request = request;
	      error.response = response;
	      error.isAxiosError = true;

	      error.toJSON = function toJSON() {
	        return {
	          // Standard
	          message: this.message,
	          name: this.name,
	          // Microsoft
	          description: this.description,
	          number: this.number,
	          // Mozilla
	          fileName: this.fileName,
	          lineNumber: this.lineNumber,
	          columnNumber: this.columnNumber,
	          stack: this.stack,
	          // Axios
	          config: this.config,
	          code: this.code,
	          status: this.response && this.response.status ? this.response.status : null
	        };
	      };

	      return error;
	    };

	    var enhanceError$1 = enhanceError$2;
	    /**
	     * Create an Error with the specified message, config, error code, request and response.
	     *
	     * @param {string} message The error message.
	     * @param {Object} config The config.
	     * @param {string} [code] The error code (for example, 'ECONNABORTED').
	     * @param {Object} [request] The request.
	     * @param {Object} [response] The response.
	     * @returns {Error} The created error.
	     */

	    var createError$2 = function createError(message, config, code, request, response) {
	      var error = new Error(message);
	      return enhanceError$1(error, config, code, request, response);
	    };

	    var createError$1 = createError$2;
	    /**
	     * Resolve or reject a Promise based on response status.
	     *
	     * @param {Function} resolve A function that resolves the promise.
	     * @param {Function} reject A function that rejects the promise.
	     * @param {object} response The response.
	     */

	    var settle$1 = function settle(resolve, reject, response) {
	      var validateStatus = response.config.validateStatus;

	      if (!response.status || !validateStatus || validateStatus(response.status)) {
	        resolve(response);
	      } else {
	        reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
	      }
	    };

	    var utils$9 = utils$d;
	    var cookies$1 = utils$9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
	    function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils$9.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils$9.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils$9.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return match ? decodeURIComponent(match[3]) : null;
	        },
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    }() : // Non standard browser env (web workers, react-native) lack needed support.
	    function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() {
	          return null;
	        },
	        remove: function remove() {}
	      };
	    }();
	    /**
	     * Determines whether the specified URL is absolute
	     *
	     * @param {string} url The URL to test
	     * @returns {boolean} True if the specified URL is absolute, otherwise false
	     */

	    var isAbsoluteURL$1 = function isAbsoluteURL(url) {
	      // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	      // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	      // by any combination of letters, digits, plus, period, or hyphen.
	      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	    };
	    /**
	     * Creates a new URL by combining the specified URLs
	     *
	     * @param {string} baseURL The base URL
	     * @param {string} relativeURL The relative URL
	     * @returns {string} The combined URL
	     */


	    var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
	      return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
	    };

	    var isAbsoluteURL = isAbsoluteURL$1;
	    var combineURLs = combineURLs$1;
	    /**
	     * Creates a new URL by combining the baseURL with the requestedURL,
	     * only when the requestedURL is not already an absolute URL.
	     * If the requestURL is absolute, this function returns the requestedURL untouched.
	     *
	     * @param {string} baseURL The base URL
	     * @param {string} requestedURL Absolute or relative URL to combine
	     * @returns {string} The combined full path
	     */

	    var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
	      if (baseURL && !isAbsoluteURL(requestedURL)) {
	        return combineURLs(baseURL, requestedURL);
	      }

	      return requestedURL;
	    };

	    var utils$8 = utils$d; // Headers whose duplicates are ignored by node
	    // c.f. https://nodejs.org/api/http.html#http_message_headers

	    var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
	    /**
	     * Parse headers into an object
	     *
	     * ```
	     * Date: Wed, 27 Aug 2014 08:58:49 GMT
	     * Content-Type: application/json
	     * Connection: keep-alive
	     * Transfer-Encoding: chunked
	     * ```
	     *
	     * @param {String} headers Headers needing to be parsed
	     * @returns {Object} Headers parsed into an object
	     */

	    var parseHeaders$1 = function parseHeaders(headers) {
	      var parsed = {};
	      var key;
	      var val;
	      var i;

	      if (!headers) {
	        return parsed;
	      }

	      utils$8.forEach(headers.split('\n'), function parser(line) {
	        i = line.indexOf(':');
	        key = utils$8.trim(line.substr(0, i)).toLowerCase();
	        val = utils$8.trim(line.substr(i + 1));

	        if (key) {
	          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	            return;
	          }

	          if (key === 'set-cookie') {
	            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	          } else {
	            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	          }
	        }
	      });
	      return parsed;
	    };

	    var utils$7 = utils$d;
	    var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
	    // whether the request URL is of the same origin as current location.
	    function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	      /**
	      * Parse a URL to discover it's components
	      *
	      * @param {String} url The URL to be parsed
	      * @returns {Object}
	      */

	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	          // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);
	      /**
	      * Determine if a URL shares the same origin as the current location
	      *
	      * @param {String} requestURL The URL to test
	      * @returns {boolean} True if URL shares the same origin, otherwise false
	      */

	      return function isURLSameOrigin(requestURL) {
	        var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
	        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
	      };
	    }() : // Non standard browser envs (web workers, react-native) lack needed support.
	    function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    }();
	    /**
	     * A `Cancel` is an object that is thrown when an operation is canceled.
	     *
	     * @class
	     * @param {string=} message The message.
	     */

	    function Cancel$3(message) {
	      this.message = message;
	    }

	    Cancel$3.prototype.toString = function toString() {
	      return 'Cancel' + (this.message ? ': ' + this.message : '');
	    };

	    Cancel$3.prototype.__CANCEL__ = true;
	    var Cancel_1 = Cancel$3;
	    var utils$6 = utils$d;
	    var settle = settle$1;
	    var cookies = cookies$1;
	    var buildURL$1 = buildURL$2;
	    var buildFullPath = buildFullPath$1;
	    var parseHeaders = parseHeaders$1;
	    var isURLSameOrigin = isURLSameOrigin$1;
	    var createError = createError$2;
	    var defaults$4 = defaults_1;
	    var Cancel$2 = Cancel_1;

	    var xhr = function xhrAdapter(config) {
	      return new Promise(function dispatchXhrRequest(resolve, reject) {
	        var requestData = config.data;
	        var requestHeaders = config.headers;
	        var responseType = config.responseType;
	        var onCanceled;

	        function done() {
	          if (config.cancelToken) {
	            config.cancelToken.unsubscribe(onCanceled);
	          }

	          if (config.signal) {
	            config.signal.removeEventListener('abort', onCanceled);
	          }
	        }

	        if (utils$6.isFormData(requestData)) {
	          delete requestHeaders['Content-Type']; // Let the browser set it
	        }

	        var request = new XMLHttpRequest(); // HTTP basic authentication

	        if (config.auth) {
	          var username = config.auth.username || '';
	          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	          requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	        }

	        var fullPath = buildFullPath(config.baseURL, config.url);
	        request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

	        request.timeout = config.timeout;

	        function onloadend() {
	          if (!request) {
	            return;
	          } // Prepare the response


	          var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	          var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
	          var response = {
	            data: responseData,
	            status: request.status,
	            statusText: request.statusText,
	            headers: responseHeaders,
	            config: config,
	            request: request
	          };
	          settle(function _resolve(value) {
	            resolve(value);
	            done();
	          }, function _reject(err) {
	            reject(err);
	            done();
	          }, response); // Clean up request

	          request = null;
	        }

	        if ('onloadend' in request) {
	          // Use onloadend if available
	          request.onloadend = onloadend;
	        } else {
	          // Listen for ready state to emulate onloadend
	          request.onreadystatechange = function handleLoad() {
	            if (!request || request.readyState !== 4) {
	              return;
	            } // The request errored out and we didn't get a response, this will be
	            // handled by onerror instead
	            // With one exception: request that using file: protocol, most browsers
	            // will return status as 0 even though it's a successful request


	            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	              return;
	            } // readystate handler is calling before onerror or ontimeout handlers,
	            // so we should call onloadend on the next 'tick'


	            setTimeout(onloadend);
	          };
	        } // Handle browser request cancellation (as opposed to a manual cancellation)


	        request.onabort = function handleAbort() {
	          if (!request) {
	            return;
	          }

	          reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

	          request = null;
	        }; // Handle low level network errors


	        request.onerror = function handleError() {
	          // Real errors are hidden from us by the browser
	          // onerror should only fire if it's a network error
	          reject(createError('Network Error', config, null, request)); // Clean up request

	          request = null;
	        }; // Handle timeout


	        request.ontimeout = function handleTimeout() {
	          var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	          var transitional = config.transitional || defaults$4.transitional;

	          if (config.timeoutErrorMessage) {
	            timeoutErrorMessage = config.timeoutErrorMessage;
	          }

	          reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

	          request = null;
	        }; // Add xsrf header
	        // This is only done if running in a standard browser environment.
	        // Specifically not if we're in a web worker, or react-native.


	        if (utils$6.isStandardBrowserEnv()) {
	          // Add xsrf header
	          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

	          if (xsrfValue) {
	            requestHeaders[config.xsrfHeaderName] = xsrfValue;
	          }
	        } // Add headers to the request


	        if ('setRequestHeader' in request) {
	          utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
	            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	              // Remove Content-Type if data is undefined
	              delete requestHeaders[key];
	            } else {
	              // Otherwise add header to the request
	              request.setRequestHeader(key, val);
	            }
	          });
	        } // Add withCredentials to request if needed


	        if (!utils$6.isUndefined(config.withCredentials)) {
	          request.withCredentials = !!config.withCredentials;
	        } // Add responseType to request if needed


	        if (responseType && responseType !== 'json') {
	          request.responseType = config.responseType;
	        } // Handle progress if needed


	        if (typeof config.onDownloadProgress === 'function') {
	          request.addEventListener('progress', config.onDownloadProgress);
	        } // Not all browsers support upload events


	        if (typeof config.onUploadProgress === 'function' && request.upload) {
	          request.upload.addEventListener('progress', config.onUploadProgress);
	        }

	        if (config.cancelToken || config.signal) {
	          // Handle cancellation
	          // eslint-disable-next-line func-names
	          onCanceled = function (cancel) {
	            if (!request) {
	              return;
	            }

	            reject(!cancel || cancel && cancel.type ? new Cancel$2('canceled') : cancel);
	            request.abort();
	            request = null;
	          };

	          config.cancelToken && config.cancelToken.subscribe(onCanceled);

	          if (config.signal) {
	            config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	          }
	        }

	        if (!requestData) {
	          requestData = null;
	        } // Send the request


	        request.send(requestData);
	      });
	    };

	    var utils$5 = utils$d;
	    var normalizeHeaderName = normalizeHeaderName$1;
	    var enhanceError = enhanceError$2;
	    var DEFAULT_CONTENT_TYPE = {
	      'Content-Type': 'application/x-www-form-urlencoded'
	    };

	    function setContentTypeIfUnset(headers, value) {
	      if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
	        headers['Content-Type'] = value;
	      }
	    }

	    function getDefaultAdapter() {
	      var adapter;

	      if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = xhr;
	      } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	        // For node use HTTP adapter
	        adapter = xhr;
	      }

	      return adapter;
	    }

	    function stringifySafely(rawValue, parser, encoder) {
	      if (utils$5.isString(rawValue)) {
	        try {
	          (parser || JSON.parse)(rawValue);
	          return utils$5.trim(rawValue);
	        } catch (e) {
	          if (e.name !== 'SyntaxError') {
	            throw e;
	          }
	        }
	      }

	      return (encoder || JSON.stringify)(rawValue);
	    }

	    var defaults$3 = {
	      transitional: {
	        silentJSONParsing: true,
	        forcedJSONParsing: true,
	        clarifyTimeoutError: false
	      },
	      adapter: getDefaultAdapter(),
	      transformRequest: [function transformRequest(data, headers) {
	        normalizeHeaderName(headers, 'Accept');
	        normalizeHeaderName(headers, 'Content-Type');

	        if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
	          return data;
	        }

	        if (utils$5.isArrayBufferView(data)) {
	          return data.buffer;
	        }

	        if (utils$5.isURLSearchParams(data)) {
	          setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	          return data.toString();
	        }

	        if (utils$5.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
	          setContentTypeIfUnset(headers, 'application/json');
	          return stringifySafely(data);
	        }

	        return data;
	      }],
	      transformResponse: [function transformResponse(data) {
	        var transitional = this.transitional || defaults$3.transitional;
	        var silentJSONParsing = transitional && transitional.silentJSONParsing;
	        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	        var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

	        if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
	          try {
	            return JSON.parse(data);
	          } catch (e) {
	            if (strictJSONParsing) {
	              if (e.name === 'SyntaxError') {
	                throw enhanceError(e, this, 'E_JSON_PARSE');
	              }

	              throw e;
	            }
	          }
	        }

	        return data;
	      }],

	      /**
	       * A timeout in milliseconds to abort a request. If set to 0 (default) a
	       * timeout is not created.
	       */
	      timeout: 0,
	      xsrfCookieName: 'XSRF-TOKEN',
	      xsrfHeaderName: 'X-XSRF-TOKEN',
	      maxContentLength: -1,
	      maxBodyLength: -1,
	      validateStatus: function validateStatus(status) {
	        return status >= 200 && status < 300;
	      },
	      headers: {
	        common: {
	          'Accept': 'application/json, text/plain, */*'
	        }
	      }
	    };
	    utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	      defaults$3.headers[method] = {};
	    });
	    utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	      defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
	    });
	    var defaults_1 = defaults$3;
	    var utils$4 = utils$d;
	    var defaults$2 = defaults_1;
	    /**
	     * Transform the data for a request or a response
	     *
	     * @param {Object|String} data The data to be transformed
	     * @param {Array} headers The headers for the request or response
	     * @param {Array|Function} fns A single function or Array of functions
	     * @returns {*} The resulting transformed data
	     */

	    var transformData$1 = function transformData(data, headers, fns) {
	      var context = this || defaults$2;
	      /*eslint no-param-reassign:0*/

	      utils$4.forEach(fns, function transform(fn) {
	        data = fn.call(context, data, headers);
	      });
	      return data;
	    };

	    var isCancel$1 = function isCancel(value) {
	      return !!(value && value.__CANCEL__);
	    };

	    var utils$3 = utils$d;
	    var transformData = transformData$1;
	    var isCancel = isCancel$1;
	    var defaults$1 = defaults_1;
	    var Cancel$1 = Cancel_1;
	    /**
	     * Throws a `Cancel` if cancellation has been requested.
	     */

	    function throwIfCancellationRequested(config) {
	      if (config.cancelToken) {
	        config.cancelToken.throwIfRequested();
	      }

	      if (config.signal && config.signal.aborted) {
	        throw new Cancel$1('canceled');
	      }
	    }
	    /**
	     * Dispatch a request to the server using the configured adapter.
	     *
	     * @param {object} config The config that is to be used for the request
	     * @returns {Promise} The Promise to be fulfilled
	     */


	    var dispatchRequest$1 = function dispatchRequest(config) {
	      throwIfCancellationRequested(config); // Ensure headers exist

	      config.headers = config.headers || {}; // Transform request data

	      config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

	      config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
	      utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
	        delete config.headers[method];
	      });
	      var adapter = config.adapter || defaults$1.adapter;
	      return adapter(config).then(function onAdapterResolution(response) {
	        throwIfCancellationRequested(config); // Transform response data

	        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
	        return response;
	      }, function onAdapterRejection(reason) {
	        if (!isCancel(reason)) {
	          throwIfCancellationRequested(config); // Transform response data

	          if (reason && reason.response) {
	            reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
	          }
	        }

	        return Promise.reject(reason);
	      });
	    };

	    var utils$2 = utils$d;
	    /**
	     * Config-specific merge-function which creates a new config-object
	     * by merging two configuration objects together.
	     *
	     * @param {Object} config1
	     * @param {Object} config2
	     * @returns {Object} New object resulting from merging config2 to config1
	     */

	    var mergeConfig$2 = function mergeConfig(config1, config2) {
	      // eslint-disable-next-line no-param-reassign
	      config2 = config2 || {};
	      var config = {};

	      function getMergedValue(target, source) {
	        if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
	          return utils$2.merge(target, source);
	        } else if (utils$2.isPlainObject(source)) {
	          return utils$2.merge({}, source);
	        } else if (utils$2.isArray(source)) {
	          return source.slice();
	        }

	        return source;
	      } // eslint-disable-next-line consistent-return


	      function mergeDeepProperties(prop) {
	        if (!utils$2.isUndefined(config2[prop])) {
	          return getMergedValue(config1[prop], config2[prop]);
	        } else if (!utils$2.isUndefined(config1[prop])) {
	          return getMergedValue(undefined, config1[prop]);
	        }
	      } // eslint-disable-next-line consistent-return


	      function valueFromConfig2(prop) {
	        if (!utils$2.isUndefined(config2[prop])) {
	          return getMergedValue(undefined, config2[prop]);
	        }
	      } // eslint-disable-next-line consistent-return


	      function defaultToConfig2(prop) {
	        if (!utils$2.isUndefined(config2[prop])) {
	          return getMergedValue(undefined, config2[prop]);
	        } else if (!utils$2.isUndefined(config1[prop])) {
	          return getMergedValue(undefined, config1[prop]);
	        }
	      } // eslint-disable-next-line consistent-return


	      function mergeDirectKeys(prop) {
	        if (prop in config2) {
	          return getMergedValue(config1[prop], config2[prop]);
	        } else if (prop in config1) {
	          return getMergedValue(undefined, config1[prop]);
	        }
	      }

	      var mergeMap = {
	        'url': valueFromConfig2,
	        'method': valueFromConfig2,
	        'data': valueFromConfig2,
	        'baseURL': defaultToConfig2,
	        'transformRequest': defaultToConfig2,
	        'transformResponse': defaultToConfig2,
	        'paramsSerializer': defaultToConfig2,
	        'timeout': defaultToConfig2,
	        'timeoutMessage': defaultToConfig2,
	        'withCredentials': defaultToConfig2,
	        'adapter': defaultToConfig2,
	        'responseType': defaultToConfig2,
	        'xsrfCookieName': defaultToConfig2,
	        'xsrfHeaderName': defaultToConfig2,
	        'onUploadProgress': defaultToConfig2,
	        'onDownloadProgress': defaultToConfig2,
	        'decompress': defaultToConfig2,
	        'maxContentLength': defaultToConfig2,
	        'maxBodyLength': defaultToConfig2,
	        'transport': defaultToConfig2,
	        'httpAgent': defaultToConfig2,
	        'httpsAgent': defaultToConfig2,
	        'cancelToken': defaultToConfig2,
	        'socketPath': defaultToConfig2,
	        'responseEncoding': defaultToConfig2,
	        'validateStatus': mergeDirectKeys
	      };
	      utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	        var merge = mergeMap[prop] || mergeDeepProperties;
	        var configValue = merge(prop);
	        utils$2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
	      });
	      return config;
	    };

	    var data = {
	      "version": "0.24.0"
	    };
	    var VERSION = data.version;
	    var validators$1 = {}; // eslint-disable-next-line func-names

	    ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
	      validators$1[type] = function validator(thing) {
	        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	      };
	    });
	    var deprecatedWarnings = {};
	    /**
	     * Transitional option validator
	     * @param {function|boolean?} validator - set to false if the transitional option has been removed
	     * @param {string?} version - deprecated version / removed since version
	     * @param {string?} message - some message with additional info
	     * @returns {function}
	     */

	    validators$1.transitional = function transitional(validator, version, message) {
	      function formatMessage(opt, desc) {
	        return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	      } // eslint-disable-next-line func-names


	      return function (value, opt, opts) {
	        if (validator === false) {
	          throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
	        }

	        if (version && !deprecatedWarnings[opt]) {
	          deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

	          console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
	        }

	        return validator ? validator(value, opt, opts) : true;
	      };
	    };
	    /**
	     * Assert object's properties type
	     * @param {object} options
	     * @param {object} schema
	     * @param {boolean?} allowUnknown
	     */


	    function assertOptions(options, schema, allowUnknown) {
	      if (typeof options !== 'object') {
	        throw new TypeError('options must be an object');
	      }

	      var keys = Object.keys(options);
	      var i = keys.length;

	      while (i-- > 0) {
	        var opt = keys[i];
	        var validator = schema[opt];

	        if (validator) {
	          var value = options[opt];
	          var result = value === undefined || validator(value, opt, options);

	          if (result !== true) {
	            throw new TypeError('option ' + opt + ' must be ' + result);
	          }

	          continue;
	        }

	        if (allowUnknown !== true) {
	          throw Error('Unknown option ' + opt);
	        }
	      }
	    }

	    var validator$1 = {
	      assertOptions: assertOptions,
	      validators: validators$1
	    };
	    var utils$1 = utils$d;
	    var buildURL = buildURL$2;
	    var InterceptorManager = InterceptorManager_1;
	    var dispatchRequest = dispatchRequest$1;
	    var mergeConfig$1 = mergeConfig$2;
	    var validator = validator$1;
	    var validators = validator.validators;
	    /**
	     * Create a new instance of Axios
	     *
	     * @param {Object} instanceConfig The default config for the instance
	     */

	    function Axios$1(instanceConfig) {
	      this.defaults = instanceConfig;
	      this.interceptors = {
	        request: new InterceptorManager(),
	        response: new InterceptorManager()
	      };
	    }
	    /**
	     * Dispatch a request
	     *
	     * @param {Object} config The config specific for this request (merged with this.defaults)
	     */


	    Axios$1.prototype.request = function request(config) {
	      /*eslint no-param-reassign:0*/
	      // Allow for axios('example/url'[, config]) a la fetch API
	      if (typeof config === 'string') {
	        config = arguments[1] || {};
	        config.url = arguments[0];
	      } else {
	        config = config || {};
	      }

	      config = mergeConfig$1(this.defaults, config); // Set config.method

	      if (config.method) {
	        config.method = config.method.toLowerCase();
	      } else if (this.defaults.method) {
	        config.method = this.defaults.method.toLowerCase();
	      } else {
	        config.method = 'get';
	      }

	      var transitional = config.transitional;

	      if (transitional !== undefined) {
	        validator.assertOptions(transitional, {
	          silentJSONParsing: validators.transitional(validators.boolean),
	          forcedJSONParsing: validators.transitional(validators.boolean),
	          clarifyTimeoutError: validators.transitional(validators.boolean)
	        }, false);
	      } // filter out skipped interceptors


	      var requestInterceptorChain = [];
	      var synchronousRequestInterceptors = true;
	      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	          return;
	        }

	        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	      });
	      var responseInterceptorChain = [];
	      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	      });
	      var promise;

	      if (!synchronousRequestInterceptors) {
	        var chain = [dispatchRequest, undefined];
	        Array.prototype.unshift.apply(chain, requestInterceptorChain);
	        chain = chain.concat(responseInterceptorChain);
	        promise = Promise.resolve(config);

	        while (chain.length) {
	          promise = promise.then(chain.shift(), chain.shift());
	        }

	        return promise;
	      }

	      var newConfig = config;

	      while (requestInterceptorChain.length) {
	        var onFulfilled = requestInterceptorChain.shift();
	        var onRejected = requestInterceptorChain.shift();

	        try {
	          newConfig = onFulfilled(newConfig);
	        } catch (error) {
	          onRejected(error);
	          break;
	        }
	      }

	      try {
	        promise = dispatchRequest(newConfig);
	      } catch (error) {
	        return Promise.reject(error);
	      }

	      while (responseInterceptorChain.length) {
	        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	      }

	      return promise;
	    };

	    Axios$1.prototype.getUri = function getUri(config) {
	      config = mergeConfig$1(this.defaults, config);
	      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	    }; // Provide aliases for supported request methods


	    utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	      /*eslint func-names:0*/
	      Axios$1.prototype[method] = function (url, config) {
	        return this.request(mergeConfig$1(config || {}, {
	          method: method,
	          url: url,
	          data: (config || {}).data
	        }));
	      };
	    });
	    utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	      /*eslint func-names:0*/
	      Axios$1.prototype[method] = function (url, data, config) {
	        return this.request(mergeConfig$1(config || {}, {
	          method: method,
	          url: url,
	          data: data
	        }));
	      };
	    });
	    var Axios_1 = Axios$1;
	    var Cancel = Cancel_1;
	    /**
	     * A `CancelToken` is an object that can be used to request cancellation of an operation.
	     *
	     * @class
	     * @param {Function} executor The executor function.
	     */

	    function CancelToken(executor) {
	      if (typeof executor !== 'function') {
	        throw new TypeError('executor must be a function.');
	      }

	      var resolvePromise;
	      this.promise = new Promise(function promiseExecutor(resolve) {
	        resolvePromise = resolve;
	      });
	      var token = this; // eslint-disable-next-line func-names

	      this.promise.then(function (cancel) {
	        if (!token._listeners) return;
	        var i;
	        var l = token._listeners.length;

	        for (i = 0; i < l; i++) {
	          token._listeners[i](cancel);
	        }

	        token._listeners = null;
	      }); // eslint-disable-next-line func-names

	      this.promise.then = function (onfulfilled) {
	        var _resolve; // eslint-disable-next-line func-names


	        var promise = new Promise(function (resolve) {
	          token.subscribe(resolve);
	          _resolve = resolve;
	        }).then(onfulfilled);

	        promise.cancel = function reject() {
	          token.unsubscribe(_resolve);
	        };

	        return promise;
	      };

	      executor(function cancel(message) {
	        if (token.reason) {
	          // Cancellation has already been requested
	          return;
	        }

	        token.reason = new Cancel(message);
	        resolvePromise(token.reason);
	      });
	    }
	    /**
	     * Throws a `Cancel` if cancellation has been requested.
	     */


	    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	      if (this.reason) {
	        throw this.reason;
	      }
	    };
	    /**
	     * Subscribe to the cancel signal
	     */


	    CancelToken.prototype.subscribe = function subscribe(listener) {
	      if (this.reason) {
	        listener(this.reason);
	        return;
	      }

	      if (this._listeners) {
	        this._listeners.push(listener);
	      } else {
	        this._listeners = [listener];
	      }
	    };
	    /**
	     * Unsubscribe from the cancel signal
	     */


	    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	      if (!this._listeners) {
	        return;
	      }

	      var index = this._listeners.indexOf(listener);

	      if (index !== -1) {
	        this._listeners.splice(index, 1);
	      }
	    };
	    /**
	     * Returns an object that contains a new `CancelToken` and a function that, when called,
	     * cancels the `CancelToken`.
	     */


	    CancelToken.source = function source() {
	      var cancel;
	      var token = new CancelToken(function executor(c) {
	        cancel = c;
	      });
	      return {
	        token: token,
	        cancel: cancel
	      };
	    };

	    var CancelToken_1 = CancelToken;
	    /**
	     * Syntactic sugar for invoking a function and expanding an array for arguments.
	     *
	     * Common use case would be to use `Function.prototype.apply`.
	     *
	     *  ```js
	     *  function f(x, y, z) {}
	     *  var args = [1, 2, 3];
	     *  f.apply(null, args);
	     *  ```
	     *
	     * With `spread` this example can be re-written.
	     *
	     *  ```js
	     *  spread(function(x, y, z) {})([1, 2, 3]);
	     *  ```
	     *
	     * @param {Function} callback
	     * @returns {Function}
	     */

	    var spread = function spread(callback) {
	      return function wrap(arr) {
	        return callback.apply(null, arr);
	      };
	    };
	    /**
	     * Determines whether the payload is an error thrown by Axios
	     *
	     * @param {*} payload The value to test
	     * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	     */


	    var isAxiosError = function isAxiosError(payload) {
	      return typeof payload === 'object' && payload.isAxiosError === true;
	    };

	    var utils = utils$d;
	    var bind = bind$2;
	    var Axios = Axios_1;
	    var mergeConfig = mergeConfig$2;
	    var defaults = defaults_1;
	    /**
	     * Create an instance of Axios
	     *
	     * @param {Object} defaultConfig The default config for the instance
	     * @return {Axios} A new instance of Axios
	     */

	    function createInstance(defaultConfig) {
	      var context = new Axios(defaultConfig);
	      var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

	      utils.extend(instance, Axios.prototype, context); // Copy context to instance

	      utils.extend(instance, context); // Factory for creating new instances

	      instance.create = function create(instanceConfig) {
	        return createInstance(mergeConfig(defaultConfig, instanceConfig));
	      };

	      return instance;
	    } // Create the default instance to be exported


	    var axios$1 = createInstance(defaults); // Expose Axios class to allow class inheritance

	    axios$1.Axios = Axios; // Expose Cancel & CancelToken

	    axios$1.Cancel = Cancel_1;
	    axios$1.CancelToken = CancelToken_1;
	    axios$1.isCancel = isCancel$1;
	    axios$1.VERSION = data.version; // Expose all/spread

	    axios$1.all = function all(promises) {
	      return Promise.all(promises);
	    };

	    axios$1.spread = spread; // Expose isAxiosError

	    axios$1.isAxiosError = isAxiosError;
	    axios$2.exports = axios$1; // Allow use of default import syntax in TypeScript

	    axios$2.exports.default = axios$1;
	    var axios = axios$2.exports;
	    exports.Level = void 0;

	    (function (Level) {
	      Level["None"] = "none";
	      Level["Fatal"] = "fatal";
	      Level["Error"] = "error";
	      Level["Warning"] = "warning";
	      Level["Info"] = "info";
	      Level["Debug"] = "debug";
	    })(exports.Level || (exports.Level = {}));

	    exports.LevelNumber = void 0;

	    (function (LevelNumber) {
	      LevelNumber[LevelNumber["None"] = 1] = "None";
	      LevelNumber[LevelNumber["Fatal"] = 2] = "Fatal";
	      LevelNumber[LevelNumber["Error"] = 3] = "Error";
	      LevelNumber[LevelNumber["Warning"] = 4] = "Warning";
	      LevelNumber[LevelNumber["Info"] = 5] = "Info";
	      LevelNumber[LevelNumber["Debug"] = 6] = "Debug";
	    })(exports.LevelNumber || (exports.LevelNumber = {}));

	    const levelNumberToLevel = {
	      [exports.LevelNumber.None]: exports.Level.None,
	      [exports.LevelNumber.Fatal]: exports.Level.Fatal,
	      [exports.LevelNumber.Error]: exports.Level.Error,
	      [exports.LevelNumber.Warning]: exports.Level.Warning,
	      [exports.LevelNumber.Info]: exports.Level.Info,
	      [exports.LevelNumber.Debug]: exports.Level.Debug
	    };
	    const levelToLevelNumber = {
	      [exports.Level.None]: exports.LevelNumber.None,
	      [exports.Level.Fatal]: exports.LevelNumber.Fatal,
	      [exports.Level.Error]: exports.LevelNumber.Error,
	      [exports.Level.Warning]: exports.LevelNumber.Warning,
	      [exports.Level.Info]: exports.LevelNumber.Info,
	      [exports.Level.Debug]: exports.LevelNumber.Debug
	    };

	    class BaseOutput {
	      constructor(sessionId, origin, settings) {
	        this._level = exports.LevelNumber.None;

	        if (!sessionId || !sessionId.length) {
	          throw new Error('Invalid first argument sessionsId. Expected a non zero length string.');
	        }

	        if (!origin || !origin) {
	          throw new Error('Invalid second argument origin. Expected a non zero length string.');
	        }

	        this._sessionId = sessionId;
	        this._origin = origin;

	        if (settings && settings.level) {
	          this.setLevel(settings.level);
	        } else {
	          this.setLevel(exports.Level.Info);
	        }
	      }

	      setLevel(level) {
	        if (!levelToLevelNumber[level]) {
	          console.warn('hello');
	          throw new Error('Invalid level, cannot transform to level number');
	        }

	        this._level = levelToLevelNumber[level];
	      }

	    }

	    class ConsoleOutput extends BaseOutput {
	      constructor() {
	        super(...arguments);
	        this._level = exports.LevelNumber.Debug;
	      }

	      send(err) {
	        const consoleMethod = this._getConsoleMethod(exports.LevelNumber.Debug); // TODO err.level !!!


	        consoleMethod(this._marshalMessage(err), err.toFlatData());
	      }
	      /**
	       *  Retrieve the correct console processor.
	       *
	       *  Depends on the console logging level.
	       */


	      _getConsoleMethod(errorLevel) {
	        // If the logging level is higher (e.g.: Less important)
	        // than the set level, return a no-op function
	        if (errorLevel > this._level) {
	          return () => {};
	        }

	        switch (errorLevel) {
	          case exports.LevelNumber.Debug:
	            // eslint-disable-next-line no-console
	            return window.console.debug;

	          case exports.LevelNumber.Info:
	            // eslint-disable-next-line no-console
	            return window.console.info;

	          case exports.LevelNumber.Warning:
	            return window.console.warn;

	          case exports.LevelNumber.Error:
	          case exports.LevelNumber.Fatal:
	          default:
	            return window.console.error;
	        }
	      }

	      _marshalMessage(error) {
	        const parts = [[this._sessionId, this._origin, error.at.toLocaleTimeString()].join(' | '), error.toSlug().key, error.toString()];
	        return parts.join('\n');
	      }

	    }

	    const SIZEOF_SHORT = 2;
	    const SIZEOF_INT = 4;
	    const FILE_IDENTIFIER_LENGTH = 4;
	    const SIZE_PREFIX_LENGTH = 4;
	    const int32 = new Int32Array(2);
	    const float32 = new Float32Array(int32.buffer);
	    const float64 = new Float64Array(int32.buffer);
	    const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;

	    class Long {
	      constructor(low, high) {
	        this.low = low | 0;
	        this.high = high | 0;
	      }

	      static create(low, high) {
	        // Special-case zero to avoid GC overhead for default values
	        return low == 0 && high == 0 ? Long.ZERO : new Long(low, high);
	      }

	      toFloat64() {
	        return (this.low >>> 0) + this.high * 0x100000000;
	      }

	      equals(other) {
	        return this.low == other.low && this.high == other.high;
	      }

	    }

	    Long.ZERO = new Long(0, 0);
	    var Encoding;

	    (function (Encoding) {
	      Encoding[Encoding["UTF8_BYTES"] = 1] = "UTF8_BYTES";
	      Encoding[Encoding["UTF16_STRING"] = 2] = "UTF16_STRING";
	    })(Encoding || (Encoding = {}));

	    class ByteBuffer {
	      /**
	       * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
	       */
	      constructor(bytes_) {
	        this.bytes_ = bytes_;
	        this.position_ = 0;
	      }
	      /**
	       * Create and allocate a new ByteBuffer with a given size.
	       */


	      static allocate(byte_size) {
	        return new ByteBuffer(new Uint8Array(byte_size));
	      }

	      clear() {
	        this.position_ = 0;
	      }
	      /**
	       * Get the underlying `Uint8Array`.
	       */


	      bytes() {
	        return this.bytes_;
	      }
	      /**
	       * Get the buffer's position.
	       */


	      position() {
	        return this.position_;
	      }
	      /**
	       * Set the buffer's position.
	       */


	      setPosition(position) {
	        this.position_ = position;
	      }
	      /**
	       * Get the buffer's capacity.
	       */


	      capacity() {
	        return this.bytes_.length;
	      }

	      readInt8(offset) {
	        return this.readUint8(offset) << 24 >> 24;
	      }

	      readUint8(offset) {
	        return this.bytes_[offset];
	      }

	      readInt16(offset) {
	        return this.readUint16(offset) << 16 >> 16;
	      }

	      readUint16(offset) {
	        return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
	      }

	      readInt32(offset) {
	        return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
	      }

	      readUint32(offset) {
	        return this.readInt32(offset) >>> 0;
	      }

	      readInt64(offset) {
	        return new Long(this.readInt32(offset), this.readInt32(offset + 4));
	      }

	      readUint64(offset) {
	        return new Long(this.readUint32(offset), this.readUint32(offset + 4));
	      }

	      readFloat32(offset) {
	        int32[0] = this.readInt32(offset);
	        return float32[0];
	      }

	      readFloat64(offset) {
	        int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
	        int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
	        return float64[0];
	      }

	      writeInt8(offset, value) {
	        this.bytes_[offset] = value;
	      }

	      writeUint8(offset, value) {
	        this.bytes_[offset] = value;
	      }

	      writeInt16(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	      }

	      writeUint16(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	      }

	      writeInt32(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	        this.bytes_[offset + 2] = value >> 16;
	        this.bytes_[offset + 3] = value >> 24;
	      }

	      writeUint32(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	        this.bytes_[offset + 2] = value >> 16;
	        this.bytes_[offset + 3] = value >> 24;
	      }

	      writeInt64(offset, value) {
	        this.writeInt32(offset, value.low);
	        this.writeInt32(offset + 4, value.high);
	      }

	      writeUint64(offset, value) {
	        this.writeUint32(offset, value.low);
	        this.writeUint32(offset + 4, value.high);
	      }

	      writeFloat32(offset, value) {
	        float32[0] = value;
	        this.writeInt32(offset, int32[0]);
	      }

	      writeFloat64(offset, value) {
	        float64[0] = value;
	        this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
	        this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
	      }
	      /**
	       * Return the file identifier.   Behavior is undefined for FlatBuffers whose
	       * schema does not include a file_identifier (likely points at padding or the
	       * start of a the root vtable).
	       */


	      getBufferIdentifier() {
	        if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
	          throw new Error('FlatBuffers: ByteBuffer is too short to contain an identifier.');
	        }

	        let result = "";

	        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
	          result += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
	        }

	        return result;
	      }
	      /**
	       * Look up a field in the vtable, return an offset into the object, or 0 if the
	       * field is not present.
	       */


	      __offset(bb_pos, vtable_offset) {
	        const vtable = bb_pos - this.readInt32(bb_pos);
	        return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
	      }
	      /**
	       * Initialize any Table-derived type to point to the union at the given offset.
	       */


	      __union(t, offset) {
	        t.bb_pos = offset + this.readInt32(offset);
	        t.bb = this;
	        return t;
	      }
	      /**
	       * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
	       * This allocates a new string and converts to wide chars upon each access.
	       *
	       * To avoid the conversion to UTF-16, pass Encoding.UTF8_BYTES as
	       * the "optionalEncoding" argument. This is useful for avoiding conversion to
	       * and from UTF-16 when the data will just be packaged back up in another
	       * FlatBuffer later on.
	       *
	       * @param offset
	       * @param opt_encoding Defaults to UTF16_STRING
	       */


	      __string(offset, opt_encoding) {
	        offset += this.readInt32(offset);
	        const length = this.readInt32(offset);
	        let result = '';
	        let i = 0;
	        offset += SIZEOF_INT;

	        if (opt_encoding === Encoding.UTF8_BYTES) {
	          return this.bytes_.subarray(offset, offset + length);
	        }

	        while (i < length) {
	          let codePoint; // Decode UTF-8

	          const a = this.readUint8(offset + i++);

	          if (a < 0xC0) {
	            codePoint = a;
	          } else {
	            const b = this.readUint8(offset + i++);

	            if (a < 0xE0) {
	              codePoint = (a & 0x1F) << 6 | b & 0x3F;
	            } else {
	              const c = this.readUint8(offset + i++);

	              if (a < 0xF0) {
	                codePoint = (a & 0x0F) << 12 | (b & 0x3F) << 6 | c & 0x3F;
	              } else {
	                const d = this.readUint8(offset + i++);
	                codePoint = (a & 0x07) << 18 | (b & 0x3F) << 12 | (c & 0x3F) << 6 | d & 0x3F;
	              }
	            }
	          } // Encode UTF-16


	          if (codePoint < 0x10000) {
	            result += String.fromCharCode(codePoint);
	          } else {
	            codePoint -= 0x10000;
	            result += String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint & (1 << 10) - 1) + 0xDC00);
	          }
	        }

	        return result;
	      }
	      /**
	       * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
	       * if a string then return a new one
	       *
	       * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
	       * makes the behaviour of __union_with_string different compared to __union
	       */


	      __union_with_string(o, offset) {
	        if (typeof o === 'string') {
	          return this.__string(offset);
	        }

	        return this.__union(o, offset);
	      }
	      /**
	       * Retrieve the relative offset stored at "offset"
	       */


	      __indirect(offset) {
	        return offset + this.readInt32(offset);
	      }
	      /**
	       * Get the start of data of a vector whose offset is stored at "offset" in this object.
	       */


	      __vector(offset) {
	        return offset + this.readInt32(offset) + SIZEOF_INT; // data starts after the length
	      }
	      /**
	       * Get the length of a vector whose offset is stored at "offset" in this object.
	       */


	      __vector_len(offset) {
	        return this.readInt32(offset + this.readInt32(offset));
	      }

	      __has_identifier(ident) {
	        if (ident.length != FILE_IDENTIFIER_LENGTH) {
	          throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
	        }

	        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
	          if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
	            return false;
	          }
	        }

	        return true;
	      }
	      /**
	       * A helper function to avoid generated code depending on this file directly.
	       */


	      createLong(low, high) {
	        return Long.create(low, high);
	      }
	      /**
	       * A helper function for generating list for obj api
	       */


	      createScalarList(listAccessor, listLength) {
	        const ret = [];

	        for (let i = 0; i < listLength; ++i) {
	          if (listAccessor(i) !== null) {
	            ret.push(listAccessor(i));
	          }
	        }

	        return ret;
	      }
	      /**
	       * A helper function for generating list for obj api
	       * @param listAccessor function that accepts an index and return data at that index
	       * @param listLength listLength
	       * @param res result list
	       */


	      createObjList(listAccessor, listLength) {
	        const ret = [];

	        for (let i = 0; i < listLength; ++i) {
	          const val = listAccessor(i);

	          if (val !== null) {
	            ret.push(val.unpack());
	          }
	        }

	        return ret;
	      }

	    }

	    class Builder {
	      /**
	       * Create a FlatBufferBuilder.
	       */
	      constructor(opt_initial_size) {
	        /** Minimum alignment encountered so far. */
	        this.minalign = 1;
	        /** The vtable for the current table. */

	        this.vtable = null;
	        /** The amount of fields we're actually using. */

	        this.vtable_in_use = 0;
	        /** Whether we are currently serializing a table. */

	        this.isNested = false;
	        /** Starting offset of the current struct/table. */

	        this.object_start = 0;
	        /** List of offsets of all vtables. */

	        this.vtables = [];
	        /** For the current vector being built. */

	        this.vector_num_elems = 0;
	        /** False omits default values from the serialized data */

	        this.force_defaults = false;
	        this.string_maps = null;
	        let initial_size;

	        if (!opt_initial_size) {
	          initial_size = 1024;
	        } else {
	          initial_size = opt_initial_size;
	        }
	        /**
	         * @type {ByteBuffer}
	         * @private
	         */


	        this.bb = ByteBuffer.allocate(initial_size);
	        this.space = initial_size;
	      }

	      clear() {
	        this.bb.clear();
	        this.space = this.bb.capacity();
	        this.minalign = 1;
	        this.vtable = null;
	        this.vtable_in_use = 0;
	        this.isNested = false;
	        this.object_start = 0;
	        this.vtables = [];
	        this.vector_num_elems = 0;
	        this.force_defaults = false;
	        this.string_maps = null;
	      }
	      /**
	       * In order to save space, fields that are set to their default value
	       * don't get serialized into the buffer. Forcing defaults provides a
	       * way to manually disable this optimization.
	       *
	       * @param forceDefaults true always serializes default values
	       */


	      forceDefaults(forceDefaults) {
	        this.force_defaults = forceDefaults;
	      }
	      /**
	       * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
	       * called finish(). The actual data starts at the ByteBuffer's current position,
	       * not necessarily at 0.
	       */


	      dataBuffer() {
	        return this.bb;
	      }
	      /**
	       * Get the bytes representing the FlatBuffer. Only call this after you've
	       * called finish().
	       */


	      asUint8Array() {
	        return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
	      }
	      /**
	       * Prepare to write an element of `size` after `additional_bytes` have been
	       * written, e.g. if you write a string, you need to align such the int length
	       * field is aligned to 4 bytes, and the string data follows it directly. If all
	       * you need to do is alignment, `additional_bytes` will be 0.
	       *
	       * @param size This is the of the new element to write
	       * @param additional_bytes The padding size
	       */


	      prep(size, additional_bytes) {
	        // Track the biggest thing we've ever aligned to.
	        if (size > this.minalign) {
	          this.minalign = size;
	        } // Find the amount of alignment needed such that `size` is properly
	        // aligned after `additional_bytes`


	        const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1; // Reallocate the buffer if needed.

	        while (this.space < align_size + size + additional_bytes) {
	          const old_buf_size = this.bb.capacity();
	          this.bb = Builder.growByteBuffer(this.bb);
	          this.space += this.bb.capacity() - old_buf_size;
	        }

	        this.pad(align_size);
	      }

	      pad(byte_size) {
	        for (let i = 0; i < byte_size; i++) {
	          this.bb.writeInt8(--this.space, 0);
	        }
	      }

	      writeInt8(value) {
	        this.bb.writeInt8(this.space -= 1, value);
	      }

	      writeInt16(value) {
	        this.bb.writeInt16(this.space -= 2, value);
	      }

	      writeInt32(value) {
	        this.bb.writeInt32(this.space -= 4, value);
	      }

	      writeInt64(value) {
	        this.bb.writeInt64(this.space -= 8, value);
	      }

	      writeFloat32(value) {
	        this.bb.writeFloat32(this.space -= 4, value);
	      }

	      writeFloat64(value) {
	        this.bb.writeFloat64(this.space -= 8, value);
	      }
	      /**
	       * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int8` to add the the buffer.
	       */


	      addInt8(value) {
	        this.prep(1, 0);
	        this.writeInt8(value);
	      }
	      /**
	       * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int16` to add the the buffer.
	       */


	      addInt16(value) {
	        this.prep(2, 0);
	        this.writeInt16(value);
	      }
	      /**
	       * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int32` to add the the buffer.
	       */


	      addInt32(value) {
	        this.prep(4, 0);
	        this.writeInt32(value);
	      }
	      /**
	       * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int64` to add the the buffer.
	       */


	      addInt64(value) {
	        this.prep(8, 0);
	        this.writeInt64(value);
	      }
	      /**
	       * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `float32` to add the the buffer.
	       */


	      addFloat32(value) {
	        this.prep(4, 0);
	        this.writeFloat32(value);
	      }
	      /**
	       * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `float64` to add the the buffer.
	       */


	      addFloat64(value) {
	        this.prep(8, 0);
	        this.writeFloat64(value);
	      }

	      addFieldInt8(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addInt8(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldInt16(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addInt16(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldInt32(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addInt32(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldInt64(voffset, value, defaultValue) {
	        if (this.force_defaults || !value.equals(defaultValue)) {
	          this.addInt64(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldFloat32(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addFloat32(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldFloat64(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addFloat64(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldOffset(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addOffset(value);
	          this.slot(voffset);
	        }
	      }
	      /**
	       * Structs are stored inline, so nothing additional is being added. `d` is always 0.
	       */


	      addFieldStruct(voffset, value, defaultValue) {
	        if (value != defaultValue) {
	          this.nested(value);
	          this.slot(voffset);
	        }
	      }
	      /**
	       * Structures are always stored inline, they need to be created right
	       * where they're used.  You'll get this assertion failure if you
	       * created it elsewhere.
	       */


	      nested(obj) {
	        if (obj != this.offset()) {
	          throw new Error('FlatBuffers: struct must be serialized inline.');
	        }
	      }
	      /**
	       * Should not be creating any other object, string or vector
	       * while an object is being constructed
	       */


	      notNested() {
	        if (this.isNested) {
	          throw new Error('FlatBuffers: object serialization must not be nested.');
	        }
	      }
	      /**
	       * Set the current vtable at `voffset` to the current location in the buffer.
	       */


	      slot(voffset) {
	        if (this.vtable !== null) this.vtable[voffset] = this.offset();
	      }
	      /**
	       * @returns Offset relative to the end of the buffer.
	       */


	      offset() {
	        return this.bb.capacity() - this.space;
	      }
	      /**
	       * Doubles the size of the backing ByteBuffer and copies the old data towards
	       * the end of the new buffer (since we build the buffer backwards).
	       *
	       * @param bb The current buffer with the existing data
	       * @returns A new byte buffer with the old data copied
	       * to it. The data is located at the end of the buffer.
	       *
	       * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
	       * it a uint8Array we need to suppress the type check:
	       * @suppress {checkTypes}
	       */


	      static growByteBuffer(bb) {
	        const old_buf_size = bb.capacity(); // Ensure we don't grow beyond what fits in an int.

	        if (old_buf_size & 0xC0000000) {
	          throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
	        }

	        const new_buf_size = old_buf_size << 1;
	        const nbb = ByteBuffer.allocate(new_buf_size);
	        nbb.setPosition(new_buf_size - old_buf_size);
	        nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
	        return nbb;
	      }
	      /**
	       * Adds on offset, relative to where it will be written.
	       *
	       * @param offset The offset to add.
	       */


	      addOffset(offset) {
	        this.prep(SIZEOF_INT, 0); // Ensure alignment is already done.

	        this.writeInt32(this.offset() - offset + SIZEOF_INT);
	      }
	      /**
	       * Start encoding a new object in the buffer.  Users will not usually need to
	       * call this directly. The FlatBuffers compiler will generate helper methods
	       * that call this method internally.
	       */


	      startObject(numfields) {
	        this.notNested();

	        if (this.vtable == null) {
	          this.vtable = [];
	        }

	        this.vtable_in_use = numfields;

	        for (let i = 0; i < numfields; i++) {
	          this.vtable[i] = 0; // This will push additional elements as needed
	        }

	        this.isNested = true;
	        this.object_start = this.offset();
	      }
	      /**
	       * Finish off writing the object that is under construction.
	       *
	       * @returns The offset to the object inside `dataBuffer`
	       */


	      endObject() {
	        if (this.vtable == null || !this.isNested) {
	          throw new Error('FlatBuffers: endObject called without startObject');
	        }

	        this.addInt32(0);
	        const vtableloc = this.offset(); // Trim trailing zeroes.

	        let i = this.vtable_in_use - 1; // eslint-disable-next-line no-empty

	        for (; i >= 0 && this.vtable[i] == 0; i--) {}

	        const trimmed_size = i + 1; // Write out the current vtable.

	        for (; i >= 0; i--) {
	          // Offset relative to the start of the table.
	          this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
	        }

	        const standard_fields = 2; // The fields below:

	        this.addInt16(vtableloc - this.object_start);
	        const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
	        this.addInt16(len); // Search for an existing vtable that matches the current one.

	        let existing_vtable = 0;
	        const vt1 = this.space;

	        outer_loop: for (i = 0; i < this.vtables.length; i++) {
	          const vt2 = this.bb.capacity() - this.vtables[i];

	          if (len == this.bb.readInt16(vt2)) {
	            for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
	              if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
	                continue outer_loop;
	              }
	            }

	            existing_vtable = this.vtables[i];
	            break;
	          }
	        }

	        if (existing_vtable) {
	          // Found a match:
	          // Remove the current vtable.
	          this.space = this.bb.capacity() - vtableloc; // Point table to existing vtable.

	          this.bb.writeInt32(this.space, existing_vtable - vtableloc);
	        } else {
	          // No match:
	          // Add the location of the current vtable to the list of vtables.
	          this.vtables.push(this.offset()); // Point table to current vtable.

	          this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
	        }

	        this.isNested = false;
	        return vtableloc;
	      }
	      /**
	       * Finalize a buffer, poiting to the given `root_table`.
	       */


	      finish(root_table, opt_file_identifier, opt_size_prefix) {
	        const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;

	        if (opt_file_identifier) {
	          const file_identifier = opt_file_identifier;
	          this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);

	          if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
	            throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
	          }

	          for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
	            this.writeInt8(file_identifier.charCodeAt(i));
	          }
	        }

	        this.prep(this.minalign, SIZEOF_INT + size_prefix);
	        this.addOffset(root_table);

	        if (size_prefix) {
	          this.addInt32(this.bb.capacity() - this.space);
	        }

	        this.bb.setPosition(this.space);
	      }
	      /**
	       * Finalize a size prefixed buffer, pointing to the given `root_table`.
	       */


	      finishSizePrefixed(root_table, opt_file_identifier) {
	        this.finish(root_table, opt_file_identifier, true);
	      }
	      /**
	       * This checks a required field has been set in a given table that has
	       * just been constructed.
	       */


	      requiredField(table, field) {
	        const table_start = this.bb.capacity() - table;
	        const vtable_start = table_start - this.bb.readInt32(table_start);
	        const ok = this.bb.readInt16(vtable_start + field) != 0; // If this fails, the caller will show what field needs to be set.

	        if (!ok) {
	          throw new Error('FlatBuffers: field ' + field + ' must be set');
	        }
	      }
	      /**
	       * Start a new array/vector of objects.  Users usually will not call
	       * this directly. The FlatBuffers compiler will create a start/end
	       * method for vector types in generated code.
	       *
	       * @param elem_size The size of each element in the array
	       * @param num_elems The number of elements in the array
	       * @param alignment The alignment of the array
	       */


	      startVector(elem_size, num_elems, alignment) {
	        this.notNested();
	        this.vector_num_elems = num_elems;
	        this.prep(SIZEOF_INT, elem_size * num_elems);
	        this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
	      }
	      /**
	       * Finish off the creation of an array and all its elements. The array must be
	       * created with `startVector`.
	       *
	       * @returns The offset at which the newly created array
	       * starts.
	       */


	      endVector() {
	        this.writeInt32(this.vector_num_elems);
	        return this.offset();
	      }
	      /**
	       * Encode the string `s` in the buffer using UTF-8. If the string passed has
	       * already been seen, we return the offset of the already written string
	       *
	       * @param s The string to encode
	       * @return The offset in the buffer where the encoded string starts
	       */


	      createSharedString(s) {
	        if (!s) {
	          return 0;
	        }

	        if (!this.string_maps) {
	          this.string_maps = new Map();
	        }

	        if (this.string_maps.has(s)) {
	          return this.string_maps.get(s);
	        }

	        const offset = this.createString(s);
	        this.string_maps.set(s, offset);
	        return offset;
	      }
	      /**
	       * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
	       * instead of a string, it is assumed to contain valid UTF-8 encoded data.
	       *
	       * @param s The string to encode
	       * @return The offset in the buffer where the encoded string starts
	       */


	      createString(s) {
	        if (!s) {
	          return 0;
	        }

	        let utf8;

	        if (s instanceof Uint8Array) {
	          utf8 = s;
	        } else {
	          utf8 = [];
	          let i = 0;

	          while (i < s.length) {
	            let codePoint; // Decode UTF-16

	            const a = s.charCodeAt(i++);

	            if (a < 0xD800 || a >= 0xDC00) {
	              codePoint = a;
	            } else {
	              const b = s.charCodeAt(i++);
	              codePoint = (a << 10) + b + (0x10000 - (0xD800 << 10) - 0xDC00);
	            } // Encode UTF-8


	            if (codePoint < 0x80) {
	              utf8.push(codePoint);
	            } else {
	              if (codePoint < 0x800) {
	                utf8.push(codePoint >> 6 & 0x1F | 0xC0);
	              } else {
	                if (codePoint < 0x10000) {
	                  utf8.push(codePoint >> 12 & 0x0F | 0xE0);
	                } else {
	                  utf8.push(codePoint >> 18 & 0x07 | 0xF0, codePoint >> 12 & 0x3F | 0x80);
	                }

	                utf8.push(codePoint >> 6 & 0x3F | 0x80);
	              }

	              utf8.push(codePoint & 0x3F | 0x80);
	            }
	          }
	        }

	        this.addInt8(0);
	        this.startVector(1, utf8.length, 1);
	        this.bb.setPosition(this.space -= utf8.length);

	        for (let i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
	          bytes[offset++] = utf8[i];
	        }

	        return this.endVector();
	      }
	      /**
	       * A helper function to avoid generated code depending on this file directly.
	       */


	      createLong(low, high) {
	        return Long.create(low, high);
	      }
	      /**
	       * A helper function to pack an object
	       *
	       * @returns offset of obj
	       */


	      createObjectOffset(obj) {
	        if (obj === null) {
	          return 0;
	        }

	        if (typeof obj === 'string') {
	          return this.createString(obj);
	        } else {
	          return obj.pack(this);
	        }
	      }
	      /**
	       * A helper function to pack a list of object
	       *
	       * @returns list of offsets of each non null object
	       */


	      createObjectOffsetList(list) {
	        const ret = [];

	        for (let i = 0; i < list.length; ++i) {
	          const val = list[i];

	          if (val !== null) {
	            ret.push(this.createObjectOffset(val));
	          } else {
	            throw new Error('FlatBuffers: Argument for createObjectOffsetList cannot contain null.');
	          }
	        }

	        return ret;
	      }

	      createStructOffsetList(list, startFunc) {
	        startFunc(this, list.length);
	        this.createObjectOffsetList(list);
	        return this.endVector();
	      }

	    }

	    function getProtocolAndHostPathFromUrl(url) {
	      const proto = url.startsWith('http://') ? 'http' : 'https';
	      const hostPath = url.replace(/^(?:[a-z]+:)?\/\//, '').replace(/\/*$/, '');
	      return [proto, hostPath];
	    }

	    function buildFlatBuffer(level, slug, data) {
	      const builder = new Builder(128);
	      const messageOffset = builder.createString(slug);
	      const fieldsArr = [];

	      for (const [key, value] of Object.entries(data)) {
	        const keyOffset = builder.createString(key);
	        const valueOffset = builder.createString(value);
	        builder.startObject(2);
	        builder.addFieldOffset(0, keyOffset, 0);
	        builder.addFieldOffset(1, valueOffset, 0);
	        fieldsArr.unshift(builder.endObject());
	      }

	      builder.startVector(4, fieldsArr.length, 4);

	      for (const offset of fieldsArr) {
	        builder.addOffset(offset);
	      }

	      const fieldsOffset = builder.endVector();
	      builder.startObject(3);
	      builder.addFieldOffset(0, messageOffset, 0);
	      builder.addFieldInt8(1, level, 0);
	      builder.addFieldOffset(2, fieldsOffset, 0);
	      builder.finish(builder.endObject());
	      return builder.asUint8Array();
	    }

	    class ServiceOutput extends BaseOutput {
	      constructor(sessionId, origin, settings) {
	        super(sessionId, origin, settings);
	        this._level = exports.LevelNumber.Error;

	        if (!settings) {
	          throw new Error('Missing settings for logging service output.');
	        }

	        if (!settings.baseUrl || !settings.baseUrl.trim().length) {
	          throw new Error('Missing baseUrl settings for logging service output.');
	        }

	        const [proto, hostPath] = getProtocolAndHostPathFromUrl(settings.baseUrl);

	        if (!hostPath.trim().length) {
	          throw new Error('Invalid base url for logging service output, expected a host name.');
	        }

	        this._url = `${proto}://${hostPath}`;
	        this._http = settings.http || axios.create();
	      }

	      async send(err) {
	        try {
	          // TODO err.level ?? NOW EVERYTHING IS FATAL!!!
	          await this._http.post(this._url, Buffer.from(buildFlatBuffer(exports.LevelNumber.Fatal, err.toString(), { ...err.toFlatData(),
	            sessionId: this._sessionId,
	            origin: this._origin
	          })));
	        } catch (e) {
	          window.console.error('Failed to send log to external service', e);
	        }
	      }

	    }

	    let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));

	    let customRandom = (alphabet, size, getRandom) => {
	      let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
	      let step = -~(1.6 * mask * size / alphabet.length);
	      return () => {
	        let id = '';

	        while (true) {
	          let bytes = getRandom(step);
	          let j = step;

	          while (j--) {
	            id += alphabet[bytes[j] & mask] || '';
	            if (id.length === size) return id;
	          }
	        }
	      };
	    };

	    let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random); // Note: with this alphabet and 12 chars, there is roughly a 1% chance of at least one collision after about 28 days.
	    // This is assuming 100.000 ids per hour.
	    // src: https://zelark.github.io/nano-id-cc/


	    const sessionIdGenerator = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXY', 12);

	    class Logger {
	      constructor(origin, config) {
	        this._outputs = [];
	        this._origin = origin;
	        this._sessionId = config && config.sessionId ? config.sessionId : Logger.generateSessionId();
	        this.addOutput(ConsoleOutput);
	      }

	      static generateSessionId() {
	        return sessionIdGenerator();
	      }

	      get sessionId() {
	        return this._sessionId;
	      }

	      addOutput(OutputConstructor, ...settings) {
	        const output = new OutputConstructor(this._sessionId, this._origin, ...settings);

	        this._outputs.push(output);

	        return output;
	      }

	      throw(error) {
	        if (!error || !error.isOpenTicketError) {
	          console.error('Failed to throw error, error object is not an OpenTicketError', error);
	          this.log(new UnexpectedError(error));
	        } else {
	          this.log(error);
	        }

	        throw error;
	      }

	      log(error) {
	        let err = error;

	        if (!error || !error.isOpenTicketError) {
	          console.error('Failed to properly log error, error object is not an OpenTicketError', error);
	          err = new UnexpectedError(error);
	        }

	        this._send(err);
	      }

	      _send(err) {
	        for (const output of this._outputs) {
	          // Any logging should be handled outside of execution scope.
	          // This should not block any other 'processes'.
	          void new Promise(resolve => {
	            output.send(err);
	            resolve();
	          });
	        }
	      }

	    }

	    class CrudRoot extends CrudNode {
	      constructor(config) {
	        super(null, 'root');
	        this.$config = config;
	        this._http = config.http || axios.create();
	        this._factory = new CrudFactory({
	          models: config.models
	        });
	        this._logger = new Logger(config.origin);
	      }

	      get $http() {
	        return this._http;
	      }

	      get $root() {
	        return this;
	      }

	      get $factory() {
	        return this._factory;
	      }

	      get $log() {
	        return this._logger;
	      }

	      get $path() {
	        return this.$config.baseUrl;
	      }

	      getRelation(type) {
	        for (const prop of Object.values(this)) {
	          if (prop instanceof CrudToMany && prop.type === type) {
	            return prop;
	          }
	        }

	        throw Error(`Root relation for type ${type} not found`);
	      }

	      get $routes() {
	        const routes = [];

	        for (const prop of Object.values(this)) {
	          if (prop instanceof CrudNode) {
	            routes.push(...prop.$routes);
	          }
	        }

	        return routes;
	      }

	    }
	    /**
	     * Class for interacting with Pickable implementations, such as the Pick CRUD mixin
	     */


	    class Picker {
	      constructor(parent) {
	        this.hasLocalChanges = false;
	        this.count = 0;
	        this.linked = {};
	        this._originalLinked = {};
	        this._models = {};
	        this.pending = {
	          link: [],
	          unlink: []
	        };

	        this.getPickerPage = async request => {
	          const response = await this._parent.getPickerPage(request);

	          this._updateLinkedData(response);

	          return response;
	        };

	        this._parent = parent;
	      } // Link a model in the local state, add as a pending operation


	      link(model) {
	        const unlinkIndex = this.pending.unlink.indexOf(model.guid);

	        if (unlinkIndex > -1) {
	          this.pending.unlink.splice(unlinkIndex, 1);
	        } else {
	          this.pending.link.push(model.guid);
	        }

	        this.linked[model.guid] = true;
	        this.count++;

	        this._updateHasLocalChanges();
	      } // Unlink a model in the local state, add as a pending operation


	      unlink(model) {
	        const linkIndex = this.pending.link.indexOf(model.guid);

	        if (linkIndex > -1) {
	          this.pending.link.splice(linkIndex, 1);
	        } else {
	          this.pending.unlink.push(model.guid);
	        }

	        this.linked[model.guid] = false;
	        this.count--;

	        this._updateHasLocalChanges();
	      } // Save the pending operations via the NestedPickable and apply changes
	      // to the local state.


	      async save() {
	        const promises = [];

	        if (this.pending.link.length) {
	          promises.push(this._parent.linkPickerModels(this.pending.link));
	        }

	        if (this.pending.unlink.length) {
	          promises.push(this._parent.unlinkPickerModels(this.pending.unlink));
	        }

	        if (!promises.length) {
	          return;
	        }

	        await Promise.all(promises);

	        for (const guid of this.pending.link) {
	          this._originalLinked[guid] = true;
	        }

	        for (const guid of this.pending.unlink) {
	          this._originalLinked[guid] = false;
	        } // Update local state to reflect applied changes


	        this.reset(); // Recount linked items

	        this.count = Object.values(this.linked).filter(linked => linked).length;
	      } // Undo pending changes and reset linked states


	      reset() {
	        this.pending.link = [];
	        this.pending.unlink = [];
	        Object.assign(this.linked, this._originalLinked);

	        this._updateHasLocalChanges();
	      } // set `.hasLocalChanges` depending on whether or not there are
	      // pending local changes to save.


	      _updateHasLocalChanges() {
	        this.hasLocalChanges = !!(this.pending.link.length || this.pending.unlink.length);
	      } // Add metadata to the local state


	      _updateLinkedData(response) {
	        for (let i = 0; i < response.data.length; i++) {
	          const item = response.data[i]; // Read the linked state of a model from the raw properties passed to it from the NestedPickable

	          this._originalLinked[item.guid] = !!item.raw.linked;
	          this.linked[item.guid] = !!item.raw.linked; // If linked, update the total linked count

	          if (!!item.raw.linked && !this._models[item.guid]) {
	            this.count++;
	          }

	          this._models[item.guid] = item;
	        }
	      }

	    }
	    /**
	     * Class for interacting with NestedPickable implementations, such as the NestedPick CRUD mixin
	     */


	    class NestedPicker {
	      // NestedPicker needs a NestedPickable implementation to function, for
	      // example the nested_pick CRUD mixin.
	      constructor(parent) {
	        // True when there are pending local changes
	        this.hasLocalChanges = false; // Nested map with to retrieve the linked state of an item,
	        // structure: [PickerSumsModel.guid][PickerModel.guid]

	        this.linked = {}; // Number of linked items per PickerSumsModel.guid

	        this.count = {}; // Pending operations

	        this.pending = {};
	        this._models = {}; // Get page of PickerModels by PickerSumsModel.guid

	        this.getNestedPage = async request => {
	          // Retrieve page from NestedPickable implementations
	          const response = await this._parent.getPickerNestedPage(request); // Set linked metadata

	          this._setLinkedStatus(request, response);

	          return response;
	        }; // Get page of PickerSumsModels


	        this.getSumsPage = async request => {
	          // Retrieve page from NestedPickable implementations
	          const response = await this._parent.getPickerSumsPage(request); // Set linked metadata

	          this._setSumsLinkedStatus(response);

	          return response;
	        };

	        this._parent = parent;
	      } // Save the pending operations via the NestedPickable and apply changes
	      // to the local state.


	      async save() {
	        const link = [];
	        const unlink = [];

	        for (const nestedPending of Object.values(this.pending)) {
	          link.push(...nestedPending.link);
	          unlink.push(...nestedPending.unlink);
	        }

	        const promises = []; // Add link call to pending promises

	        if (link.length) {
	          promises.push(this._parent.linkPickerModels(link));
	        } // Add unlink call to pending promises


	        if (unlink.length) {
	          promises.push(this._parent.unlinkPickerModels(unlink));
	        }

	        await Promise.all(promises); // Apply changes to local state, clear pending actions

	        for (const sumsGuid of Object.keys(this.pending)) {
	          for (const linked of this.pending[sumsGuid].link) {
	            this.linked[sumsGuid][linked] = true;
	          }

	          for (const unlinked of this.pending[sumsGuid].unlink) {
	            this.linked[sumsGuid][unlinked] = false;
	          }

	          this.pending[sumsGuid].link = [];
	          this.pending[sumsGuid].unlink = [];
	        } // Update local changes state, hasLocalChanges is `false` after
	        // a successful `.save` operation.


	        this._updateHasLocalChanges();
	      } // Undo pending changes and reset linked states


	      reset() {
	        for (const sumsGuid of Object.keys(this.pending)) {
	          for (const linked of this.pending[sumsGuid].link) {
	            this.linked[sumsGuid][linked] = false;
	          }

	          for (const unlinked of this.pending[sumsGuid].unlink) {
	            this.linked[sumsGuid][unlinked] = true;
	          }

	          this.pending[sumsGuid].link = [];
	          this.pending[sumsGuid].unlink = [];
	        }
	      } // Link a model in the local state, add as a pending operation


	      link(sumsGuid, model) {
	        const unlinkIndex = this.pending[sumsGuid].unlink.indexOf(model.guid);

	        if (unlinkIndex > -1) {
	          this.pending[sumsGuid].unlink.splice(unlinkIndex, 1);
	        } else {
	          this.pending[sumsGuid].link.push(model.guid);
	        }

	        this.linked[sumsGuid][model.guid] = true;
	        this.count[sumsGuid]++;

	        this._updateHasLocalChanges();
	      } // Unlink a model in the local state, add as a pending operation


	      unlink(sumsGuid, model) {
	        const linkIndex = this.pending[sumsGuid].link.indexOf(model.guid);

	        if (linkIndex > -1) {
	          this.pending[sumsGuid].link.splice(linkIndex, 1);
	        } else {
	          this.pending[sumsGuid].unlink.push(model.guid);
	        }

	        this.linked[sumsGuid][model.guid] = false;
	        this.count[sumsGuid]--;

	        this._updateHasLocalChanges();
	      } // Add sums metadata to the local state


	      _setSumsLinkedStatus(response) {
	        response.data.forEach(model => {
	          if (!this.count[model.guid]) {
	            this.count[model.guid] = model.raw.linked;
	          }
	        });
	      } // Add nested metadata to the local state


	      _setLinkedStatus(request, response) {
	        if (!this.linked[request.guid]) {
	          this.linked[request.guid] = {};
	        }

	        if (!this.pending[request.guid]) {
	          this.pending[request.guid] = {
	            link: [],
	            unlink: []
	          };
	        }

	        response.data.forEach(model => {
	          this._models[model.guid] = model;

	          if (this.linked[request.guid][model.guid] === undefined) {
	            this.linked[request.guid][model.guid] = !!model.raw.linked;
	          }
	        });
	      } // set `.hasLocalChanges` depending on whether or not there are
	      // pending local changes to save.


	      _updateHasLocalChanges() {
	        for (const nestedPending of Object.values(this.pending)) {
	          if (nestedPending.link.length || nestedPending.unlink.length) {
	            this.hasLocalChanges = true;
	            return;
	          }
	        }

	        this.hasLocalChanges = false;
	      }

	    }

	    function arr_move(arr, oldIndex, newIndex) {
	      const element = arr[oldIndex];
	      arr.splice(oldIndex, 1);
	      arr.splice(newIndex, 0, element);
	    }

	    class Sorter {
	      constructor(parent) {
	        this._dirty = [];
	        this._original = [];
	        this._events = [];

	        this.getPage = async request => {
	          const response = await this._parent.getSortedPage(request);

	          this._updateSortData(response);

	          return response;
	        };

	        this._parent = parent;
	      }

	      hasLocalChanges() {
	        for (let i = 0; i < this._original.length; i++) {
	          if (this._original[i].guid !== this._dirty[i].guid) {
	            return true;
	          }
	        }

	        return false;
	      }

	      move(oldIndex, newIndex) {
	        const item = this._dirty[oldIndex];
	        const anchor = this._dirty[newIndex]; // Depending on in which direction the move is, use 'after' or 'before'
	        // to specify the relative position to the anchor element

	        const order = newIndex > oldIndex ? 'after' : 'before';
	        arr_move(this._dirty, oldIndex, newIndex);

	        this._events.push({
	          item,
	          order,
	          anchor
	        });
	      }

	      async save() {
	        try {
	          for (const event of this._events) {
	            await this._parent.sortModel(event.item, event.order, event.anchor);

	            const oldIndex = this._dirty.findIndex(model => model.guid === event.item.guid);

	            const newIndex = this._dirty.findIndex(model => model.guid === event.anchor.guid);

	            arr_move(this._original, oldIndex, newIndex);
	          }
	        } finally {
	          this.reset();
	        }
	      }

	      reset() {
	        this._events = [];
	        this._dirty = Array.from(this._original);
	      }

	      _updateSortData(response) {
	        this._dirty.push(...response.data);

	        this._original.push(...response.data);
	      }

	    }

	    exports.PaginationOrder = void 0;

	    (function (PaginationOrder) {
	      PaginationOrder["ASC"] = "asc";
	      PaginationOrder["DESC"] = "desc";
	    })(exports.PaginationOrder || (exports.PaginationOrder = {}));
	    /**
	     * Filters are parsed to the correct laravel-query-builder format
	     * @param filters
	     */


	    function parseFilters(filters) {
	      const map = {};

	      for (const key of Object.keys(filters)) {
	        map[`filter[${key}]`] = `${filters[key]}`;
	      }

	      return map;
	    }
	    /**
	     * Ordering is parsed to the correct laravel-query-builder format
	     * @param ordering
	     */


	    function parseOrdering(ordering) {
	      const params = {
	        sort: ''
	      }; // Order the order rules by index

	      const ordered = Object.entries(ordering).map(([field, fieldOrdering]) => ({
	        field,
	        ...fieldOrdering
	      })).sort((a, b) => a.index - b.index);

	      for (const item of ordered) {
	        params.sort += item.order === exports.PaginationOrder.DESC ? `-${item.field}` : item.field;
	      }

	      return params;
	    }

	    class ArrayPaginatable {
	      constructor(data) {
	        this.getPage = async request => {
	          const total = this._data.length;
	          const page = request.page || 1;
	          const perPage = request.per_page || 5;
	          const lastPage = Math.ceil(total / perPage);
	          const data = [];

	          for (let i = 0; i < perPage; i++) {
	            const j = perPage * (page - 1) + i;

	            if (j >= total) {
	              break;
	            }

	            data.push(this._data[j]);
	          }

	          return {
	            current_page: page,
	            last_page: lastPage,
	            per_page: perPage,
	            total,
	            data,
	            path: '',
	            first_page_url: '',
	            last_page_url: '',
	            from: '',
	            to: ''
	          };
	        };

	        this._data = data;
	      }

	    }

	    const REFRESH_DEBOUNCE_MILLIS$1 = 300;

	    class Pagination {
	      /**
	       * @param paginatable
	       * @param optionals
	       */
	      constructor(paginatable, optionals) {
	        this.loading = false;
	        this.page = null;
	        this.filters = {};
	        this._ordering = {};
	        this._refreshDebounce = null;
	        this._refreshPromise = null;
	        this._refreshPromiseResolve = null;
	        this._initialized = false;

	        if (typeof paginatable === 'function') {
	          this._paginatable = paginatable;
	        } else {
	          this._paginatable = paginatable.getPage;
	        }

	        this._optionals = optionals || {};
	      }

	      defaults() {
	        return { ...this._request
	        };
	      }
	      /**
	       * Initialize with default or specified configuration and fetch the first page.
	       * @param _config
	       */


	      async init(_config) {
	        const config = _config || {};
	        this._request = {
	          page: 1,
	          ...config.defaults
	        };

	        if (config && config.filters) {
	          Object.assign(this.filters, config.filters);
	        }

	        await this.getPage(this._request);
	        this._initialized = true;
	      }
	      /**
	       * @param field
	       * @param value
	       */


	      async addFilter(field, value) {
	        this._checkIfInitialized();

	        this.filters[field] = value;
	        return this._refreshWithDebounce();
	      }
	      /**
	       * @param field
	       */


	      async removeFilter(field) {
	        this._checkIfInitialized();

	        delete this.filters[field];
	        return this._refreshWithDebounce();
	      }
	      /**
	       * Check if the canOrder method is implemented and the specified field can be ordered.
	       * @param field
	       */


	      canOrder(field) {
	        if (!this._optionals.canOrder) {
	          return false;
	        }

	        return this._optionals.canOrder(field);
	      }
	      /**
	       * Returns the ordering that is set for the specified field.
	       * @param field
	       */


	      getFieldOrder(field) {
	        if (this._ordering[field]) {
	          return this._ordering[field];
	        }

	        return null;
	      }
	      /**
	       * @param field
	       * @param order
	       */


	      async addOrder(field, order) {
	        this._checkIfInitialized();

	        if (!this.canOrder(field)) {
	          throw new StringError('Field cannot be ordered');
	        } // TODO: Add support for multiple orderings


	        this._ordering = {
	          [field]: {
	            order,
	            index: 0
	          }
	        };
	        return this._refreshWithDebounce();
	      }
	      /**
	       * @param field
	       */


	      async removeOrder(field) {
	        this._checkIfInitialized(); // TODO: Add support for multiple orderings


	        this._ordering = {};
	        return this._refreshWithDebounce();
	      }
	      /**
	       * Retrieves the page from the api again, overwriting the local state.
	       * If no custom request is specified the request in the local state is used.
	       * @param request
	       */


	      async refresh(request) {
	        return this.getPage(request || this._request);
	      }

	      async nextPage() {
	        this._checkIfInitialized();

	        return this.getPage({ ...this._request,
	          page: this.page.current_page + 1
	        });
	      }

	      async prevPage() {
	        this._checkIfInitialized();

	        return this.getPage({ ...this._request,
	          page: this.page.current_page - 1
	        });
	      }
	      /**
	       * Retrieve the correct page from the api based on the specified request.
	       * @param request
	       */


	      async getPage(request) {
	        this.loading = true;

	        try {
	          this.page = await this._paginatable({ ...parseFilters(this.filters),
	            ...parseOrdering(this._ordering),
	            ...this._request,
	            ...request
	          });
	          return this.page;
	        } finally {
	          this.loading = false;
	        }
	      }
	      /**
	       * Retrieves the page from the api with a debounce to keep the amount of api requests low.
	       * The local state request is used.
	       * @private
	       */


	      async _refreshWithDebounce() {
	        if (!this._refreshPromise) {
	          this._refreshPromise = new Promise(resolve => {
	            this._refreshPromiseResolve = resolve;
	          });
	        }

	        this.loading = true;

	        if (this._refreshDebounce) {
	          window.clearTimeout(this._refreshDebounce);
	        }

	        this._refreshDebounce = window.setTimeout(async () => {
	          this._refreshDebounce = null;
	          const p = await this.getPage(this._request);

	          this._refreshPromiseResolve(p);

	          this._refreshPromise = null;
	          this._refreshPromiseResolve = null;
	        }, REFRESH_DEBOUNCE_MILLIS$1);
	        return this._refreshPromise;
	      }
	      /**
	       * @private
	       */


	      _checkIfInitialized() {
	        if (!this._initialized) {
	          throw new StringError('Pagination not initialized');
	        }
	      }

	    }

	    const REFRESH_DEBOUNCE_MILLIS = 300;

	    class LazyList {
	      /**
	       * @param paginatable
	       * @param optionals
	       */
	      constructor(paginatable, optionals) {
	        this.loading = false;
	        this.filters = {};
	        this.data = [];
	        this.response = null;
	        this.hasMore = true;
	        this._refreshDebounce = null;
	        this._refreshPromise = null;
	        this._refreshPromiseResolve = null;

	        if (typeof paginatable === 'function') {
	          this._paginatable = paginatable;
	        } else {
	          this._paginatable = paginatable.getPage;
	        }

	        this._optionals = optionals || {};
	      }
	      /**
	       * Initialize with default or specified configuration and fetch the first data.
	       * @param _config
	       */


	      async init(_config) {
	        const config = _config || {};
	        this._request = {
	          page: 1,
	          ...config.defaults
	        };
	        this.data = [];
	        this.hasMore = true;

	        if (config && config.filters) {
	          Object.assign(this.filters, config.filters);
	        }

	        await this.loadMore();
	      }
	      /**
	       * @param key
	       * @param filter
	       */


	      async addFilter(key, filter) {
	        this.filters[key] = filter;
	        await this._refreshWithDebounce();
	      }
	      /**
	       * @param key
	       */


	      async removeFilter(key) {
	        delete this.filters[key];
	        await this._refreshWithDebounce();
	      }

	      async refresh() {
	        await this._refreshWithDebounce();
	      }
	      /**
	       * Load the next page and append it to the local state data.
	       */


	      async loadMore() {
	        if (!this.hasMore) {
	          throw new StringError('No items left to retrieve');
	        }

	        this.loading = true;

	        try {
	          const page = this._request.page++;
	          const res = await this._paginatable({ ...this._request,
	            ...parseFilters(this.filters),
	            page
	          });
	          this.data.push(...res.data);
	          this.response = { ...res,
	            data: undefined
	          };

	          if (this.data.length === res.total) {
	            this.hasMore = false;
	          }
	        } finally {
	          this.loading = false;
	        }
	      }
	      /**
	       * Load the next page and append it to the local state data with a debounce to keep the amount of api request low.
	       * @private
	       */


	      async _refreshWithDebounce() {
	        if (!this._refreshPromise) {
	          this._refreshPromise = new Promise(resolve => {
	            this._refreshPromiseResolve = resolve;
	          });
	        }

	        this.loading = true;
	        this.data = [];

	        if (this._refreshDebounce) {
	          window.clearTimeout(this._refreshDebounce);
	        }

	        this._refreshDebounce = window.setTimeout(async () => {
	          this._refreshDebounce = null;
	          this._request.page = 1;
	          await this.init({
	            defaults: this._request
	          });

	          this._refreshPromiseResolve();

	          this._refreshPromise = null;
	          this._refreshPromiseResolve = null;
	        }, REFRESH_DEBOUNCE_MILLIS);
	        return this._refreshPromise;
	      }

	    }

	    function addGlobal(scope, ref) {
	      let root = window || commonjsGlobal;

	      if (!root) {
	        return;
	      }

	      root = root.OpenTicket = root.OpenTicket || {};
	      root[scope] = ref;
	    }

	    exports.ArrayPaginatable = ArrayPaginatable;
	    exports.BaseError = BaseError;
	    exports.ConsoleOutput = ConsoleOutput;
	    exports.CrudFactory = CrudFactory;
	    exports.CrudModel = CrudModel;
	    exports.CrudModelProps = CrudModelProps;
	    exports.CrudNode = CrudNode;
	    exports.CrudRoot = CrudRoot;
	    exports.CrudRoute = index;
	    exports.CrudToMany = CrudToMany;
	    exports.CrudToManyMixin = CrudToManyMixin;
	    exports.CrudToOne = CrudToOne;
	    exports.Form = Form;
	    exports.FormValidationError = FormValidationError;
	    exports.LazyList = LazyList;
	    exports.Logger = Logger;
	    exports.ModelForm = ModelForm;
	    exports.NestedPicker = NestedPicker;
	    exports.Pagination = Pagination;
	    exports.Picker = Picker;
	    exports.ServiceOutput = ServiceOutput;
	    exports.Sorter = Sorter;
	    exports.StringError = StringError;
	    exports.UnexpectedError = UnexpectedError;
	    exports.addGlobal = addGlobal;
	    exports.levelNumberToLevel = levelNumberToLevel;
	    exports.levelToLevelNumber = levelToLevelNumber;
	    exports.parseFilters = parseFilters;
	    exports.parseOrdering = parseOrdering;
	    exports.toMany = toMany;
	    Object.defineProperty(exports, '__esModule', {
	      value: true
	    });
	  });
	})(helpers, helpers.exports);

	var uaParser = {exports: {}};

	(function (module, exports) {
	  /////////////////////////////////////////////////////////////////////////////////

	  /* UAParser.js v1.0.2
	     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
	     MIT License */

	  /*
	  Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	  Supports browser & node.js environment. 
	  Demo   : https://faisalman.github.io/ua-parser-js
	  Source : https://github.com/faisalman/ua-parser-js */
	  /////////////////////////////////////////////////////////////////////////////////
	  (function (window, undefined$1) {
	    // Constants
	    /////////////

	    var LIBVERSION = '1.0.2',
	        EMPTY = '',
	        UNKNOWN = '?',
	        FUNC_TYPE = 'function',
	        UNDEF_TYPE = 'undefined',
	        OBJ_TYPE = 'object',
	        STR_TYPE = 'string',
	        MAJOR = 'major',
	        MODEL = 'model',
	        NAME = 'name',
	        TYPE = 'type',
	        VENDOR = 'vendor',
	        VERSION = 'version',
	        ARCHITECTURE = 'architecture',
	        CONSOLE = 'console',
	        MOBILE = 'mobile',
	        TABLET = 'tablet',
	        SMARTTV = 'smarttv',
	        WEARABLE = 'wearable',
	        EMBEDDED = 'embedded',
	        UA_MAX_LENGTH = 255;
	    var AMAZON = 'Amazon',
	        APPLE = 'Apple',
	        ASUS = 'ASUS',
	        BLACKBERRY = 'BlackBerry',
	        BROWSER = 'Browser',
	        CHROME = 'Chrome',
	        EDGE = 'Edge',
	        FIREFOX = 'Firefox',
	        GOOGLE = 'Google',
	        HUAWEI = 'Huawei',
	        LG = 'LG',
	        MICROSOFT = 'Microsoft',
	        MOTOROLA = 'Motorola',
	        OPERA = 'Opera',
	        SAMSUNG = 'Samsung',
	        SONY = 'Sony',
	        XIAOMI = 'Xiaomi',
	        ZEBRA = 'Zebra',
	        FACEBOOK = 'Facebook'; ///////////
	    // Helper
	    //////////

	    var extend = function (regexes, extensions) {
	      var mergedRegexes = {};

	      for (var i in regexes) {
	        if (extensions[i] && extensions[i].length % 2 === 0) {
	          mergedRegexes[i] = extensions[i].concat(regexes[i]);
	        } else {
	          mergedRegexes[i] = regexes[i];
	        }
	      }

	      return mergedRegexes;
	    },
	        enumerize = function (arr) {
	      var enums = {};

	      for (var i = 0; i < arr.length; i++) {
	        enums[arr[i].toUpperCase()] = arr[i];
	      }

	      return enums;
	    },
	        has = function (str1, str2) {
	      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
	    },
	        lowerize = function (str) {
	      return str.toLowerCase();
	    },
	        majorize = function (version) {
	      return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
	    },
	        trim = function (str, len) {
	      if (typeof str === STR_TYPE) {
	        str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
	        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	      }
	    }; ///////////////
	    // Map helper
	    //////////////


	    var rgxMapper = function (ua, arrays) {
	      var i = 0,
	          j,
	          k,
	          p,
	          q,
	          matches,
	          match; // loop through all regexes maps

	      while (i < arrays.length && !matches) {
	        var regex = arrays[i],
	            // even sequence (0,2,4,..)
	        props = arrays[i + 1]; // odd sequence (1,3,5,..)

	        j = k = 0; // try matching uastring with regexes

	        while (j < regex.length && !matches) {
	          matches = regex[j++].exec(ua);

	          if (!!matches) {
	            for (p = 0; p < props.length; p++) {
	              match = matches[++k];
	              q = props[p]; // check if given property is actually array

	              if (typeof q === OBJ_TYPE && q.length > 0) {
	                if (q.length === 2) {
	                  if (typeof q[1] == FUNC_TYPE) {
	                    // assign modified match
	                    this[q[0]] = q[1].call(this, match);
	                  } else {
	                    // assign given value, ignore regex match
	                    this[q[0]] = q[1];
	                  }
	                } else if (q.length === 3) {
	                  // check whether function or regex
	                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                    // call function (usually string mapper)
	                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
	                  } else {
	                    // sanitize match using given regex
	                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
	                  }
	                } else if (q.length === 4) {
	                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
	                }
	              } else {
	                this[q] = match ? match : undefined$1;
	              }
	            }
	          }
	        }

	        i += 2;
	      }
	    },
	        strMapper = function (str, map) {
	      for (var i in map) {
	        // check if current value is array
	        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	          for (var j = 0; j < map[i].length; j++) {
	            if (has(map[i][j], str)) {
	              return i === UNKNOWN ? undefined$1 : i;
	            }
	          }
	        } else if (has(map[i], str)) {
	          return i === UNKNOWN ? undefined$1 : i;
	        }
	      }

	      return str;
	    }; ///////////////
	    // String map
	    //////////////
	    // Safari < 3.0


	    var oldSafariMap = {
	      '1.0': '/8',
	      '1.2': '/1',
	      '1.3': '/3',
	      '2.0': '/412',
	      '2.0.2': '/416',
	      '2.0.3': '/417',
	      '2.0.4': '/419',
	      '?': '/'
	    },
	        windowsVersionMap = {
	      'ME': '4.90',
	      'NT 3.11': 'NT3.51',
	      'NT 4.0': 'NT4.0',
	      '2000': 'NT 5.0',
	      'XP': ['NT 5.1', 'NT 5.2'],
	      'Vista': 'NT 6.0',
	      '7': 'NT 6.1',
	      '8': 'NT 6.2',
	      '8.1': 'NT 6.3',
	      '10': ['NT 6.4', 'NT 10.0'],
	      'RT': 'ARM'
	    }; //////////////
	    // Regex map
	    /////////////

	    var regexes = {
	      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
	      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
	      ], [VERSION, [NAME, 'Edge']], [// Presto based
	      /(opera mini)\/([-\w\.]+)/i, // Opera Mini
	      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, // Opera Mobi/Tablet
	      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
	      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
	      ], [VERSION, [NAME, OPERA + ' Mini']], [/\bopr\/([\w\.]+)/i // Opera Webkit
	      ], [VERSION, [NAME, OPERA]], [// Mixed
	      /(kindle)\/([\w\.]+)/i, // Kindle
	      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	      // Trident based
	      /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
	      /(ba?idubrowser)[\/ ]?([\w\.]+)/i, // Baidu Browser
	      /(?:ms|\()(ie) ([\w\.]+)/i, // Internet Explorer
	      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i, // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
	      /(weibo)__([\d\.]+)/i // Weibo
	      ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
	      ], [VERSION, [NAME, 'UC' + BROWSER]], [/\bqbcore\/([\w\.]+)/i // WeChat Desktop for Windows Built-in Browser
	      ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
	      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
	      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
	      ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
	      ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
	      ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
	      ], [VERSION, [NAME, FIREFOX + ' Focus']], [/\bopt\/([\w\.]+)/i // Opera Touch
	      ], [VERSION, [NAME, OPERA + ' Touch']], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
	      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
	      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
	      ], [VERSION, [NAME, OPERA + ' Coast']], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
	      ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
	      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
	      ], [[NAME, '360 ' + BROWSER]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [// Oculus/Samsung/Sailfish Browser
	      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
	      ], [[NAME, /_/g, ' '], VERSION], [/(electron)\/([\w\.]+) safari/i, // Electron-based App
	      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, // Tesla
	      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
	      ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i, // SouGouBrowser
	      /(lbbrowser)/i // LieBao Browser
	      ], [NAME], [// WebView
	      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
	      ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i, // Line App for iOS
	      /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
	      /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
	      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
	      ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
	      ], [VERSION, [NAME, CHROME + ' Headless']], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
	      ], [[NAME, CHROME + ' WebView'], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
	      ], [VERSION, [NAME, 'Android ' + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
	      ], [NAME, VERSION], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i // Mobile Safari
	      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
	      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
	      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
	      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
	      ], [[NAME, 'Netscape'], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
	      ], [VERSION, [NAME, FIREFOX + ' Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
	      /(swiftfox)/i, // Swiftfox
	      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
	      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	      /(firefox)\/([\w\.]+)/i, // Other Firefox-based
	      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, // Mozilla
	      // Other
	      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
	      /(links) \(([\w\.]+)/i // Links
	      ], [NAME, VERSION]],
	      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
	      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
	      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
	      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
	      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
	      ], [[ARCHITECTURE, 'armhf']], [// PocketPC mistakenly identified as PowerPC
	      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
	      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
	      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	      ], [[ARCHITECTURE, lowerize]]],
	      device: [[//////////////////////////
	      // MOBILES & TABLETS
	      // Ordered by popularity
	      /////////////////////////
	      // Samsung
	      /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [// Apple
	      /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
	      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, // iPad
	      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [// Huawei
	      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [// Xiaomi
	      /\b(poco[\w ]+)(?: bui|\))/i, // Xiaomi POCO
	      /\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
	      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
	      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
	      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
	      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
	      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [// OPPO
	      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [// Vivo
	      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [// Realme
	      /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [// Motorola
	      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [// LG
	      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [// Lenovo
	      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [// Nokia
	      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [// Google
	      /(pixel c)\b/i // Google Pixel C
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [// Sony
	      /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [// OnePlus
	      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [// Amazon
	      /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, // Kindle Fire without Silk
	      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
	      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
	      ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [// BlackBerry
	      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
	      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
	      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [// Asus
	      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [// HTC
	      /(nexus 9)/i // HTC Nexus 9
	      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC
	      // ZTE
	      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [// Acer
	      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [// Meizu
	      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [// Sharp
	      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [// MIXED
	      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	      /(hp) ([\w ]+\w)/i, // HP iPAQ
	      /(asus)-?(\w+)/i, // Asus
	      /(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
	      /(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
	      /(jolla)/i, // Jolla
	      /(oppo) ?([\w ]+) bui/i // OPPO
	      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i, // Archos
	      /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
	      /(kindle)\/([\w\.]+)/i, // Kindle
	      /(nook)[\w ]+build\/(\w+)/i, // Nook
	      /(dell) (strea[kpr\d ]*[\dko])/i, // Dell Streak
	      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, // Le Pan Tablets
	      /(trinity)[- ]*(t\d{3}) bui/i, // Trinity Tablets
	      /(gigaset)[- ]+(q\w{1,9}) bui/i, // Gigaset Tablets
	      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
	      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
	      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
	      ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
	      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
	      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
	      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
	      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
	      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
	      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
	      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
	      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
	      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
	      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
	      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
	      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
	      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
	      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
	      ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
	      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
	      ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
	      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
	      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
	      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
	      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
	      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
	      ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
	      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [///////////////////
	      // CONSOLES
	      ///////////////////
	      /(ouya)/i, // Ouya
	      /(nintendo) ([wids3utch]+)/i // Nintendo
	      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
	      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
	      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
	      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [///////////////////
	      // SMARTTVS
	      ///////////////////
	      /smart-tv.+(samsung)/i // Samsung
	      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
	      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
	      ], [VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
	      ], [[MODEL, CHROME + 'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
	      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
	      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, // Roku
	      /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
	      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
	      ], [[TYPE, SMARTTV]], [///////////////////
	      // WEARABLES
	      ///////////////////
	      /((pebble))app/i // Pebble
	      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
	      ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [///////////////////
	      // EMBEDDED
	      ///////////////////
	      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
	      ], [VENDOR, [TYPE, EMBEDDED]], [////////////////////
	      // MIXED (GENERIC)
	      ///////////////////
	      /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
	      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
	      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
	      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
	      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
	      ], [MODEL, [VENDOR, 'Generic']]],
	      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
	      ], [VERSION, [NAME, EDGE + 'HTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
	      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
	      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	      /ekioh(flow)\/([\w\.]+)/i, // Flow
	      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, // KHTML/Tasman/Links
	      /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
	      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
	      ], [VERSION, NAME]],
	      os: [[// Windows
	      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
	      ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i, // Windows RT
	      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, // Windows Phone
	      /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [// iOS/macOS
	      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, // iOS
	      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
	      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Mobile OSes
	      /droid ([\w\.]+)\b.+(android[- ]x86)/i // Android-x86
	      ], [VERSION, NAME], [// Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
	      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
	      /(tizen|kaios)[\/ ]([\w\.]+)/i, // Tizen/KaiOS
	      /\((series40);/i // Series 40
	      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
	      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
	      ], [VERSION, [NAME, 'Symbian']], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
	      ], [VERSION, [NAME, FIREFOX + ' OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
	      ], [VERSION, [NAME, 'webOS']], [// Google Chromecast
	      /crkey\/([\d\.]+)/i // Google Chromecast
	      ], [VERSION, [NAME, CHROME + 'cast']], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
	      ], [[NAME, 'Chromium OS'], VERSION], [// Console
	      /(nintendo|playstation) ([wids345portablevuch]+)/i, // Nintendo/Playstation
	      /(xbox); +xbox ([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)
	      // Other
	      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, // Joli/Palm
	      /(mint)[\/\(\) ]?(\w*)/i, // Mint
	      /(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
	      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
	      /(hurd|linux) ?([\w\.]*)/i, // Hurd/Linux
	      /(gnu) ?([\w\.]*)/i, // GNU
	      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
	      /(haiku) (\w+)/i // Haiku
	      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
	      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, // Solaris
	      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, // AIX
	      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
	      /(unix) ?([\w\.]*)/i // UNIX
	      ], [NAME, VERSION]]
	    }; /////////////////
	    // Constructor
	    ////////////////

	    var UAParser = function (ua, extensions) {
	      if (typeof ua === OBJ_TYPE) {
	        extensions = ua;
	        ua = undefined$1;
	      }

	      if (!(this instanceof UAParser)) {
	        return new UAParser(ua, extensions).getResult();
	      }

	      var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

	      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

	      this.getBrowser = function () {
	        var _browser = {};
	        _browser[NAME] = undefined$1;
	        _browser[VERSION] = undefined$1;
	        rgxMapper.call(_browser, _ua, _rgxmap.browser);
	        _browser.major = majorize(_browser.version);
	        return _browser;
	      };

	      this.getCPU = function () {
	        var _cpu = {};
	        _cpu[ARCHITECTURE] = undefined$1;
	        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
	        return _cpu;
	      };

	      this.getDevice = function () {
	        var _device = {};
	        _device[VENDOR] = undefined$1;
	        _device[MODEL] = undefined$1;
	        _device[TYPE] = undefined$1;
	        rgxMapper.call(_device, _ua, _rgxmap.device);
	        return _device;
	      };

	      this.getEngine = function () {
	        var _engine = {};
	        _engine[NAME] = undefined$1;
	        _engine[VERSION] = undefined$1;
	        rgxMapper.call(_engine, _ua, _rgxmap.engine);
	        return _engine;
	      };

	      this.getOS = function () {
	        var _os = {};
	        _os[NAME] = undefined$1;
	        _os[VERSION] = undefined$1;
	        rgxMapper.call(_os, _ua, _rgxmap.os);
	        return _os;
	      };

	      this.getResult = function () {
	        return {
	          ua: this.getUA(),
	          browser: this.getBrowser(),
	          engine: this.getEngine(),
	          os: this.getOS(),
	          device: this.getDevice(),
	          cpu: this.getCPU()
	        };
	      };

	      this.getUA = function () {
	        return _ua;
	      };

	      this.setUA = function (ua) {
	        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
	        return this;
	      };

	      this.setUA(_ua);
	      return this;
	    };

	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
	    UAParser.CPU = enumerize([ARCHITECTURE]);
	    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
	    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]); ///////////
	    // Export
	    //////////
	    // check js environment

	    {
	      // nodejs env
	      if (module.exports) {
	        exports = module.exports = UAParser;
	      }

	      exports.UAParser = UAParser;
	    } // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.


	    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);

	    if ($ && !$.ua) {
	      var parser = new UAParser();
	      $.ua = parser.getResult();

	      $.ua.get = function () {
	        return parser.getUA();
	      };

	      $.ua.set = function (ua) {
	        parser.setUA(ua);
	        var result = parser.getResult();

	        for (var prop in result) {
	          $.ua[prop] = result[prop];
	        }
	      };
	    }
	  })(typeof window === 'object' ? window : commonjsGlobal);
	})(uaParser, uaParser.exports);

	class OrderError extends helpers.exports.StringError {
	}

	class OrderRefundError extends helpers.exports.StringError {
	    constructor(slug, message, data, response) {
	        super(slug, message);
	        this._isOrderRefundError = true;
	        this._refundData = data || {};
	        this._response = response;
	    }
	    static is(e) {
	        return Object.prototype.hasOwnProperty.call(e, '_isOrderRefundError');
	    }
	    additionalFlatData() {
	        try {
	            return {
	                ...this._refundData,
	                ...marshalOrderError(this._response),
	            };
	        }
	        catch (e) {
	            return this._refundData;
	        }
	    }
	    toSlug() {
	        return {
	            key: this.data,
	            data: this.additionalFlatData(),
	        };
	    }
	}
	function marshalOrderError(e) {
	    if (e) {
	        try {
	            return {
	                errors: e.data.errors.map((error) => error.reason).join('\n'),
	                firstError: getOrderErrorSlug(e.data.errors),
	            };
	        }
	        catch (_) {
	            // No-op
	        }
	    }
	    return {
	        errors: '<unknown errors>',
	        firstError: 'order.errors.refund.unknown',
	    };
	}
	function getOrderErrorSlug(errors) {
	    for (const error of errors) {
	        if (!error.reason) {
	            continue;
	        }
	        switch (error.reason) {
	            case 'cannot execute refund for order, please enter IBAN information':
	                return 'order.errors.refund.iban';
	            case 'Order cannot be found':
	                return 'order.errors.refund.order_not_found';
	            case 'Cannot handle returns for order, it was never paid':
	                return 'order.errors.refund.never_paid';
	            case 'payment present more than once':
	                return 'order.errors.refund.payment_duplicate';
	            case 'ticket present more than once':
	                return 'order.errors.refund.ticket_duplicate';
	            case 'product present more than once':
	                return 'order.errors.refund.product_duplicate';
	            case 'product not found':
	                return 'order.errors.refund.product_not_found';
	            case 'ticket not found':
	                return 'order.errors.refund.ticket_not_found';
	            case 'payment not found':
	                return 'order.errors.refund.payment_not_found';
	            case 'Arbitrary return larger than sum of item values':
	                return 'order.errors.refund.arbitrary_larger_than_sum';
	        }
	    }
	    return 'order.errors.refund.unknown';
	}

	class OrderRefundItemError extends helpers.exports.BaseError {
	    constructor() {
	        super(...arguments);
	        this._level = helpers.exports.LevelNumber.Debug;
	    }
	    toSlug() {
	        return {
	            data: {
	                name: this.data.name,
	            },
	            key: 'sdk.errors.not_refundable',
	        };
	    }
	    toString() {
	        return `Not refundable ${this.data.type} ${this.data.guid}`;
	    }
	    additionalFlatData() {
	        return this.data;
	    }
	}

	function jsonStringify(value, or) {
	    try {
	        return JSON.stringify(value);
	    }
	    catch (e) {
	        return or;
	    }
	}
	class OrderRefundMessage extends helpers.exports.BaseError {
	    constructor(slug, data) {
	        super(data);
	        this._level = helpers.exports.LevelNumber.Debug;
	        this._slug = slug;
	    }
	    toSlug() {
	        return {
	            key: this._slug,
	        };
	    }
	    toString() {
	        return `Refund debug message: ${this.toSlug().key}`;
	    }
	    additionalFlatData() {
	        const flatData = {
	            donatePercentage: jsonStringify(this.data.donatePercentage, 'NaN'),
	            items: jsonStringify(this.data.items, '[]'),
	            refundSetting: jsonStringify(this.data.refundSetting, 'null'),
	            toVoucher: jsonStringify(this.data.toVoucher, 'null'),
	        };
	        if (this.data.refundOrderId) {
	            flatData.refundOrderId = this.data.refundOrderId;
	        }
	        if (this.data.refundAmount) {
	            flatData.refundAmount = jsonStringify(this.data.refundAmount, 'NaN');
	        }
	        if (this.data.refundRedirectUrl) {
	            flatData.refundRedirectUrl = this.data.refundRedirectUrl;
	        }
	        return flatData;
	    }
	}

	// An UnknownOrderError should never occur.
	// It should only be used for unexpected errors.
	// The specific error should only appear ONCE the logs,
	// after which that particular error should be handled properly.
	class UnknownOrderError extends OrderError {
	    constructor(slug, message, error) {
	        super(slug, message);
	        this._error = error;
	    }
	    additionalFlatData() {
	        if (!this._error) {
	            return {
	                error: 'Unknown',
	            };
	        }
	        try {
	            const data = {
	                error: JSON.stringify({
	                    ...this._error,
	                }),
	                errorMessage: this._error.message,
	                errorName: this._error.name,
	            };
	            if (this._error.stack) {
	                data.errorStack = this._error.stack;
	            }
	            const { response } = this._error;
	            if (response && response.data) {
	                data.responseData = JSON.stringify(response.data);
	            }
	            return data;
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                return { error: 'Unknown', jsonError: `${e.name}: ${e.message}` };
	            }
	            return { error: 'Unknown', jsonError: 'Unknown' };
	        }
	    }
	}

	let adsBlockedPromise;
	/**
	 * @internal Used to guess if the user uses an ad blocker.
	 *
	 * (!) This will make a (HEAD) call to Google's ad services,
	 * without cors, credentials (cookies) and referrer.
	 */
	async function adsBlocked() {
	    if (adsBlockedPromise) {
	        return adsBlockedPromise;
	    }
	    if (!window || !window.fetch) {
	        return true;
	    }
	    adsBlockedPromise = window.fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
	        method: 'HEAD',
	        mode: 'no-cors',
	        credentials: 'omit',
	        referrerPolicy: 'no-referrer',
	        cache: 'no-store',
	    })
	        .then(() => false)
	        .catch(() => true);
	    return adsBlockedPromise;
	}

	function guessTimezone() {
	    try {
	        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	        if (zone && zone.length > 3) {
	            return zone;
	        }
	    }
	    catch (e) {
	        // Cannot precisely retrieve timezone!
	    }
	    return undefined;
	}

	/**
	 *  Parse the URI's query into keys and values.
	 *
	 *  Multiple values per key are supported, as are key only query params.
	 */
	function parseQuery() {
	    if (!document || !document.location || !document.location.search) {
	        return {};
	    }
	    const searchParams = new URLSearchParams(document.location.search);
	    const map = {};
	    for (const [key, value] of searchParams) {
	        if (Object.prototype.hasOwnProperty.call(map, key)) {
	            // When the key already exists, there is at least 1 value - either a string or an array of strings.
	            // After adding the current value, it should always be an array.
	            map[key] = [].concat(map[key], value);
	        }
	        else {
	            // When the key does not yet exist, after adding the current value,
	            // there will be exactly one value, thus should be a string.
	            map[key] = value;
	        }
	    }
	    return map;
	}

	/**
	 *  Handle the refund order data given in the refund order options
	 *  This will compile the order and send it to the API.
	 *
	 *  ```ts
	 *  const response: RefundOrderResponse = handleRefund(refundOrderOptions);
	 *  ```
	 */
	async function handleRefund(config, options) {
	    if (!config) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.config', 'Failed to handle refund order: No config provided');
	    }
	    if (!config.httpClient || !config.httpClient.post) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.config', 'Failed to handle refund order: No valid http client provided');
	    }
	    if (!config.baseUrl) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.config', 'Failed to handle refund order: No valid base URL provided');
	    }
	    const logData = {
	        baseUrl: config.baseUrl,
	    };
	    if (!config.shopId) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.config', 'Failed to handle refund order: No valid shop ID provided', logData);
	    }
	    logData.shopId = config.shopId;
	    if (!options) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.options', 'Failed to handle refund order: No options provided', logData);
	    }
	    if (!options.booker
	        || !options.booker.email
	        || !options.booker.firstname
	        || !options.booker.lastname
	        || !options.booker.locale) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.bookerinfo', 'Failed to handle refund order: No valid bookerinfo provided', logData);
	    }
	    try {
	        logData.booker = JSON.stringify(options.booker);
	    }
	    catch (e) {
	        logData.booker = '<invalid json>';
	    }
	    if (!options.orderId) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.orderid', 'Failed to handle refund order: No valid order ID provided', logData);
	    }
	    logData.orderId = options.orderId;
	    if (!options.items || !options.items.length) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.items', 'Failed to handle refund order: No valid return items provided', logData);
	    }
	    try {
	        logData.items = JSON.stringify(options.items);
	    }
	    catch (e) {
	        logData.items = '<invalid json>';
	    }
	    if (!options.paymentMethod || !options.paymentMethod.guid || !options.paymentMethod.currency) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.paymentmethod', 'Failed to handle refund order: No valid payment method provided', logData);
	    }
	    try {
	        logData.booker = JSON.stringify(options.paymentMethod);
	    }
	    catch (e) {
	        logData.booker = '<invalid json>';
	    }
	    if (!options.reason) {
	        throw new OrderRefundError('order.errors.orderbuilder.refund.handle.reason', 'Failed to handle refund order: No valid reason provided', logData);
	    }
	    logData.reason = options.reason;
	    const returnsOrderData = {
	        includes_fees: options.includesFees,
	        items: options.items,
	        order_id: options.orderId,
	        reason: options.reason,
	        to_voucher: options.toVoucher,
	    };
	    if (options.donatePercentage && options.donatePercentage > 0) {
	        returnsOrderData.arbitrary = {
	            percentage: options.donatePercentage,
	            // A gift is by default 0 vat.
	            // However, this might not be true for all countries!!!
	            // We do not have this notion right now though...
	            vat: 0,
	        };
	    }
	    const orderData = {
	        receiver: {
	            email: options.booker.email,
	            firstname: options.booker.firstname,
	            lastname: options.booker.lastname,
	            locale: options.booker.locale,
	        },
	        return: returnsOrderData,
	        paymentProvider: options.paymentMethod.guid,
	        currency: options.paymentMethod.currency,
	        extraMetaData: {
	            ...await getTechData(options.initAt),
	            originalOrderId: options.orderId,
	        },
	    };
	    // Note: Some browsers (micro)-cache XHR requests... so we make the resource id (URI) unique!
	    // DD-Frontend-2718
	    const url = config.getNoCacheUrl(urlJoin(config.baseUrl, config.shopId, 'order'));
	    try {
	        const response = await config.httpClient.post(url, orderData);
	        return response.data;
	    }
	    catch (error) {
	        if (isResponseError(error) && error.response.status >= 400 && error.response.status < 500) {
	            throw new OrderRefundError('order.errors.orderbuilder.refund.handle.failed', 'Failed to send refund order', logData, error.response);
	        }
	        else if (error instanceof Error) {
	            error.refundData = logData;
	            throw new UnknownOrderError('order.errors.orderbuilder.refund.handle.fatal', 'Failed to send refund order', error);
	        }
	        else {
	            throw new OrderRefundError('order.errors.orderbuilder.refund.handle.fatal', 'Failed to send refund order', logData);
	        }
	    }
	}
	/**
	 * Transform arbitrary data into a tech-data object.
	 *
	 * This data is mainly for understanding order flow and debugging purposes.
	 */
	async function getTechData(initAt) {
	    const dppx = +(window ? window.devicePixelRatio : 0);
	    const dpi = dppx * 96;
	    const uaParser$1 = new uaParser.exports.UAParser();
	    const adblock = await adsBlocked();
	    return {
	        adblock,
	        cookieEnabled: navigator.cookieEnabled,
	        doNotTrack: !!navigator.doNotTrack,
	        queryParams: parseQuery(),
	        referrer: document.referrer,
	        screen: {
	            dpcm: dpi / 2.54,
	            dpi,
	            dppx,
	            height: window.screen.height,
	            orientation: {
	                angle: (window.screen && window.screen.orientation && window.screen.orientation.angle) || null,
	                type: (window.screen && window.screen.orientation && window.screen.orientation.type) || null,
	            },
	            width: window.screen.width,
	        },
	        seatsioHoldToken: null,
	        timeToBank: Math.ceil(((new Date()).getTime() - initAt.getTime()) / 1000),
	        timezone: guessTimezone() || null,
	        userAgent: uaParser$1.getResult(),
	    };
	}
	function isResponseError(error) {
	    if (!error || !Object.prototype.hasOwnProperty.call(error, 'response')) {
	        return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(error.response, 'status')
	        || !Object.prototype.hasOwnProperty.call(error.response, 'data')
	        || !Object.prototype.hasOwnProperty.call(error.response.data, 'errors')
	        || !Array.isArray(error.response.data.errors)) {
	        return false;
	    }
	    for (const errorElement of error.response.data.errors) {
	        if (!Object.prototype.hasOwnProperty.call(errorElement, 'reason')) {
	            return false;
	        }
	    }
	    return true;
	}

	class Validator {
	    constructor(validatorFn) {
	        this._validatorFn = validatorFn;
	    }
	    metadata(metadata, mutateErrors) {
	        const validationErrors = this._validatorFn(metadata, mutateErrors);
	        return {
	            valid: !validationErrors.length,
	            message: validationErrors[0] || '',
	            errors: validationErrors,
	        };
	    }
	}

	/* eslint-disable sort-keys, @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-assignment */
	/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-shadow */
	// Structure of the order data response
	const struct = {
	    shop: {
	        type: 'shop',
	    },
	    tickets: {
	        type: 'ticket',
	        ticket: {
	            type: 'nested_ticket',
	            event: {
	                type: 'event',
	                payout_profile: {
	                    type: 'payout_profile',
	                },
	                refund_setting: {
	                    type: 'refund_setting',
	                },
	            },
	        },
	        products: {
	            type: 'product',
	            product: {
	                type: 'nested_product',
	                event_dates: {
	                    type: 'event_date',
	                    event: {
	                        type: 'event',
	                    },
	                    location: {
	                        type: 'location',
	                    },
	                },
	            },
	            metadata: {
	                type: 'metadata',
	                metadata: {
	                    type: 'nested_metadata',
	                },
	            },
	        },
	        metadata: {
	            type: 'metadata',
	            metadata: {
	                type: 'nested_metadata',
	            },
	        },
	    },
	    products: {
	        type: 'global_product',
	        product: {
	            type: 'nested_product',
	        },
	    },
	    payments: {
	        type: 'payment',
	        payment_method: {
	            type: 'payment_method',
	        },
	    },
	    metadata: {
	        type: 'metadata',
	        metadata: {
	            type: 'nested_metadata',
	        },
	    },
	};
	/**
	 * Returns a date object with the datetime fixed to the value
	 *
	 * Used for showing dates in the timezone of the event instead of the users
	 *
	 * See also DD-Frontend-2725
	 *
	 * @param value
	 */
	function castDateAsIs(value) {
	    if (!value || typeof value !== 'string' || Object.prototype.toString.call(value) === '[object Date]') {
	        return value;
	    }
	    const parsed = Date.parse(value);
	    if (!Number.isNaN(parsed)) {
	        const date = new Date(value);
	        const year = parseInt(value.substring(0, 4), 10);
	        const month = parseInt(value.substring(5, 7), 10);
	        const day = parseInt(value.substring(8, 10), 10);
	        const hours = parseInt(value.substring(11, 13), 10);
	        const minutes = parseInt(value.substring(14, 16), 10);
	        const seconds = parseInt(value.substring(17, 19), 10);
	        date.setFullYear(year, month - 1, day);
	        date.setHours(hours, minutes, seconds);
	        return date;
	    }
	    return value;
	}
	class OrderParser {
	    static parse(apiData) {
	        const order = OrderParser._parserApiOrder(apiData);
	        const map = {
	            global_product_map: {},
	            product_map: {},
	            event_map: {},
	            location_map: {},
	            event_date_map: {},
	            shop_map: {},
	            ticket_map: {},
	            payment_map: {},
	            payment_method_map: {},
	            payout_profile_map: {},
	            refund_setting_map: {},
	            metadata_map: {},
	        };
	        const pivots = {};
	        OrderParser._normalize(struct, apiData, map, pivots);
	        const relations = this._build(map, pivots);
	        return {
	            ...order,
	            ...map,
	            ...relations,
	        };
	    }
	    static _parserApiOrder(order) {
	        // Make sure download_link exists (for reactivity)
	        order.download_link = order.download_link ? order.download_link : null;
	        return order;
	    }
	    static _build(map, pivots) {
	        // Get the map of <guid, OrderEvent> from the map
	        const { event_map } = map;
	        // Do the nested operation for both 'tickets' and 'products'
	        for (const type of ['ticket', 'product']) {
	            const itemKey = `${type}_map`;
	            // Loop over all items in the <guid, OrderProduct | OrderTicket> maps
	            for (const item of Object.values(map[itemKey])) {
	                // Get the nested item ( 'ticket' for OrderTicket and 'product' for OrderProduct)
	                const nestedItem = item[type];
	                // The key on an OrderEvent, either 'tickets' or 'products'
	                const propName = `${type}s`;
	                // Check if the event is provided by the API, skip if not
	                if (nestedItem.event_id && event_map[nestedItem.event_id]) {
	                    // // Add the item to the event
	                    const arr = event_map[nestedItem.event_id][propName];
	                    if (arr) {
	                        arr.push(item);
	                    }
	                    else {
	                        event_map[nestedItem.event_id][propName] = [item];
	                    }
	                }
	            }
	        }
	        const events = Object.values(event_map);
	        const tickets = Object.values(map.ticket_map);
	        const global_products = Object.values(map.global_product_map);
	        const shop = Object.values(map.shop_map)[0];
	        return {
	            events,
	            tickets,
	            shop,
	            global_products,
	        };
	    }
	    static _normalize(struct, data, map, pivots) {
	        if (!struct || typeof struct !== 'object') {
	            return [];
	        }
	        const relations = {};
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	        for (const prop of Object.keys(struct)) {
	            const value = data[prop];
	            if (!value || prop === 'type') {
	                continue;
	            }
	            if (Array.isArray(value)) {
	                for (const singleValue of value) {
	                    const items = OrderParser._normalize(struct[prop], singleValue, map, pivots);
	                    if (struct[prop].type) {
	                        const item = OrderParser._constructItem(
	                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	                        struct[prop].type, singleValue, map, items);
	                        relations[prop] = relations[prop] || [];
	                        relations[prop].push(item);
	                    }
	                }
	            }
	            else {
	                const items = OrderParser._normalize(struct[prop], value, map, pivots);
	                if (struct[prop].type) {
	                    relations[prop] = OrderParser._constructItem(
	                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	                    struct[prop].type, value, map, items);
	                }
	            }
	        }
	        return relations;
	    }
	    static _constructItem(type, item, rootMap, relations) {
	        const key = `${type}_map`;
	        // Use root map or tmp object if item does not have a root map
	        const map = rootMap[key] || {};
	        // MODIFY RELATIONS
	        // Be sure to implement BaseMetadataItem
	        if (type === 'metadata' && relations) {
	            relations.item = relations.metadata;
	        }
	        // END MODIFY RELATIONS
	        if (map[item.guid]) {
	            item = map[item.guid] = {
	                ...map[item.guid],
	                ...relations,
	            };
	            return item;
	        }
	        // MODIFY INTERFACE
	        // To be compatible with MetaInput.vue
	        if (type === 'metadata') {
	            item.errors = [];
	            // The API returns empty strings for numeric inputs, which results in a NaN value
	            if (item.metadata.extra
	                && Array.isArray(item.metadata.extra)
	                && item.metadata.extra.includes('numeric')
	                && item.value === '') {
	                item.value = null;
	            }
	        }
	        if (type === 'event') {
	            item.start = castDateAsIs(item.start);
	            item.end = castDateAsIs(item.end);
	            item.tickets = [];
	            item.products = [];
	        }
	        if (type === 'event_date') {
	            item.start = castDateAsIs(item.start);
	            item.end = castDateAsIs(item.end);
	        }
	        // Additional prop for the availability of the ticket pdf
	        if (type === 'ticket') {
	            item.computed_download_ready = false;
	        }
	        // To be compatible with MetaInput.vue
	        if (type === 'nested_metadata') {
	            if (item.extra) {
	                const typedItem = item;
	                typedItem.extra = Array.isArray(item.extra) ? item.extra : item.extra.split('|');
	                if (typedItem.type === 'enum' || typedItem.type === 'enumOther' || typedItem.type === 'values') {
	                    const rule = typedItem.extra.find((rule) => rule.includes('in:'));
	                    item.options = rule ? rule.split(':').slice(1).join(':').split(',') : [];
	                }
	            }
	            else {
	                item.extra = [];
	            }
	        }
	        // BOOLEAN CASTING
	        // END MODIFY INTERFACE
	        item = map[item.guid] = {
	            ...item,
	            ...relations,
	        };
	        return item;
	    }
	}

	let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));

	let customRandom = (alphabet, size, getRandom) => {
	  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
	  let step = -~(1.6 * mask * size / alphabet.length);
	  return () => {
	    let id = '';

	    while (true) {
	      let bytes = getRandom(step);
	      let j = step;

	      while (j--) {
	        id += alphabet[bytes[j] & mask] || '';
	        if (id.length === size) return id;
	      }
	    }
	  };
	};

	let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random);

	// Note: with this alphabet and 12 chars, there is roughly a 1% chance of at least one collision after about 28 days.
	// This is assuming 100.000 ids per hour.
	// src: https://zelark.github.io/nano-id-cc/
	const sessionIdGenerator = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXY', 12);
	function parsePricing(price) {
	    const cents = typeof price === 'string' ? parseFloat(price) : price;
	    return `${(cents / 100).toFixed(2)}`;
	}
	class OrderTracking {
	    constructor() {
	        this._containers = {};
	        this._sessionId = sessionIdGenerator();
	        window.dataLayer = window.dataLayer || [];
	        this._push('consent', 'default', {
	            ad_storage: 'denied',
	            ad_user_data: 'denied',
	            ad_personalization: 'denied',
	            analytics_storage: 'denied',
	        });
	    }
	    /**
	     *  The legacy order status page has two entry points for the order.
	     *  - A return from payment page
	     *  - A linked download page (i.e.: from email)
	     *  The payment page is the only page that should trigger the conversion events.
	     *  However the download page from the email should still trigger a page view event.
	     */
	    sendLegacyEventsWithoutConversion() {
	        this._contentView();
	    }
	    sendLegacyEvents(data, order) {
	        this._interaction({
	            action: 'Complete order',
	            category: 'OrderProcess',
	            label: `Payment: ${order.status}`,
	            value: parsePricing(order.finn_price),
	        });
	        for (const event of order.events) {
	            const rawPrice = order.conversions.events[event.guid].total;
	            this._interaction({
	                action: 'Completed order for event',
	                category: 'EventConversion',
	                label: `${event.guid}|-|${event.name}`,
	                value: parsePricing(rawPrice),
	            });
	            const { location } = event;
	            const dateArr = [];
	            try {
	                if (event.start) {
	                    const { start } = event;
	                    if (typeof start === 'string') {
	                        dateArr.push(start.slice(0, 10));
	                    }
	                    else if (typeof start === 'object' && start instanceof Date) {
	                        dateArr.push(start.toISOString().slice(0, 10));
	                    }
	                    if (event.end) {
	                        const { end } = event;
	                        if (typeof end === 'string') {
	                            dateArr.push(end.slice(0, 10));
	                        }
	                        else if (typeof end === 'object' && end instanceof Date) {
	                            dateArr.push(end.toISOString().slice(0, 10));
	                        }
	                    }
	                }
	            }
	            catch (e) {
	                console.error('[sendLegacyEvents] Failed to parse dates', { e, event });
	            }
	            let coords = '';
	            if (location.latitude) {
	                coords += location.latitude;
	                if (location.longitude) {
	                    coords += `,${location.longitude}`;
	                }
	            }
	            this._interaction({
	                category: 'LocationAttend',
	                action: coords,
	                label: `${location.address || ''}`,
	                value: `${dateArr.join('_')}`,
	            });
	        }
	        try {
	            this._send({
	                event: 'event_data',
	                events: order.events.map((event) => ({
	                    guid: event.guid,
	                    name: event.name,
	                    currency: event.currency,
	                    locale: event.locale,
	                })),
	            });
	        }
	        catch (e) {
	            console.error('[sendLegacyEvents] Failed to send event date', { e });
	        }
	        this._orderData(data);
	        this._purchase(order);
	        this._contentView();
	    }
	    _interaction(event) {
	        this._send({
	            ...event,
	            event: 'interaction',
	        });
	    }
	    _contentView() {
	        this._send({
	            event: 'content-view',
	        });
	    }
	    _orderData(data) {
	        this._send({
	            event: 'order_data',
	            order: data,
	            orderConverions: data.conversions,
	            orderId: data.guid,
	            shopGuid: data.shop.guid,
	            shopName: data.shop.name,
	        });
	    }
	    _purchase(order) {
	        let eventGuidName = '|-|';
	        if (order.events.length) {
	            const lastEvent = order.events[order.events.length - 1];
	            eventGuidName = lastEvent ? `${lastEvent.guid}|-|${lastEvent.name}` : '|-|';
	        }
	        const payment = Object.values(order.payment_map)[0];
	        if (!payment) {
	            return;
	        }
	        const event = {
	            event: 'purchase',
	            ecommerce: {
	                purchase: {
	                    actionField: {
	                        id: order.shop.guid,
	                        affiliation: order.shop.name,
	                        revenue: parsePricing(order.finn_price),
	                        action: 'purchase',
	                        step: 2,
	                    },
	                    products: Object.values(order.ticket_map).map((orderTicket) => {
	                        let coupon = '';
	                        for (const product of orderTicket.products) {
	                            if (product.coupon_code) {
	                                coupon = product.coupon_code.code;
	                            }
	                        }
	                        return {
	                            coupon,
	                            id: orderTicket.ticket.guid,
	                            name: orderTicket.ticket.name,
	                            price: parsePricing(orderTicket.finn_price - orderTicket.finn_service_fee),
	                            quantity: 1,
	                        };
	                    }),
	                },
	            },
	            label: eventGuidName,
	            value: parsePricing(payment.finn_value),
	        };
	        this._send(event);
	    }
	    addGTM(code) {
	        if (this._containers[code]) {
	            return;
	        }
	        // DD-SHOP-2713 - Container de-duplication is optimised for idempotency.
	        this._containers[code] = code;
	        // Load Google Tag Manager js
	        const w = window;
	        const d = document;
	        const s = 'script';
	        const l = 'dataLayer';
	        w[l].push({
	            'gtm.start': new Date().getTime(),
	            event: 'gtm.js',
	        });
	        const f = d.getElementsByTagName(s)[0];
	        const j = d.createElement(s);
	        // const dl = l !== 'dataLayer' ? `&l=${l}` : '';
	        const dl = '';
	        j.async = true;
	        j.src = `https://www.googletagmanager.com/gtm.js?id=${code}${dl}`;
	        if (f.parentNode) {
	            f.parentNode.insertBefore(j, f);
	        }
	        else {
	            d.head.appendChild(j);
	        }
	        // Insert Google Tag Manager IFrame
	        const noscript = document.createElement('noscript');
	        const iframe = document.createElement('iframe');
	        iframe.onerror = () => {
	            delete this._containers[code];
	        };
	        iframe.src = `https://www.googletagmanager.com/ns.html?id=${code}`;
	        iframe.height = '0';
	        iframe.width = '0';
	        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	        // @ts-expect-error
	        // noinspection JSConstantReassignment
	        iframe.style = 'display:none;visibility:hidden';
	        noscript.appendChild(iframe);
	        const { body } = document;
	        body.insertBefore(noscript, body.firstChild);
	    }
	    updateConsent(settings) {
	        const { baseAds, personalisedAds } = settings;
	        setTimeout(() => {
	            const consent = {};
	            if (personalisedAds === false) {
	                consent.ad_user_data = 'denied';
	                consent.ad_personalization = 'denied';
	            }
	            if (baseAds === true) {
	                consent.ad_storage = 'granted';
	                consent.analytics_storage = 'granted';
	                if (personalisedAds === true) {
	                    consent.ad_user_data = 'granted';
	                    consent.ad_personalization = 'granted';
	                }
	            }
	            else if (baseAds === false) {
	                consent.ad_storage = 'denied';
	                consent.analytics_storage = 'denied';
	                consent.ad_user_data = 'denied';
	                consent.ad_personalization = 'denied';
	            }
	            this._push('consent', 'update', consent);
	        }, 0);
	    }
	    revokeConsent() {
	        setTimeout(() => {
	            this._push('consent', 'update', {
	                ad_storage: 'denied',
	                ad_user_data: 'denied',
	                ad_personalization: 'denied',
	                analytics_storage: 'denied',
	            });
	        }, 0);
	    }
	    _send(event) {
	        if (!window.dataLayer) {
	            window.dataLayer = [];
	        }
	        window.dataLayer.push({
	            ...event,
	            userId: this._sessionId,
	            'content-name': window.location.pathname,
	        });
	    }
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    _push(..._) {
	        // Do not change the signature of this function,
	        // nor it's use of 'arguments'.
	        // GTM does some check on the given iterable, which exclude arrays
	        // (and thus rest params, named arguments and array-ish objects)...
	        // eslint-disable-next-line prefer-rest-params
	        window.dataLayer.push(arguments);
	    }
	}

	const POLL_DELAY = 10000;
	const POLL_TIME = 10 * 60 * 1000;
	const CANCELLED_STATUSES = ['cancelled', 'refunded', 'expired', 'failed'];
	const PENDING_STATUSES = ['pending', 'verify', 'paid decide', 'refunding'];
	const MAX_TICKETS_ALLOWED_FOR_POLLING = 10;
	/**
	 *  Determine if an event's refund limit has been reached.
	 *
	 *  This is the case iff the event has a refundable status,
	 *  there is a time limit set for visitors to request a refund
	 *  (otherwise requesting a refund is not necessary: all items will be refunded)
	 *  and the time limit has expired.
	 */
	function isNoLongerRefundableEvent(event) {
	    let statusUntil = null;
	    if (event.status_until) {
	        statusUntil = event.status_until;
	    }
	    else if (event.refund_setting && event.refund_setting.status_until) {
	        statusUntil = event.refund_setting.status_until;
	    }
	    // Tickets that do not have a time limit on refund requests can not be returned through the sdk.
	    // However, it is not a 'limit that has passed', therefore the check returns false!
	    if (!statusUntil) {
	        console.warn('event has no time limit on refund requests');
	        return false;
	    }
	    // Tickets from events that have a time limit on refund requests
	    // that have expired can no longer be returned through the sdk.
	    if (new Date(statusUntil) < new Date()) {
	        console.warn('event refund status passed', statusUntil, (new Date(statusUntil) < new Date()), new Date(statusUntil));
	        return true;
	    }
	    return false;
	}
	/**
	 *  Determine if an event is refundable.
	 *
	 *  This is the case iff the event has a refundable status,
	 *  there is a time limit set for visitors to request a refund
	 *  (otherwise requesting a refund is not necessary: all items will be refunded)
	 *  and the time limit has not expired yet.
	 */
	function isRefundableEvent(event) {
	    // Tickets from events that are not refunding or moving can not be returned through the sdk.
	    if (!['refunding', 'moving'].includes(event.status)) {
	        console.warn('not refunding/moving');
	        return false;
	    }
	    let statusUntil = null;
	    if (event.status_until) {
	        statusUntil = event.status_until;
	    }
	    else if (event.refund_setting && event.refund_setting.status_until) {
	        statusUntil = event.refund_setting.status_until;
	    }
	    // Tickets that do not have a time limit on refund requests can not be returned through the sdk.
	    if (!statusUntil) {
	        console.warn('event has no time limit on refund requests');
	        return false;
	    }
	    // Tickets from events that have a time limit on refund requests
	    // that have expired can not be returned through the sdk.
	    if (new Date(statusUntil) < new Date()) {
	        console.warn('event refund status passed', statusUntil, (new Date(statusUntil) < new Date()), new Date(statusUntil));
	        return false;
	    }
	    return true;
	}
	/**
	 *  Determine if an ordered product is refundable.
	 *
	 *  This is the case iff the product is from the currently evaluated event,
	 *  has been bought before the refundable before date (not yet implemented) and is not invalidated.
	 */
	function isRefundableProduct(event, orderProduct) {
	    // Refunding only happens per event.
	    // Any items not from that event can not be refunded!
	    if (orderProduct.product.event_id !== event.guid) {
	        console.warn('invalid event_id');
	        return false;
	    }
	    // TODO Refund settings refundable before
	    // Already invalidated products can not be refunded through the sdk.
	    return !orderProduct.invalidated_since;
	}
	/**
	 *  Determine if an ordered ticket is refundable.
	 *
	 *  This is the case iff the ticket is from the currently evaluated event,
	 *  has been bought before the refundable before date (not yet implemented) and is not invalidated.
	 */
	function isRefundableTicket(event, orderTicket) {
	    // Refunding only happens per event.
	    // Any items not from that event can not be refunded!
	    if (orderTicket.ticket.event_id !== event.guid) {
	        console.warn('invalid event_id');
	        return false;
	    }
	    // TODO Refund settings refundable before
	    // Already invalidated tickets can not be refunded through the sdk.
	    return !orderTicket.invalidated_since;
	}
	/**
	 *  Determine if an item blocks the return of payment (fees).
	 *
	 *  This is the case iff any valid items are left in the order after processing the refund request.
	 */
	function orderItemBlocksPaymentReturn(returnItems, item, type) {
	    // If the current checked ticket is already invalidated, don't block payment return
	    // This also counts for tickets that are not refunded.
	    if (item.invalidated_since) {
	        return false;
	    }
	    // If the current checked ticket is being returned, don't block payment return
	    if (returnItems.find((returnItem) => returnItem.type === type && returnItem.guid === item.guid)) {
	        return false;
	    }
	    // When any items are left valid after the refund, the payment (fees) should not be returned through the sdk.
	    return true;
	}
	class OrderClient {
	    constructor(config) {
	        this.initialized = false;
	        this._urlUid = 0;
	        this.isPolling = false;
	        this._http = axios.create();
	        this._initAt = new Date();
	        this.validator = new Validator(config.validatorFn);
	        this.tracking = new OrderTracking();
	        this.logger = new helpers.exports.Logger('order', config);
	    }
	    async init(config) {
	        try {
	            if (config.loggingUrl) {
	                const output = this.logger.addOutput(helpers.exports.ServiceOutput, {
	                    baseUrl: config.loggingUrl,
	                });
	                if (config.loggingLevel !== undefined) {
	                    output.setLevel(config.loggingLevel);
	                }
	            }
	            else {
	                this.logger.log(new OrderError('order.errors.init.no_logging_url_provided', 'No loggingUrl provided for external logging'));
	            }
	            this._config = config;
	            this._http.defaults.baseURL = urlJoin(this._config.baseUrl, 'order');
	            const response = await this._http.get(`${this._config.orderGuid}?conversions=1`);
	            this._rawData = JSON.parse(JSON.stringify(response.data)); // eslint-disable-line
	            this.data = OrderParser.parse(response.data);
	            this.initialized = true;
	            if (config.gtmCode) {
	                this.tracking.addGTM(config.gtmCode);
	            }
	            // If order.download_ready is true, all ticket PDFs are available
	            if (this.data.download_ready) {
	                for (const ticket of this.data.tickets) {
	                    if (!ticket.computed_download_ready) {
	                        ticket.computed_download_ready = true;
	                    }
	                }
	            }
	            void this._startPolling(POLL_DELAY);
	        }
	        catch (e) {
	            this.logger.throw(new OrderError('order.errors.init.failed', `Failed to initialize OrderClient: ${e}`));
	        }
	    }
	    startPolling() {
	        void this._startPolling();
	    }
	    async _startPolling(initialDelay) {
	        // Do not poll if payment is cancelled
	        if (CANCELLED_STATUSES.includes(this.data.status)) {
	            return;
	        }
	        this.isPolling = true;
	        // Initial delay before polling starts
	        if (initialDelay) {
	            await new Promise((resolve) => {
	                setTimeout(() => {
	                    resolve();
	                }, initialDelay);
	            });
	        }
	        // Number of polling iterations
	        let iterations = Math.ceil(POLL_TIME / POLL_DELAY);
	        // If the order should be updated on a poll
	        let shouldPollOrder = this._shouldPollOrder();
	        // What tickets should be updated on a poll
	        let pollableTickets = this._pollableTickets();
	        while (iterations && (shouldPollOrder || pollableTickets.length)) {
	            const response = await this._http.get(this._config.orderGuid);
	            const order = OrderParser.parse(response.data);
	            if (shouldPollOrder) {
	                this._updateOrder(order);
	                shouldPollOrder = this._shouldPollOrder();
	            }
	            // Only update tickets when order status is not pending
	            if (!PENDING_STATUSES.includes(this.data.status)) {
	                const promises = pollableTickets.map((ticketGuid) => {
	                    const newTicket = order.ticket_map[ticketGuid];
	                    return this._updateTicket(newTicket);
	                });
	                await Promise.all(promises);
	                pollableTickets = this._pollableTickets();
	            }
	            // Delay before the next poll
	            await new Promise((resolve) => {
	                setTimeout(() => {
	                    resolve();
	                }, POLL_DELAY);
	            });
	            iterations--;
	        }
	        this.isPolling = false;
	    }
	    _shouldPollOrder() {
	        if (this.data.status === 'paid') {
	            return !this.data.download_link || !this.data.download_ready;
	        }
	        return !CANCELLED_STATUSES.includes(this.data.status);
	    }
	    _pollableTickets() {
	        return Object.values(this.data.ticket_map).filter((ticket) => {
	            if (ticket.invalidated_since || ticket.retrievable_after) {
	                return false;
	            }
	            return !ticket.is_complete || !ticket.download_link || !ticket.computed_download_ready;
	        }).map((ticket) => ticket.guid);
	    }
	    _updateOrder(order) {
	        this.data.status = order.status;
	        this.data.download_link = order.download_link;
	        // If order.download_ready is true, all ticket PDFs are available
	        if (!this.data.download_ready && order.download_ready) {
	            for (const ticket of this.data.tickets) {
	                if (!ticket.computed_download_ready) {
	                    ticket.computed_download_ready = true;
	                }
	            }
	        }
	        this.data.download_ready = order.download_ready;
	    }
	    async _updateTicket(newTicket) {
	        const ticket = this.data.ticket_map[newTicket.guid];
	        ticket.download_link = newTicket.download_link;
	        ticket.is_complete = newTicket.is_complete;
	        if (!ticket.is_complete || !ticket.download_link || ticket.computed_download_ready) {
	            return;
	        }
	        // Cap the maximum amount of poll requests, DDL: Frontend 271E
	        if (this.data.tickets.length > MAX_TICKETS_ALLOWED_FOR_POLLING) {
	            return;
	        }
	        try {
	            await this._http.head(`${ticket.download_link}`);
	            ticket.computed_download_ready = true;
	        }
	        catch (e) {
	            // NO-OP
	        }
	    }
	    /**
	     *  Compute the payment method info.
	     *
	     *  For now, only orders with 1 payment can be refunded through the sdk.
	     */
	    getPaymentMethodInfo() {
	        const payments = Object.values(this.data.payment_map);
	        if (!payments.length) {
	            this.logger.throw(new OrderError('order.errors.refund.without_payment', 'Cannot refund order without payment'));
	        }
	        else if (payments.length !== 1) {
	            this.logger.throw(new OrderError('order.errors.refund.with_multiple_payments', 'Cannot refund order with multiple payments'));
	        }
	        return {
	            currency: payments[0].currency,
	            guid: payments[0].payment_method_id,
	        };
	    }
	    /**
	     *  Compute a set of return items for the given event and list of tickets.
	     *
	     *  This will check if the event is refundable and
	     *  if all tickets and its children (i.e.: products) in the list are refundable.
	     */
	    getReturnItems(event, tickets, refundSetting) {
	        if (!isRefundableEvent(event)) {
	            return [];
	        }
	        const returnItems = [];
	        for (const orderTicket of tickets) {
	            if (!isRefundableTicket(event, orderTicket)) {
	                this.logger.log(new OrderRefundItemError({
	                    guid: orderTicket.ticket.guid,
	                    message: `Not refundable ${orderTicket.ticket.name}`,
	                    name: orderTicket.ticket.name,
	                    slug: 'order.errors.refund.not_refundable',
	                    type: 'ticket',
	                }));
	                continue;
	            }
	            for (const orderProduct of orderTicket.products) {
	                if (!isRefundableProduct(event, orderProduct)) {
	                    this.logger.log(new OrderRefundItemError({
	                        guid: orderProduct.product.guid,
	                        message: `Not refundable ${orderProduct.product.name}`,
	                        name: orderProduct.product.name,
	                        slug: 'order.errors.refund.not_refundable',
	                        type: 'product',
	                    }));
	                    continue;
	                }
	                returnItems.push({ guid: orderProduct.guid, type: 'product' });
	            }
	            returnItems.push({ guid: orderTicket.guid, type: 'ticket' });
	        }
	        if (refundSetting.refund_transaction_fees && this.shouldReturnPayments(returnItems)) {
	            returnItems.push(...Object.values(this.data.payment_map).map((payment) => ({
	                guid: payment.guid,
	                type: 'payment',
	            })));
	        }
	        return returnItems;
	    }
	    /**
	     *  Request a refund
	     *
	     *  This requires a set of items to be returned and a linked payout profile.
	     */
	    async requestRefund(refundSetting, items, toVoucher = false, donatePercentage = 0) {
	        const logData = {
	            donatePercentage,
	            items,
	            refundSetting,
	            toVoucher,
	        };
	        this.logger.log(new OrderRefundMessage('order.refund.about_to_request', logData));
	        const orderBuilderOptions = {
	            booker: {
	                email: this.data.email,
	                firstname: this.data.firstName,
	                lastname: this.data.lastName,
	                locale: this.data.locale,
	            },
	            items,
	            includesFees: refundSetting.refund_fees,
	            initAt: this._initAt,
	            paymentMethod: this.getPaymentMethodInfo(),
	            orderId: this.data.guid,
	            toVoucher,
	            reason: 'return by visitor',
	        };
	        if (!refundSetting.refundable_by_voucher) {
	            orderBuilderOptions.toVoucher = false;
	        }
	        else if (!refundSetting.refundable_by_payment) {
	            orderBuilderOptions.toVoucher = true;
	        }
	        if (refundSetting.refund_donate_enabled && donatePercentage) {
	            orderBuilderOptions.donatePercentage = donatePercentage;
	        }
	        try {
	            const response = await handleRefund({
	                baseUrl: this._config.baseUrl,
	                getNoCacheUrl: (url) => this._getNoCacheUrl(url),
	                httpClient: this._http,
	                shopId: this.data.shop_id,
	            }, orderBuilderOptions);
	            logData.refundAmount = response.amount;
	            logData.refundOrderId = response.order_id;
	            logData.refundRedirectUrl = response.redirectUrl;
	            this.logger.log(new OrderRefundMessage('order.refund.success', logData));
	            return response;
	        }
	        catch (e) {
	            if (OrderRefundError.is(e)) {
	                this.logger.throw(e);
	            }
	            this.logger.throw(new UnknownOrderError('order.errors.refund.unknown', 'Refund handling failed', e));
	        }
	        return Promise.reject();
	    }
	    /**
	     *  Determine if the payment should also be returned.
	     *
	     *  This is the case iff all tickets (including its products) and global products
	     *  are already invalidated or are currently being returned.
	     */
	    shouldReturnPayments(items) {
	        // TODO: Try and rework to an array of order_tickets instead of looping over the map.
	        for (const orderTicketId in this.data.ticket_map) {
	            if (!Object.prototype.hasOwnProperty.call(this.data.ticket_map, orderTicketId)) {
	                continue;
	            }
	            const orderTicket = this.data.ticket_map[orderTicketId];
	            if (orderItemBlocksPaymentReturn(items, orderTicket, 'ticket')) {
	                return false;
	            }
	            for (const orderProduct of orderTicket.products) {
	                if (orderItemBlocksPaymentReturn(items, orderProduct, 'product')) {
	                    return false;
	                }
	            }
	        }
	        for (const globalProduct of this.data.global_products) {
	            if (orderItemBlocksPaymentReturn(items, globalProduct, 'product')) {
	                return false;
	            }
	        }
	        return true;
	    }
	    async saveTicketMetadata(ticket) {
	        const metadata = Array.from(ticket.metadata);
	        for (const product of ticket.products) {
	            metadata.push(...product.metadata);
	        }
	        const response = await this._saveMetadata(metadata, ticket.guid, 'ticket');
	        if (response.order) {
	            const updatedTicket = response.order.tickets.find((t) => t.guid === ticket.guid);
	            if (updatedTicket) {
	                ticket.is_complete = !!updatedTicket.is_complete;
	                ticket.download_link = updatedTicket.download_link ? updatedTicket.download_link : null;
	            }
	        }
	        return response.personalize;
	    }
	    async _saveMetadata(metadata, guid, type) {
	        this.validateMetadata(metadata);
	        function isEmptyArray(value) {
	            return !!value && Array.isArray(value) && !value.length;
	        }
	        const data = {
	            // TODO: Invites are not supported for now, this will be implemented separately
	            //  Note invites are currently getting a small change in API (2021-06-21)
	            send_email: false,
	            values: metadata
	                .filter((m) => m.is_required || (m.value !== null && m.value !== '' && !isEmptyArray(m.value)))
	                .map((m) => ({
	                metadata_id: m.item.guid,
	                order_metadata_id: m.guid,
	                value: m.value,
	            })),
	        };
	        const personalizeResponse = (await this._http.put(`${this._config.baseUrl}/personalize/${type}/${guid}`, data)).data;
	        if (personalizeResponse.errors.length) {
	            return { personalize: personalizeResponse };
	        }
	        const orderResponse = (await this._http.get(`${this._config.orderGuid}`)).data;
	        // Check if order is complete after late personalisation
	        if (orderResponse.is_complete) {
	            this.data.is_complete = true;
	            this.data.download_link = orderResponse.download_link ? orderResponse.download_link : null;
	            this.data.download_ready = orderResponse.download_ready;
	        }
	        return {
	            order: orderResponse,
	            personalize: personalizeResponse,
	        };
	    }
	    /**
	     * Throws a FormValidationError if the metadata is considered incorrect by the validator.
	     * @param metadata
	     * @throws FormValidationError
	     */
	    validateMetadata(metadata) {
	        const errors = {};
	        for (const meta of metadata) {
	            const validation = this.validator.metadata(meta, true);
	            if (!validation.valid) {
	                errors[meta.item.name] = validation.message;
	            }
	        }
	        if (Object.keys(errors).length) {
	            this.logger.throw(new helpers.exports.FormValidationError({
	                slug: 'order.errors.metadata.validation.failed',
	                messages: errors,
	            }));
	        }
	    }
	    // eslint-disable-next-line @typescript-eslint/require-await
	    async sendInvite() {
	        // ticket: string, email: string, name: string
	        // TODO
	        throw new Error('Invites currently disabled');
	    }
	    sendLegacyEvents() {
	        if (!this.initialized) {
	            this.logger.throw(new OrderError('order.errors.tracking.conversion.initialized', 'Failed to send legacy tracking events. Cannot track anything before order client initialization.'));
	        }
	        try {
	            this.tracking.sendLegacyEvents(this._rawData, this.data);
	        }
	        catch (e) {
	            this.logger.throw(new OrderError('order.errors.tracking.conversion.failed', 'Failed to send legacy tracking events'));
	        }
	    }
	    sendLegacyEventsWithoutConversion() {
	        if (!this.initialized) {
	            this.logger.throw(new OrderError('order.errors.tracking.noconversion.initialized', 'Failed to send legacy tracking events without conversion. Cannot track anything before order client initialization.'));
	        }
	        try {
	            this.tracking.sendLegacyEventsWithoutConversion();
	        }
	        catch (e) {
	            this.logger.throw(new OrderError('order.errors.tracking.noconversion.failed', 'Failed to send legacy tracking events without conversion'));
	        }
	    }
	    _getNoCacheUrl(url) {
	        // Note: Some browsers (micro)-cache XHR requests... so we make the resource id (URI) unique!
	        // DD-Frontend-2718
	        const noCacheNonce = `?${(new Date()).getTime()}-${++this._urlUid}-${Math.floor(Math.random() * 1000000000)}`;
	        return urlJoin(url, noCacheNonce);
	    }
	}

	exports["default"] = OrderClient;
	exports.isNoLongerRefundableEvent = isNoLongerRefundableEvent;
	exports.isRefundableEvent = isRefundableEvent;
	exports.isRefundableProduct = isRefundableProduct;
	exports.isRefundableTicket = isRefundableTicket;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=order.js.map
